// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.auth-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #4A964E;
}

.auth-card {
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 400px;
  animation: dropIn 0.6s ease-out;
}

.auth-card h2 {
  text-align: center;
  margin-bottom: 30px;
  color: #333;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #555;
}

.form-group input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.3s;
}

.form-group input:focus {
  outline: none;
  border-color: #4A964E;
}

.btn {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-primary {
  background: #4A964E;
  color: white;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-primary:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.btn-secondary {
  background: #f0f0f0;
  color: #333;
  margin-top: 10px;
}

.btn-secondary:hover {
  background: #e0e0e0;
}

.error-message {
  background: #fee;
  color: #c00;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
  text-align: center;
}

.success-message {
  background: #efe;
  color: #060;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
  text-align: center;
}

.auth-switch {
  text-align: center;
  margin-top: 20px;
  color: #666;
}

.auth-switch a {
  color: #4A964E;
  text-decoration: none;
  font-weight: 500;
}

.auth-switch a:hover {
  text-decoration: underline;
}

.auth-links {
  text-align: center;
  margin-top: 15px;
}

.forgot-password-link {
  color: #666;
  text-decoration: none;
  font-size: 14px;
}

.forgot-password-link:hover {
  color: #4A964E;
  text-decoration: underline;
}

.auth-description {
  color: #666;
  margin-bottom: 20px;
  text-align: center;
  font-size: 14px;
}

.countdown-timer {
  background: #f0fdf4;
  border: 1px solid #86efac;
  color: #166534;
  padding: 10px 15px;
  border-radius: 8px;
  text-align: center;
  margin-bottom: 15px;
}

.countdown-expired {
  background: #fef2f2;
  border: 1px solid #fca5a5;
  color: #991b1b;
  padding: 10px 15px;
  border-radius: 8px;
  text-align: center;
  margin-bottom: 15px;
}

.btn-link {
  background: none;
  border: none;
  color: #4A964E;
  cursor: pointer;
  text-decoration: underline;
  font-size: inherit;
  padding: 0;
}

.btn-link:hover {
  color: #3d7d41;
}

.btn-link:disabled {
  color: #999;
  cursor: not-allowed;
}

.form-hint {
  display: block;
  color: #666;
  font-size: 12px;
  margin-top: 5px;
}

.success-message {
  background-color: #d4edda;
  color: #155724;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
  text-align: center;
}

.btn-secondary {
  background: #e5e7eb;
  color: #374151;
  width: 100%;
}

.btn-secondary:hover {
  background: #d1d5db;
}

/* Dashboard styles */
.dashboard {
  min-height: 100vh;
  background: #f5f5f5;
}

.navbar {
  background: white;
  padding: 16px 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.navbar h1 {
  color: #333;
  font-size: 24px;
}

.navbar-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.user-info {
  color: #666;
}

.btn-logout {
  padding: 8px 16px;
  background: #ff4757;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
}

.btn-logout:hover {
  background: #ff3344;
}

.dashboard-content {
  padding: 40px;
}

.welcome-card {
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.welcome-card h2 {
  color: #333;
  margin-bottom: 16px;
}

.welcome-card p {
  color: #666;
  line-height: 1.6;
}

.user-details {
  margin-top: 30px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  text-align: left;
}

.user-details h3 {
  color: #333;
  margin-bottom: 16px;
}

.user-details p {
  margin-bottom: 8px;
}

.user-details strong {
  color: #333;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  font-size: 18px;
  color: #666;
}

/* ==================== NEW LAYOUT STYLES ==================== */

.app-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Top Navigation Bar */
.top-navbar {
  background: #4A964E;
  color: white;
  padding: 0 clamp(8px, 1.1vw, 20px);
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: clamp(8px, 1vw, 20px);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.navbar-left {
  display: flex;
  align-items: center;
  gap: clamp(8px, 0.9vw, 16px);
  min-width: 0;
  flex: 0 0 auto;
}

.mobile-menu-trigger,
.mobile-navigation-layer {
  display: none;
}

.sidebar-toggle {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  font-size: 20px;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.3s;
  flex: 0 0 auto;
  white-space: nowrap;
}

.sidebar-toggle:hover {
  background: rgba(255, 255, 255, 0.2);
}

.app-title {
  font-size: clamp(16px, 1vw, 20px);
  font-weight: 600;
  max-width: clamp(150px, 16vw, 300px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.main-nav {
  display: flex;
  gap: clamp(2px, 0.3vw, 6px);
  flex: 1 1 auto;
  min-width: 0;
  justify-content: center;
  align-items: center;
}

.header-profile {
  position: relative;
  flex: 0 0 auto;
  padding: 6px 0;
}

.header-profile-trigger {
  position: relative;
  width: 42px;
  height: 42px;
  border: 2px solid rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  background: #327a37;
  color: #fff;
  display: grid;
  place-items: center;
  overflow: visible;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.04em;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;
}

.header-profile-trigger:hover,
.header-profile-trigger:focus-visible,
.header-profile.open .header-profile-trigger {
  border-color: #fff;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.25);
  transform: translateY(-1px);
  outline: none;
}

.header-profile-trigger img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.header-profile-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 10px;
  height: 10px;
  border: 2px solid #4A964E;
  border-radius: 50%;
  background: #ef4444;
}

.header-profile-menu {
  position: absolute;
  top: calc(100% - 2px);
  right: 0;
  width: 280px;
  max-height: calc(100vh - 70px);
  overflow-y: auto;
  padding: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  color: #1f2937;
  box-shadow: 0 14px 35px rgba(0, 0, 0, 0.2);
  opacity: 0;
  visibility: hidden;
  transform: translateY(-8px);
  transition: opacity 0.18s, visibility 0.18s, transform 0.18s;
  z-index: 1100;
}

.header-profile.open .header-profile-menu,
.header-profile:focus-within .header-profile-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.header-profile-summary {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 10px 12px 12px;
  border-bottom: 1px solid #edf0ed;
  margin-bottom: 5px;
  overflow: hidden;
}

.header-profile-summary strong,
.header-profile-summary span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.header-profile-summary strong { font-size: 14px; }
.header-profile-summary span { color: #6b7280; font-size: 12px; }

.header-profile-section-label {
  margin: 0;
  padding: 7px 11px 4px;
  color: #8a938c;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.header-profile-item {
  width: 100%;
  min-height: 40px;
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 9px 11px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #374151;
  text-align: left;
  text-decoration: none;
  font: inherit;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.header-profile-item:hover,
.header-profile-item:focus-visible,
.header-profile-item.active {
  outline: none;
  background: #eaf5eb;
  color: #327a37;
}

.header-profile-item.logout { color: #b42318; }
.header-profile-item.logout:hover { background: #fef2f2; color: #991b1b; }
.header-profile-divider { height: 1px; margin: 5px 3px; background: #edf0ed; }

.profile-menu-icon {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  color: #6b7280;
  transition: color 0.15s, transform 0.15s;
}

.header-profile-item:hover .profile-menu-icon,
.header-profile-item:focus-visible .profile-menu-icon,
.header-profile-item.active .profile-menu-icon {
  color: #327a37;
  transform: translateX(1px);
}

.header-profile-item.logout .profile-menu-icon,
.header-profile-item.logout:hover .profile-menu-icon {
  color: currentColor;
}

.nav-link {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  padding: 8px clamp(6px, 0.55vw, 11px);
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: clamp(3px, 0.3vw, 6px);
  transition: all 0.3s;
  font-size: clamp(12px, 0.72vw, 14px);
  line-height: 1.15;
  white-space: nowrap;
}

.nav-link:hover {
  background: rgba(255, 255, 255, 0.15);
  color: white;
}

.nav-link.active {
  background: rgba(255, 255, 255, 0.25);
  color: white;
}

.nav-icon {
  font-size: 16px;
  flex: 0 0 auto;
}

.nav-label {
  font-weight: 700;
  white-space: nowrap;
}

/* Nav Dropdown */
.nav-dropdown-container {
  position: relative;
  flex: 0 0 auto;
}

.dropdown-arrow {
  font-size: 10px;
  margin-left: 1px;
  transition: transform 0.2s;
  flex: 0 0 auto;
}

.nav-dropdown-container:hover .dropdown-arrow {
  transform: rotate(180deg);
}

.nav-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  padding: 8px 0;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.2s ease;
  z-index: 1000;
}

.nav-dropdown-container:hover .nav-dropdown {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.nav-dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  color: #333;
  text-decoration: none;
  font-size: 14px;
  transition: background 0.2s;
}

.nav-dropdown-item:hover {
  background: #f5f5f5;
}

.nav-dropdown-item .nav-icon {
  font-size: 16px;
}

.nav-dropdown-group {
  position: relative;
}

.nav-dropdown-nested-arrow {
  margin-left: auto;
  color: #6b7280;
  font-size: 20px;
  line-height: 1;
}

.nav-dropdown-submenu {
  position: absolute;
  top: -8px;
  left: 100%;
  min-width: 220px;
  padding: 8px 0;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  opacity: 0;
  visibility: hidden;
  transform: translateX(-6px);
  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s;
}

.nav-dropdown-group:hover > .nav-dropdown-submenu,
.nav-dropdown-group:focus-within > .nav-dropdown-submenu {
  opacity: 1;
  visibility: visible;
  transform: translateX(0);
}

/* App Body */
.app-body {
  display: flex;
  margin-top: 60px;
  min-height: calc(100vh - 60px);
}

/* Left Sidebar */
.sidebar {
  width: 260px;
  background: white;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 60px;
  bottom: 0;
  transition: transform 0.3s, width 0.3s;
  z-index: 100;
  overflow-y: auto;
}

.sidebar.closed {
  transform: translateX(-260px);
}

.user-profile-section {
  padding: 24px 20px;
  display: flex;
  align-items: center;
  gap: 14px;
  border-bottom: 1px solid #eee;
  background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);
}

.user-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #4A964E;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s;
  overflow: hidden;
}

.user-avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-avatar-initial {
  font-size: 20px;
  font-weight: 600;
}

.user-avatar:hover {
  transform: scale(1.05);
}

.user-info-sidebar {
  display: flex;
  flex-direction: column;
}

.user-name {
  font-weight: 600;
  color: #333;
  font-size: 15px;
}

.user-email {
  font-size: 12px;
  color: #888;
  margin-top: 2px;
}

.profile-menu {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s;
  background: #f8f9fa;
}

.profile-menu.open {
  max-height: 200px;
}

.profile-menu-item {
  padding: 12px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: background 0.2s;
  color: #555;
  font-size: 14px;
  text-decoration: none;
}

.profile-menu-item:hover {
  background: #eee;
  color: #333;
}

/* Sidebar Navigation Links - Always Visible */
.sidebar-nav-links {
  padding: 8px 12px;
  border-bottom: 1px solid #eee;
}

.sidebar-nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  color: #555;
  font-size: 14px;
  text-decoration: none;
  background: none;
  border: none;
  width: 100%;
  text-align: left;
}

.sidebar-nav-item:hover {
  background: #f0f0f0;
  color: #4A964E;
}

.sidebar-nav-item.active {
  background: #e8f5e9;
  color: #4A964E;
  font-weight: 500;
}

.sidebar-nav-item.notifications-trigger {
  position: relative;
}

.sidebar-nav-item .notification-badge {
  margin-left: auto;
}

/* Notifications styles */
.notifications-trigger {
  position: relative;
}

.notification-badge {
  background: #ef4444;
  color: white;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 10px;
  min-width: 18px;
  text-align: center;
  margin-left: auto;
}

.notifications-dropdown {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  margin: 8px 12px;
  max-height: 600px;
  min-width: 380px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.notifications-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
}

.notifications-header h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.mark-all-read-btn {
  background: none;
  border: none;
  color: #2563eb;
  font-size: 12px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background 0.2s;
}

.mark-all-read-btn:hover {
  background: #eff6ff;
}

.notifications-list {
  overflow-y: auto;
  max-height: 540px;
}

.notification-item {
  display: flex;
  align-items: flex-start;
  padding: 12px 16px;
  border-bottom: 1px solid #f3f4f6;
  cursor: pointer;
  transition: background 0.2s;
  position: relative;
}

.notification-item:hover {
  background: #f9fafb;
}

.notification-item.unread {
  background: #eff6ff;
}

.notification-item.unread:hover {
  background: #dbeafe;
}

.notification-content {
  flex: 1 1;
  min-width: 0;
}

.notification-title {
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.notification-message {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 4px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: pre-line;
}

.notification-time {
  font-size: 11px;
  color: #9ca3af;
}

.unread-indicator {
  width: 8px;
  height: 8px;
  background: #2563eb;
  border-radius: 50%;
  margin-left: 8px;
  margin-top: 4px;
  flex-shrink: 0;
}

.notification-delete-btn {
  background: none;
  border: none;
  color: #f87171;
  cursor: pointer;
  padding: 6px;
  border-radius: 8px;
  transition: color 0.2s, background-color 0.2s;
  margin-left: 8px;
  flex-shrink: 0;
}

.notification-delete-btn:hover {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.notification-delete-btn:focus-visible {
  outline: 2px solid #ef4444;
  outline-offset: 2px;
}

.notification-delete-icon {
  display: block;
  width: 16px;
  height: 16px;
}

/* Notifications Modal */
.notifications-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.notifications-modal {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  width: 100%;
  max-width: 600px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.notifications-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
}

.notifications-modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.notifications-modal-close {
  background: none;
  border: none;
  font-size: 20px;
  color: #6b7280;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s;
}

.notifications-modal-close:hover {
  background: #f3f4f6;
  color: #374151;
}

.notifications-modal-actions {
  padding: 12px 24px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
}

.notifications-modal-actions:empty {
  display: none;
}

.notifications-modal-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 8px 0;
}

.notifications-modal-list .notification-item {
  margin: 0 12px 8px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.notifications-modal-list .notification-item:last-child {
  margin-bottom: 12px;
}

/* Responsive styles for notifications modal */
@media (max-width: 768px) {
  .notifications-modal-overlay {
    padding: 10px;
  }

  .notifications-modal {
    max-height: 90vh;
  }

  .notifications-modal-header {
    padding: 16px 20px;
  }

  .notifications-modal-header h3 {
    font-size: 16px;
  }

  .notifications-modal-actions {
    padding: 10px 20px;
  }

  .notifications-modal-list .notification-item {
    margin: 0 8px 8px;
  }
}

.no-notifications {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #9ca3af;
}

.no-notifications-icon {
  font-size: 32px;
  margin-bottom: 8px;
}

.no-notifications p {
  margin: 0;
  font-size: 14px;
}

/* Notifications page */
.notifications-page { max-width: 960px; margin: 0 auto; }
.notifications-page-header { display: flex; align-items: center; justify-content: space-between; gap: 20px; }
.notifications-page-actions { display: flex; align-items: center; justify-content: flex-end; flex-wrap: wrap; gap: 10px; }
.notifications-page-action {
  padding: 10px 15px;
  border: 1px solid #4A964E;
  border-radius: 8px;
  background: #fff;
  color: #327a37;
  font-weight: 600;
  cursor: pointer;
}
.notifications-page-action:hover { background: #eaf5eb; }
.notifications-page-action:disabled { opacity: 0.55; cursor: not-allowed; }
.notifications-page-action--danger {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border-color: #f87171;
  color: #dc2626;
}
.notifications-page-action--danger:hover:not(:disabled) { background: #fef2f2; }
.notifications-page-action--danger .notification-delete-icon { width: 16px; height: 16px; }
.notifications-page-list { display: grid; gap: 10px; }
.notifications-page-item {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 18px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
.notifications-page-item.unread { border-left: 4px solid #4A964E; background: #f4fbf4; }
.notifications-page-item.clickable { cursor: pointer; }
.notifications-page-item.clickable:hover { border-color: #9aca9d; box-shadow: 0 4px 14px rgba(74, 150, 78, 0.12); }
.notifications-page-icon {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: #eaf5eb;
  color: #327a37;
  font-weight: 700;
}
.notifications-page-item .notification-content h3 { margin: 0 0 5px; font-size: 15px; color: #1f2937; }
.notifications-page-item .notification-content p { margin: 0 0 8px; color: #4b5563; font-size: 14px; white-space: pre-line; }
.notifications-page-item .notification-content time { color: #9ca3af; font-size: 12px; }
.notifications-page-state {
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 1px dashed #d1d5db;
  border-radius: 12px;
  background: #fff;
  color: #6b7280;
}
.notifications-page-state span { font-size: 34px; }

.menu-icon {
  font-size: 16px;
}

.sidebar-divider {
  height: 1px;
  background: #eee;
  margin: 10px 0;
}

.sidebar-section {
  padding: 16px 20px;
}

.sidebar-section-title {
  font-size: 11px;
  text-transform: uppercase;
  color: #999;
  font-weight: 600;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
}

.sidebar-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 6px;
  color: #555;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.2s;
  margin-bottom: 4px;
}

.sidebar-link:hover {
  background: #f0f0f0;
  color: #4A964E;
}

.sidebar-info {
  font-size: 13px;
  color: #666;
}

.sidebar-info p {
  margin-bottom: 8px;
}

.sidebar-footer {
  margin-top: auto;
  padding: 20px;
  border-top: 1px solid #eee;
}

.btn-logout-sidebar {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px;
  background: #ff4757;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s;
}

.btn-logout-sidebar:hover {
  background: #ff3344;
}

/* Main Content */
.main-content {
  flex: 1 1;
  margin-left: 260px;
  padding: 24px;
  background: #f5f5f5;
  transition: margin-left 0.3s;
}

.main-content.expanded {
  margin-left: 0;
}

/* Page Styles */
.page-container {
  max-width: 1200px;
  margin: 0 auto;
}

.page-header {
  margin-bottom: 24px;
}

.page-header h2 {
  font-size: 28px;
  color: #333;
  margin-bottom: 8px;
}

.page-header p {
  color: #666;
  font-size: 15px;
}

.page-content {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* Blank Page Card */
.blank-page-card {
  text-align: center;
  padding: 60px 20px;
}

.blank-icon {
  font-size: 64px;
  margin-bottom: 20px;
  display: block;
}

.blank-page-card h3 {
  font-size: 24px;
  color: #333;
  margin-bottom: 12px;
}

.blank-page-card p {
  color: #666;
  font-size: 16px;
  margin-bottom: 8px;
}

.coming-soon {
  display: inline-block;
  margin-top: 20px;
  padding: 8px 20px;
  background: #4A964E;
  color: white;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
}

/* Tiles Grid */
.module-page-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.module-page-title > svg {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  color: #2563eb;
  stroke-width: 1.8;
}

.module-tile .module-tile-icon {
  display: grid;
  width: 72px;
  height: 72px;
  margin-bottom: 20px;
  border-radius: 20px;
  background: #eff6ff;
  color: #2563eb;
  place-items: center;
  transition: transform 0.2s ease;
}

.module-tile-icon > svg {
  width: 36px;
  height: 36px;
}

.module-tile:hover .module-tile-icon {
  transform: scale(1.06);
}

.sales-module-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.sales-module-title svg {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  color: #2563eb;
  stroke-width: 1.8;
}

.tiles-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
}

.tile-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 40px 24px;
  background: white;
  border-radius: 12px;
  border: 1px solid #e9ecef;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  text-decoration: none;
  color: inherit;
  transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;
}

.tile-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  border-color: #4A964E;
}

.tile-icon {
  font-size: 56px;
  margin-bottom: 16px;
}

.tile-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
}

.tile-description {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.5;
}

/* Stats Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-top: 30px;
}

.stat-card {
  background: #f8f9fa;
  padding: 24px;
  border-radius: 10px;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stat-icon {
  font-size: 32px;
  margin-bottom: 12px;
  display: block;
}

.stat-card h4 {
  color: #333;
  margin-bottom: 8px;
}

.stat-card p {
  color: #888;
  font-size: 13px;
}

/* Profile Page */
.profile-card {
  display: flex;
  align-items: flex-start;
  gap: 30px;
}

.profile-avatar-large {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #4A964E;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  font-weight: 600;
  flex-shrink: 0;
  overflow: hidden;
}

.profile-avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.profile-avatar-initial {
  font-size: 40px;
  font-weight: 600;
}

.profile-details h3 {
  font-size: 24px;
  color: #333;
  margin-bottom: 4px;
}

.profile-email {
  color: #666;
  font-size: 15px;
  margin-bottom: 20px;
}

/* .profile-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
} */

.profile-info-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
}

.profile-info-item label {
  display: block;
  font-size: 12px;
  color: #888;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
}

.status-badge.active {
  background: #d4edda;
  color: #155724;
}

.status-badge.inactive {
  background: #f8d7da;
  color: #721c24;
}

/* Profile Page - Edit Form */
.profile-input {
  padding: 8px 12px;
  font-size: 14px;
  border: 2px solid #e9ecef;
  border-radius: 6px;
  width: 100%;
  max-width: 200px;
  transition: border-color 0.2s;
}

.profile-input:focus {
  outline: none;
  border-color: #4A964E;
}

.profile-actions {
  margin-top: 24px;
  display: flex;
  gap: 12px;
}

.btn-primary {
  padding: 10px 20px;
  background: #4A964E;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.2s;
}

.btn-primary:hover:not(:disabled) {
  opacity: 0.9;
  transform: translateY(-1px);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-secondary {
  padding: 10px 20px;
  background: #f8f9fa;
  color: #333;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-secondary:hover:not(:disabled) {
  background: #e9ecef;
}

.btn-secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.message {
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
}

.message.success {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.message.error {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.message.info {
  background: #cce5ff;
  color: #004085;
  border: 1px solid #b8daff;
}

/* Settings Page */
.settings-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 32px;
  max-width: 600px;
}

.settings-form {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.form-section {
  border-bottom: 1px solid #eee;
  padding-bottom: 24px;
}

.form-section:last-of-type {
  border-bottom: none;
  padding-bottom: 0;
}

.form-section-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 4px 0;
}

.form-section-desc {
  font-size: 13px;
  color: #888;
  margin: 0 0 20px 0;
}

.form-group {
  margin-bottom: 16px;
}

.form-group:last-child {
  margin-bottom: 0;
}

.form-group label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #555;
  margin-bottom: 6px;
}

.form-input {
  width: 100%;
  padding: 12px 14px;
  font-size: 15px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  background: white;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: #4A964E;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15);
}

.form-input.disabled {
  background: #f5f5f5;
  color: #888;
  cursor: not-allowed;
}

.form-select {
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 12px center;
  background-repeat: no-repeat;
  background-size: 16px;
  padding-right: 40px;
}

.status-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.status-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.status-label {
  font-size: 14px;
  color: #666;
  min-width: 120px;
}

.form-actions {
  display: flex;
  gap: 12px;
  padding-top: 8px;
}

/* Avatar Section */
.avatar-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.avatar-preview {
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid #e9ecef;
  transition: border-color 0.2s;
}

.avatar-preview:hover {
  border-color: #4A964E;
}

.avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #4A964E 0%, #3d7a40 100%);
  color: white;
}

.avatar-initial {
  font-size: 48px;
  font-weight: 600;
}

.avatar-loading {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  font-size: 24px;
}

.avatar-actions {
  display: flex;
  gap: 12px;
}

.avatar-actions button {
  flex: 1 1;
  min-width: 0;
  transition: background 0.2s, transform 0.15s ease;
}

.avatar-actions button:hover:not(:disabled) {
  transform: scale(1.05);
}

.avatar-message {
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  text-align: center;
}

.avatar-message.success {
  background: #d4edda;
  color: #155724;
}

.avatar-message.error {
  background: #f8d7da;
  color: #721c24;
}

.btn-danger {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  background: #dc3545;
  color: white;
}

.btn-danger:hover:not(:disabled) {
  background: #c82333;
}

.btn-danger:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Colleagues Page */

/* Toolbar: search + view toggle side by side */
.colleagues-toolbar {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 24px;
}

.colleagues-search {
  flex: 1 1;
  margin: 0 !important;
}

/* Segmented view toggle */
.view-toggle {
  display: flex;
  background: #eef2f7;
  border: 1px solid #dbe3ed;
  border-radius: 8px;
  padding: 3px;
  flex-shrink: 0;
}

.view-toggle-btn {
  padding: 7px 16px;
  border: none;
  background: transparent;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #6c757d;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, box-shadow 0.15s;
  white-space: nowrap;
  font-family: inherit;
}

.view-toggle-btn.active {
  background: white;
  color: #25643a;
  box-shadow: 0 1px 5px rgba(15, 23, 42, 0.14);
}

.view-toggle-btn:not(.active):hover {
  color: #343a40;
}

/* Position label in card view (below name, above email) */
.colleague-position-compact {
  min-height: 16px;
  font-size: 12px;
  font-weight: 600;
  color: #3f7d46;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Search Bar */
.search-container {
  position: relative;
  margin-bottom: 24px;
}

.search-container.employee-search {
  margin-bottom: 16px;
}

.search-input {
  width: 100%;
  padding: 14px 50px 14px 20px;
  font-size: 15px;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  background: white;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.search-input:focus {
  outline: none;
  border-color: #4A964E;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15);
}

.search-input::placeholder {
  color: #adb5bd;
}

.search-clear {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: #e9ecef;
  border: none;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 12px;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.search-clear:hover {
  background: #dee2e6;
}

.no-results {
  text-align: center;
  padding: 40px;
  color: #666;
  font-size: 16px;
}

.colleagues-grid {
  display: flex;
  flex-direction: column;
  gap: 22px;
  min-width: 0;
}

.department-section {
  background: white;
  border-radius: 12px;
  border: 1px solid #e3e9ef;
  box-shadow: 0 8px 26px rgba(15, 23, 42, 0.06);
  overflow: hidden;
}

.department-section-header {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  padding: 17px 22px;
  background: #ffffff;
  color: #1f2937;
  border-bottom: 1px solid #e7edf3;
  cursor: pointer;
  transition: background 0.2s;
}

.department-section-header:hover {
  background: #f8fbf8;
}

.department-section-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.department-badge {
  flex: 0 0 auto;
  background: #edf7ee;
  color: #25643a;
  padding: 5px 12px;
  border: 1px solid #cfe8d1;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
}

.expand-arrow {
  flex: 0 0 auto;
  font-size: 12px;
  color: #64748b;
  transition: transform 0.3s ease;
}

.expand-arrow.open {
  transform: rotate(180deg);
}

.colleagues-row {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  align-items: stretch;
  justify-items: stretch;
  gap: 16px;
  width: 100%;
  min-width: 0;
  padding: 20px;
}

.colleague-card-compact {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-width: 0;
  width: 100%;
  min-height: 236px;
  height: 100%;
  padding: 20px 16px 16px;
  background: #fbfcfd;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;
}

.colleague-card-compact:hover {
  border-color: #b7d9bd;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.1);
  transform: translateY(-2px);
}

.colleague-avatar-compact {
  flex: 0 0 64px;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #4A964E;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 14px;
  overflow: hidden;
  box-shadow: 0 0 0 4px #edf7ee;
}

.colleague-avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.colleague-avatar-initial {
  font-size: 24px;
  font-weight: 600;
}

.colleague-details-compact {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  min-width: 0;
}

.colleague-details-compact h4 {
  margin: 0 0 5px 0;
  min-height: 36px;
  color: #172033;
  font-size: 15px;
  font-weight: 750;
  line-height: 1.2;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow-wrap: anywhere;
}

.colleague-details-compact h4,
.colleague-position-compact,
.colleague-email-compact,
.colleague-phone-compact {
  min-width: 0;
}

.colleague-details-compact h4:only-child {
  white-space: nowrap;
}

.colleague-card-divider {
  border: none;
  border-top: 1px solid #e5ebf1;
  margin: 12px 0 10px 0;
}

.colleague-contact-icon {
  width: 13px;
  height: 13px;
  flex-shrink: 0;
  color: #888;
  margin-right: 5px;
  vertical-align: middle;
  position: relative;
  top: -1px;
}

.colleague-email-compact {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 18px;
  margin: 0 0 6px 0;
  color: #526070;
  font-size: 12px;
  line-height: 1.35;
}

.colleague-email-compact span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.colleague-job-title-compact {
  font-size: 11px;
  color: #666;
  margin: 0 0 4px 0;
  font-weight: 500;
}

.colleague-phone-compact {
  min-height: 18px;
  margin: 0 0 12px 0;
  overflow: hidden;
  color: #64748b;
  font-size: 12px;
  line-height: 1.35;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.status-badge-small {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  margin-top: auto;
  min-height: 24px;
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
}

.status-badge-small.active {
  background: #d4edda;
  color: #155724;
}

.status-badge-small.inactive {
  background: #f8d7da;
  color: #721c24;
}

/* ── List view ── */
.colleagues-list-view {
  overflow-x: auto;
  padding: 0;
}

.colleagues-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.colleagues-table thead tr {
  background: #f8f9fa;
  border-bottom: 2px solid #e9ecef;
}

.colleagues-table th {
  padding: 10px 14px;
  text-align: left;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  white-space: nowrap;
}

.colleagues-table th:first-child {
  width: 48px;
  padding-left: 16px;
}

.colleagues-table tbody tr {
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.1s;
}

.colleagues-table tbody tr:last-child {
  border-bottom: none;
}

.colleagues-table tbody tr:hover {
  background: #f8fdf8;
}

.colleagues-table td {
  padding: 10px 14px;
  vertical-align: middle;
  color: #333;
}

.colleagues-table td:first-child {
  padding-left: 16px;
}

/* Small avatar circle for list rows */
.col-list-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #4A964E;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  overflow: hidden;
  flex-shrink: 0;
}

.col-list-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.col-list-name {
  font-weight: 600;
  color: #1a1a1a;
  white-space: nowrap;
}

.col-list-position {
  color: #4A964E;
  font-weight: 500;
}

.col-list-email {
  color: #555;
}

.col-list-phone {
  color: #777;
  white-space: nowrap;
}
.colleagues-list {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.colleague-card {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 10px;
  border: 1px solid #e9ecef;
  transition: box-shadow 0.2s, transform 0.2s;
}

.colleague-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.colleague-card .profile-avatar-large {
  width: 80px;
  height: 80px;
  font-size: 32px;
}

.colleague-card .profile-details h3 {
  font-size: 20px;
  margin-bottom: 2px;
}

.colleague-card .profile-email {
  margin-bottom: 16px;
}

.colleague-card .profile-info-grid {
  gap: 16px;
}

/* Responsive */
@media (max-width: 1440px) {
  .app-title {
    max-width: 190px;
  }

  .nav-link {
    max-width: 112px;
    padding-left: 8px;
    padding-right: 8px;
  }

}

@media (max-width: 1220px) {
  .nav-label {
    display: none;
  }
  
  .nav-link {
    width: 40px;
    max-width: 40px;
    padding: 8px 0;
    justify-content: center;
  }

  .dropdown-arrow {
    display: none;
  }

  .nav-dropdown {
    left: 50%;
    transform: translate(-50%, -10px);
  }

  .nav-dropdown-container:hover .nav-dropdown {
    transform: translate(-50%, 0);
  }

}

@media (max-width: 900px) {
  .app-title {
    max-width: 160px;
  }

}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
    width: 100%;
    min-width: 0;
    padding: 16px;
    overflow-x: hidden;
  }
  
  .main-nav {
    display: none;
  }

  .top-navbar {
    justify-content: space-between;
    gap: 8px;
  }

  .navbar-left {
    flex: 1 1 auto;
    overflow: hidden;
  }

  .app-title {
    max-width: calc(100vw - 120px);
    font-size: 16px;
  }

  .mobile-menu-trigger {
    width: 40px;
    height: 40px;
    flex: 0 0 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5px;
    padding: 0;
    border: 0;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.12);
    color: #fff;
    cursor: pointer;
  }

  .mobile-menu-trigger:hover,
  .mobile-menu-trigger:focus-visible {
    background: rgba(255, 255, 255, 0.22);
    outline: 2px solid rgba(255, 255, 255, 0.9);
    outline-offset: 1px;
  }

  .mobile-menu-trigger span {
    width: 20px;
    height: 2px;
    border-radius: 2px;
    background: currentColor;
  }

  .mobile-navigation-layer {
    position: fixed;
    inset: 0;
    z-index: 1200;
    display: block;
    visibility: hidden;
    pointer-events: none;
    transition: visibility 0.25s;
  }

  .mobile-navigation-layer.open {
    visibility: visible;
    pointer-events: auto;
  }

  .mobile-navigation-backdrop {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    padding: 0;
    border: 0;
    background: rgba(15, 23, 42, 0.48);
    opacity: 0;
    cursor: default;
    transition: opacity 0.25s;
  }

  .mobile-navigation-layer.open .mobile-navigation-backdrop { opacity: 1; }

  .mobile-navigation-drawer {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: min(86vw, 340px);
    display: flex;
    flex-direction: column;
    background: #fff;
    color: #1f2937;
    box-shadow: 8px 0 30px rgba(0, 0, 0, 0.22);
    transform: translateX(-102%);
    transition: transform 0.25s ease;
  }

  .mobile-navigation-layer.open .mobile-navigation-drawer { transform: translateX(0); }

  .mobile-navigation-header {
    min-height: 72px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 14px 12px 18px;
    border-bottom: 1px solid #e5e7eb;
    background: #f7faf7;
  }

  .mobile-navigation-header > div {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .mobile-navigation-header strong { color: #285f2c; font-size: 18px; }
  .mobile-navigation-header div span { color: #6b7280; font-size: 12px; }

  .mobile-navigation-close {
    width: 40px;
    height: 40px;
    flex: 0 0 40px;
    border: 0;
    border-radius: 8px;
    background: transparent;
    color: #4b5563;
    font-size: 30px;
    line-height: 1;
    cursor: pointer;
  }

  .mobile-navigation-close:hover,
  .mobile-navigation-close:focus-visible { background: #eaf5eb; color: #285f2c; outline: none; }

  .mobile-navigation-list {
    flex: 1 1;
    overflow-y: auto;
    overscroll-behavior: contain;
    padding: 12px;
    -webkit-overflow-scrolling: touch;
  }

  .mobile-navigation-group { margin-bottom: 3px; }
  .mobile-navigation-row { display: flex; align-items: stretch; gap: 3px; }

  .mobile-navigation-link {
    min-width: 0;
    flex: 1 1;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 11px 12px;
    border-radius: 9px;
    color: #374151;
    text-decoration: none;
    font-size: 15px;
    font-weight: 700;
  }

  .mobile-navigation-link:hover,
  .mobile-navigation-link:focus-visible,
  .mobile-navigation-link.active { background: #eaf5eb; color: #327a37; outline: none; }
  .mobile-navigation-icon { width: 22px; text-align: center; font-size: 18px; }

  .mobile-navigation-expand {
    width: 42px;
    flex: 0 0 42px;
    border: 0;
    border-radius: 9px;
    background: transparent;
    color: #6b7280;
    cursor: pointer;
  }

  .mobile-navigation-expand:hover,
  .mobile-navigation-expand:focus-visible { background: #edf3ed; color: #327a37; outline: none; }
  .mobile-navigation-expand span { display: inline-block; font-size: 20px; transition: transform 0.2s; }
  .mobile-navigation-expand[aria-expanded="true"] span { transform: rotate(180deg); }

  .mobile-navigation-submenu {
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows 0.2s;
  }

  .mobile-navigation-submenu.open { grid-template-rows: 1fr; }
  .mobile-navigation-submenu > * { overflow: hidden; }

  .mobile-navigation-sublink {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 38px;
    margin: 2px 4px 2px 34px;
    padding: 8px 10px;
    border-left: 2px solid #dbe7dc;
    color: #58605a;
    text-decoration: none;
    font-size: 13px;
  }

  .mobile-navigation-sublink:hover,
  .mobile-navigation-sublink:focus-visible,
  .mobile-navigation-sublink.active { border-color: #4A964E; color: #327a37; background: #f4f9f4; outline: none; }

  .mobile-navigation-sublink--nested {
    margin-left: 52px;
    border-left-color: #c9d9ca;
    font-size: 12px;
  }

  .header-profile-menu { position: fixed; top: 56px; right: 8px; width: min(280px, calc(100vw - 16px)); }
  .notifications-page-header { align-items: flex-start; flex-direction: column; }

  .colleagues-toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .view-toggle {
    width: 100%;
  }

  .view-toggle-btn {
    flex: 1 1;
  }
}

@media (max-width: 480px) {
  .top-navbar { padding: 0 8px; }
  .app-title { max-width: calc(100vw - 116px); font-size: 14px; }
  .main-content { padding: 12px; }
  .colleagues-row {
    grid-template-columns: 1fr;
    padding: 14px;
  }

  .department-section-header {
    align-items: flex-start;
    flex-wrap: wrap;
    padding: 15px 16px;
  }

  .department-section-header h3 {
    flex-basis: 100%;
  }

  .department-badge {
    font-size: 12px;
  }
}

/* ==================== COLLEAGUES PANEL STYLES ==================== */

.sidebar-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sidebar-section-header.clickable {
  cursor: pointer;
  padding: 8px;
  margin: -8px;
  border-radius: 6px;
  transition: background 0.2s;
}

.sidebar-section-header.clickable:hover {
  background: #f0f0f0;
}

.sidebar-section-header .sidebar-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 0;
}

.expand-icon {
  font-size: 10px;
  color: #888;
  transition: transform 0.3s;
}

.expand-icon.open {
  transform: rotate(180deg);
}

.expand-icon.small {
  font-size: 8px;
}

.colleagues-panel {
  margin-top: 12px;
  max-height: 400px;
  overflow-y: auto;
}

.loading-text,
.no-colleagues {
  font-size: 12px;
  color: #888;
  text-align: center;
  padding: 10px;
}

.department-group {
  margin-bottom: 8px;
  border-radius: 6px;
  background: #f8f9fa;
  overflow: hidden;
}

.department-header {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  cursor: pointer;
  transition: background 0.2s;
  gap: 6px;
}

.department-header:hover {
  background: #eee;
}

.department-name {
  font-size: 13px;
  font-weight: 600;
  color: #444;
  flex: 1 1;
  text-transform: capitalize;
}

.department-count {
  font-size: 11px;
  color: #888;
  background: #ddd;
  padding: 2px 6px;
  border-radius: 10px;
}

.department-colleagues {
  border-top: 1px solid #eee;
  background: white;
}

.colleague-item {
  display: flex;
  align-items: flex-start;
  padding: 10px 12px;
  gap: 10px;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.2s;
}

.colleague-item:last-child {
  border-bottom: none;
}

.colleague-item:hover {
  background: #f8f9fa;
}

.colleague-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #4A964E;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
}

.colleague-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.colleague-name {
  font-size: 13px;
  font-weight: 500;
  color: #333;
}

.colleague-email {
  font-size: 11px;
  color: #888;
  word-break: break-all;
}

.colleague-phone {
  font-size: 11px;
  color: #4A964E;
  margin-top: 2px;
}

/* ===================== */
/* Admin Panel Styles    */
/* ===================== */

.sidebar-section.admin-section {
  border-top: 1px solid rgba(102, 126, 234, 0.3);
  border-bottom: 1px solid rgba(102, 126, 234, 0.3);
  background: rgba(102, 126, 234, 0.05);
  margin: 10px -15px;
  padding: 10px 15px;
}

.sidebar-link.admin-link {
  color: #4A964E;
  font-weight: 600;
}

.sidebar-link.admin-link:hover {
  background: rgba(102, 126, 234, 0.15);
}

.admin-section {
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.admin-section h3 {
  margin-bottom: 15px;
  color: #333;
  font-size: 18px;
  border-bottom: 2px solid #4A964E;
  padding-bottom: 10px;
}

.roles-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.role-badge-info {
  display: flex;
  flex-direction: column;
  padding: 10px 15px;
  background: #4A964E;
  color: white;
  border-radius: 8px;
  min-width: 150px;
}

.role-badge-info .role-name {
  font-weight: 600;
  font-size: 14px;
  text-transform: capitalize;
}

.role-badge-info .role-description {
  font-size: 12px;
  opacity: 0.9;
  margin-top: 4px;
}

.admin-users-table {
  overflow-x: auto;
}

.admin-users-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.admin-users-table th,
.admin-users-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.admin-users-table th {
  background: #f5f5f5;
  font-weight: 600;
  color: #333;
}

.admin-users-table tr:hover {
  background: #f9f9f9;
}

.current-user-row {
  background: rgba(102, 126, 234, 0.05) !important;
}

.you-badge {
  display: inline-block;
  background: #4A964E;
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 4px;
  margin-left: 8px;
  vertical-align: middle;
}

.status-badge-small {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.status-badge-small.active {
  background: #d4edda;
  color: #155724;
}

.status-badge-small.inactive {
  background: #f8d7da;
  color: #721c24;
}

.user-roles {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.role-tag {
  display: inline-block;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  text-transform: capitalize;
  background: #e0e0e0;
  color: #333;
}

.role-tag.admin {
  background: #dc3545;
  color: white;
}

.role-tag.manager {
  background: #fd7e14;
  color: white;
}

.role-tag.employee {
  background: #28a745;
  color: white;
}

.role-tag.viewer {
  background: #17a2b8;
  color: white;
}

.role-tag.client {
  background: #334155;
  color: white;
}

.no-roles {
  color: #999;
  font-style: italic;
  font-size: 12px;
}

.btn-edit-roles {
  padding: 6px 12px;
  background: #4A964E;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: background 0.2s;
}

.btn-edit-roles:hover {
  background: #5a6fd6;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 12px;
  padding: 30px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.modal-content h3 {
  margin-bottom: 5px;
  color: #333;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e0e0e0;
}

.modal-header h3 {
  margin: 0;
}

.modal-close {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #999;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.modal-close:hover {
  color: #333;
}

.modal-body {
  margin-bottom: 20px;
}

.modal-footer {
  display: flex;
  gap: 12px;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #e0e0e0;
}

.modal-footer button {
  flex: 1 1;
  transition: all 0.2s ease;
}

.modal-footer button:hover:not(:disabled) {
  transform: scale(1.05);
}

.modal-subtitle {
  color: #666;
  margin-bottom: 20px;
  font-size: 14px;
}

/* No Roles Action */
.no-roles-action {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: #fff3f3;
  border: 2px dashed #dc3545;
  border-radius: 8px;
  margin-bottom: 16px;
}

.btn-no-roles {
  background: #fff;
  border: 2px solid #dc3545;
  color: #dc3545;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s;
  white-space: nowrap;
}

.btn-no-roles:hover {
  background: #dc3545;
  color: white;
}

.btn-no-roles.active {
  background: #dc3545;
  color: white;
}

.no-roles-hint {
  font-size: 12px;
  color: #666;
  font-style: italic;
}

.roles-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 16px 0;
  color: #999;
  font-size: 13px;
}

.roles-divider::before,
.roles-divider::after {
  content: '';
  flex: 1 1;
  height: 1px;
  background: #e0e0e0;
}

.roles-checkbox-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.role-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.role-checkbox:hover {
  border-color: #4A964E;
  background: #f9f9ff;
}

.role-checkbox input[type="checkbox"] {
  width: 18px;
  height: 18px;
  margin-top: 2px;
  cursor: pointer;
}

.role-checkbox-name {
  font-weight: 600;
  color: #333;
  text-transform: capitalize;
}

.role-checkbox-desc {
  font-size: 12px;
  color: #666;
  display: block;
  margin-left: auto;
}

.modal-actions {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.modal-actions .btn-primary,
.modal-actions .btn-secondary {
  flex: 1 1;
  padding: 12px;
}

/* User roles display in Profile */
.profile-roles {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

/* ===================== */
/* Admin Panel Extended  */
/* ===================== */

.admin-tabs {
  display: flex;
  gap: 5px;
  margin-bottom: 20px;
  border-bottom: 2px solid #e0e0e0;
  padding-bottom: 10px;
}

.admin-tab {
  padding: 10px 20px;
  border: none;
  background: #f5f5f5;
  border-radius: 8px 8px 0 0;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
}

.admin-tab:hover {
  background: #e8e8e8;
}

.admin-tab.active {
  background: #4A964E;
  color: white;
}

.section-description {
  color: #666;
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 1.5;
}

.actions-cell {
  display: flex;
  gap: 5px;
}

.btn-edit-permissions {
  padding: 6px 12px;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: background 0.2s;
}

.btn-edit-permissions:hover {
  background: #218838;
}

.user-permissions-count {
  font-size: 12px;
  color: #666;
  background: #f0f0f0;
  padding: 4px 8px;
  border-radius: 4px;
}

/* Roles Grid */
.roles-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 15px;
}

.role-card {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 15px;
  transition: box-shadow 0.2s;
}

.role-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.role-card-header {
  margin-bottom: 10px;
}

.role-tag.large {
  font-size: 14px;
  padding: 6px 12px;
}

.role-card-description {
  color: #666;
  font-size: 13px;
  margin-bottom: 10px;
}

.role-card-permissions {
  border-top: 1px solid #e0e0e0;
  padding-top: 10px;
  margin-top: 10px;
}

.role-card-permissions strong {
  font-size: 11px;
  color: #888;
  display: block;
  margin-bottom: 5px;
}

.permission-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.permission-tag-small {
  font-size: 10px;
  padding: 2px 6px;
  background: #e8f4fd;
  color: #1976d2;
  border-radius: 3px;
  font-family: monospace;
}

/* Permissions Grid */
.permission-category {
  margin-bottom: 25px;
}

.permission-category h4 {
  color: #333;
  margin-bottom: 15px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
}

.permissions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 10px;
}

.permission-card {
  background: #f9f9f9;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 12px;
}

.permission-name {
  display: block;
  font-size: 13px;
  color: #1976d2;
  background: #e8f4fd;
  padding: 4px 8px;
  border-radius: 4px;
  margin-bottom: 8px;
}

.permission-description {
  color: #666;
  font-size: 12px;
  margin: 0;
}

/* Modal Large */
.modal-large {
  max-width: 700px;
}

.modal-info {
  color: #666;
  font-size: 13px;
  margin-bottom: 15px;
  padding: 10px;
  background: #f5f5f5;
  border-radius: 6px;
}

/* Permissions Checkbox Container */
.permissions-checkbox-container {
  max-height: 400px;
  overflow-y: auto;
  margin-bottom: 20px;
}

.permission-category-section {
  margin-bottom: 20px;
}

.permission-category-section h4 {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
  padding: 8px;
  background: #f5f5f5;
  border-radius: 4px;
}

.permissions-checkbox-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.permission-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.permission-checkbox:hover {
  border-color: #28a745;
  background: #f0fff4;
}

.permission-checkbox input[type="checkbox"] {
  width: 18px;
  height: 18px;
  margin-top: 2px;
  cursor: pointer;
}

.permission-checkbox-content {
  flex: 1 1;
}

.permission-checkbox-name {
  display: block;
  font-size: 12px;
  color: #1976d2;
  margin-bottom: 4px;
}

.permission-checkbox-desc {
  font-size: 11px;
  color: #666;
}

/* Role checkbox name colors */
.role-checkbox-name.admin {
  color: #dc3545;
}

.role-checkbox-name.manager {
  color: #fd7e14;
}

.role-checkbox-name.employee {
  color: #28a745;
}

.role-checkbox-name.viewer {
  color: #17a2b8;
}

.role-checkbox-name.client {
  color: #334155;
}

/* Profile permissions */
.profile-permissions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 5px;
}

.profile-info-item.full-width {
  grid-column: 1 / -1;
}

/* =====================================================
   HOME PAGE STYLES
   ===================================================== */

.home-page .page-header {
  margin-bottom: 25px;
}

/* Home Page Header with Avatar */
.home-header-with-avatar {
  display: flex;
  align-items: center;
  gap: 20px;
}

.home-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  border: 3px solid #4A964E;
}

.home-avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.home-avatar-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #4A964E 0%, #3d7a40 100%);
  color: white;
  font-size: 32px;
  font-weight: 600;
}

.home-header-text h2 {
  margin: 0 0 4px 0;
}

.home-header-text p {
  margin: 0;
}

.home-grid {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ── Section card shell ─────────────────────────────────────── */
.home-section {
  background: white;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.07);
  overflow: hidden;
}

/* ── Section header (green bar) ─────────────────────────────── */
.section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 13px 20px;
  background: linear-gradient(135deg, #4A964E 0%, #3a7a3e 100%);
  color: white;
}

.section-header__icon {
  font-size: 17px;
  line-height: 1;
}

.section-header h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  flex: 1 1;
  letter-spacing: 0.01em;
}

.section-header__count {
  font-size: 11px;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.25);
  padding: 2px 9px;
  border-radius: 20px;
  min-width: 24px;
  text-align: center;
}

/* ── Subsection divider ─────────────────────────────────────── */
.announcements-section,
.news-section {
  max-height: none;
  overflow-y: visible;
}

.announcements-subsection {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.announcements-subsection:last-child {
  border-bottom: none;
}

.subsection-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 700;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  margin-bottom: 12px;
}

/* ── Announcement list ──────────────────────────────────────── */
.announcements-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* ── Announcement card ──────────────────────────────────────── */
.announcement-card {
  border-radius: 10px;
  padding: 12px 14px;
  border-left: 4px solid #2563eb;
  background: #f9fafb;
  transition: transform 0.15s, box-shadow 0.15s;
}

.announcement-card:hover {
  transform: translateX(3px);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.09);
}

.announcement-card.is-pinned {
  outline: 1px solid #fbbf24;
  outline-offset: -1px;
}

.announcement-card.priority-urgent {
  box-shadow: 0 0 0 1px #fca5a5;
}

.announcement-header {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin-bottom: 7px;
  flex-wrap: wrap;
}

.priority-icon {
  font-size: 15px;
  flex-shrink: 0;
  margin-top: 1px;
}

.announcement-title {
  font-weight: 700;
  font-size: 13.5px;
  color: #111827;
  flex: 1 1;
  line-height: 1.4;
  min-width: 0;
  word-break: break-word;
}

/* badge row */
.announcement-badges {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
}

.pinned-badge {
  font-size: 10px;
  font-weight: 700;
  color: #92400e;
  background: #fef3c7;
  border: 1px solid #fcd34d;
  padding: 1px 7px;
  border-radius: 6px;
  white-space: nowrap;
}

.priority-badge {
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  padding: 1px 7px;
  border-radius: 6px;
  letter-spacing: 0.03em;
  white-space: nowrap;
}

.announcement-content {
  font-size: 13px;
  color: #111827;
  line-height: 1.65;
  margin-bottom: 10px;
  word-break: break-word;
}

/* footer */
.announcement-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 6px;
  padding-top: 8px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.announcement-author {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11.5px;
  color: #374151;
  font-weight: 500;
}

.author-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #dbeafe;
  color: #1d4ed8;
  font-size: 10px;
  font-weight: 700;
  flex-shrink: 0;
}

.announcement-date {
  font-size: 11px;
  color: #9ca3af;
}

/* ── News section ───────────────────────────────────────────── */
.news-list {
  padding: 14px 18px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.news-card {
  display: flex;
  gap: 14px;
  padding: 13px;
  background: #f9fafb;
  border-radius: 10px;
  border: 1px solid #f0f0f0;
  transition: background 0.15s, box-shadow 0.15s, transform 0.15s;
}

.news-card:hover {
  background: #f3f4f6;
  transform: translateY(-2px);
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.09);
}

.news-image {
  width: 88px;
  height: 70px;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
}

.news-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.news-content {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.news-title-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.pinned-icon {
  font-size: 12px;
  flex-shrink: 0;
}

.news-title {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
  margin: 0;
  line-height: 1.4;
}

.news-summary {
  font-size: 13px;
  color: #111827;
  line-height: 1.65;
  margin: 0;
  word-break: break-word;
}

/* ── Article / rich-content body ────────────────────────────── */
.article-body {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.article-h1 {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  margin: 14px 0 4px;
  line-height: 1.3;
  padding-bottom: 4px;
  border-bottom: 2px solid #e5e7eb;
}

.article-h2 {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
  margin: 12px 0 3px;
  line-height: 1.3;
}

.article-h3 {
  font-size: 13px;
  font-weight: 700;
  color: #374151;
  margin: 10px 0 2px;
  line-height: 1.3;
}

.article-body .article-h1:first-child,
.article-body .article-h2:first-child,
.article-body .article-h3:first-child {
  margin-top: 0;
}

.article-p {
  font-size: 13px;
  color: #111827;
  line-height: 1.7;
  margin: 4px 0;
}

.article-list {
  margin: 4px 0 4px 18px;
  padding: 0;
  list-style: disc;
}

.article-list li {
  font-size: 13px;
  color: #111827;
  line-height: 1.65;
  margin-bottom: 2px;
}

.article-spacer {
  height: 8px;
}

.news-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 4px;
  padding-top: 6px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  margin-top: auto;
}

.news-author {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #374151;
  font-weight: 500;
}

.news-date {
  font-size: 11px;
  color: #9ca3af;
}

/* ── Empty states ───────────────────────────────────────────── */
.no-content {
  color: #9ca3af;
  font-size: 12.5px;
  font-style: italic;
  margin: 0;
  padding: 4px 0;
}

.no-content-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 32px 16px;
  color: #9ca3af;
  font-size: 13px;
  text-align: center;
}

.no-content-box span {
  font-size: 28px;
}

.no-content-box p {
  margin: 0;
}

/* ── Responsive ─────────────────────────────────────────────── */
@media (max-width: 600px) {
  .news-image { display: none; }
  .announcement-badges { width: 100%; }
}

/* =====================================================
   CONTENT MANAGEMENT STYLES
   ===================================================== */

.content-management .page-header {
  margin-bottom: 20px;
}

.content-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.tab-btn {
  padding: 12px 24px;
  border: 2px solid #e0e0e0;
  background: white;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
}

.tab-btn:hover {
  border-color: #4A964E;
  color: #4A964E;
}

.tab-btn.active {
  background: #4A964E;
  color: white;
  border-color: transparent;
}

.content-panel {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 20px;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.panel-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

/* Content Form Overlay */
.content-form-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.content-form {
  background: white;
  border-radius: 12px;
  padding: 25px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
}

.content-form h4 {
  margin: 0 0 20px 0;
  font-size: 18px;
  color: #333;
}

.content-form .form-group {
  margin-bottom: 16px;
}

.content-form .form-group label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  font-size: 13px;
  color: #555;
}

.content-form .form-group input,
.content-form .form-group textarea,
.content-form .form-group select {
  width: 100%;
  padding: 10px 14px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.content-form .form-group input:focus,
.content-form .form-group textarea:focus,
.content-form .form-group select:focus {
  outline: none;
  border-color: #4A964E;
}

.content-form .form-row {
  display: flex;
  gap: 15px;
}

.content-form .form-row .form-group {
  flex: 1 1;
}

.content-form .checkbox-group {
  display: flex;
  align-items: center;
}

.content-form .checkbox-group label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin-bottom: 0;
}

.content-form .checkbox-group input[type="checkbox"] {
  width: 18px;
  height: 18px;
}

.form-actions {
  display: flex;
  gap: 10px;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

.form-actions .btn {
  width: auto;
  padding: 10px 24px;
}

/* Content Table */
.content-table {
  width: 100%;
  border-collapse: collapse;
}

.content-table th,
.content-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.content-table th {
  background: #f8f9fa;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  color: #666;
}

.content-table tr:hover {
  background: #f9fafb;
}

.content-table tr.unpublished {
  opacity: 0.7;
  background: #fffbf0;
}

.pin-icon {
  margin-right: 5px;
}

.status-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}

.status-badge.published {
  background: #e8f5e9;
  color: #2e7d32;
}

.status-badge.draft {
  background: #fff3e0;
  color: #e65100;
}

.priority-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
}

.scope-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
}

.scope-badge.global {
  background: #e3f2fd;
  color: #1565c0;
}

.scope-badge.department {
  background: #f3e5f5;
  color: #7b1fa2;
}

.btn-small {
  padding: 6px 12px !important;
  font-size: 12px !important;
  width: auto !important;
  margin-right: 5px;
}

.btn-edit {
  background: #17a2b8;
  color: white;
}

.btn-edit:hover {
  background: #138496;
}

.btn-danger {
  background: #dc3545;
  color: white;
}

.btn-danger:hover {
  background: #c82333;
}

/* Content section in sidebar */
.content-section {
  border-top: 1px solid #eee;
  padding-top: 15px;
}

.content-link {
  color: #8e44ad !important;
}

.content-link:hover {
  background: #f5eef8 !important;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .content-form-overlay {
    padding: 10px;
  }
  
  .content-form {
    padding: 15px;
  }
  
  .content-form .form-row {
    flex-direction: column;
  }
  
  .content-table {
    font-size: 12px;
  }
  
  .content-table th,
  .content-table td {
    padding: 8px 10px;
  }
}

/* =====================================================
   Employee Manager Styles
   ===================================================== */

.tab-navigation {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 0;
}

.tab-button {
  background: none;
  border: none;
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 500;
  color: #6c757d;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: all 0.2s;
  margin-bottom: -2px;
}

.tab-button:hover {
  color: #007bff;
  background: #f8f9fa;
}

.tab-button.active {
  color: #007bff;
  border-bottom-color: #007bff;
}

.tab-content {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.tab-content .manager-section {
  width: 100%;
  max-width: none;
}

.employee-manager-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

.manager-section {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 24px;
}

.manager-section h3 {
  margin: 0 0 20px 0;
  font-size: 18px;
  color: #333;
}

.add-dept-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.dept-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dept-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.dept-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dept-info strong {
  color: #333;
}

.dept-desc {
  font-size: 12px;
  color: #666;
}

.dept-count {
  font-size: 11px;
  color: #888;
  background: #e9ecef;
  padding: 2px 8px;
  border-radius: 10px;
  width: fit-content;
}

.dept-actions {
  display: flex;
  gap: 8px;
}

.dept-edit-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dept-edit-actions {
  display: flex;
  gap: 8px;
}

.position-group {
  margin-bottom: 24px;
}

.position-group-header {
  font-size: 14px;
  font-weight: 600;
  color: #555;
  margin-bottom: 8px;
  padding-left: 4px;
  border-left: 3px solid #007bff;
  padding-left: 12px;
}

.form-help {
  display: block;
  font-size: 12px;
  color: #6c757d;
  margin-top: 4px;
}

.btn-icon {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background 0.2s;
}

.btn-icon:hover {
  background: #e9ecef;
}

.btn-icon-danger:hover {
  background: #f8d7da;
}

.btn-success {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  background: #28a745;
  color: white;
}

.btn-success:hover:not(:disabled) {
  background: #218838;
}

.btn-success:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-sm {
  padding: 6px 12px;
  font-size: 13px;
}

.no-data {
  color: #888;
  font-style: italic;
  text-align: center;
  padding: 20px;
}

/* Employees Table */
.employees-section {
  overflow: hidden;
}

.employees-table-container {
  overflow-x: auto;
}

.employees-table {
  width: 100%;
  border-collapse: collapse;
}

.employees-table th,
.employees-table td {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.employees-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #555;
  font-size: 13px;
  text-transform: uppercase;
}

.employees-table tbody tr:hover {
  background: #f8f9fa;
}

.emp-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.emp-avatar-small {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #4A964E;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  overflow: hidden;
  flex-shrink: 0;
}

.emp-avatar-small img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.emp-avatar-small span {
  font-size: 16px;
}

.emp-info strong {
  display: block;
  color: #333;
}

.emp-email {
  display: block;
  font-size: 12px;
  color: #888;
}

@media (max-width: 1024px) {
  .employee-manager-grid {
    grid-template-columns: 1fr;
  }
}

/* ═══════════════════════════════════════════════════════════════
   Order Monitoring  — ProductionOrderMonitoring.js
   ═══════════════════════════════════════════════════════════════ */

.order-monitoring .om-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  min-width: 0;
  margin-bottom: 16px;
}

.order-monitoring .om-tabs {
  display: flex;
  flex: 1 1 380px;
  min-width: 0;
  gap: 4px;
  background: #f0f0f0;
  padding: 4px;
  border-radius: 8px;
}

.order-monitoring .om-tab {
  flex: 1 1;
  min-width: 0;
  padding: 8px clamp(8px, 1.2vw, 16px);
  border: none;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
  font-size: clamp(11px, 1vw, 14px);
  font-weight: 500;
  line-height: 1.2;
  white-space: normal;
  color: #555;
  transition: all 0.2s;
}

.order-monitoring .om-tab-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  margin-left: 7px;
  padding: 0 6px;
  border-radius: 999px;
  background: #dc2626;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  line-height: 1;
}

.order-monitoring .om-tab--active .om-tab-count {
  background: #b91c1c;
}

.order-monitoring .om-tab:hover {
  background: #e0e0e0;
}

.order-monitoring .om-tab--active {
  background: #4A964E;
  color: white;
}

.order-monitoring .om-controls {
  display: flex;
  flex: 0 1 auto;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  min-width: 0;
  gap: 12px;
}

.order-monitoring .om-dept-toggle {
  display: flex;
  flex: 0 0 auto;
  gap: 4px;
  background: #f0f0f0;
  padding: 4px;
  border-radius: 8px;
}

.order-monitoring .om-dept-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 8px clamp(10px, 1.3vw, 18px);
  border: none;
  border-radius: 6px;
  background: transparent;
  font-weight: 600;
  font-size: clamp(11px, 1vw, 14px);
  cursor: pointer;
  color: #555;
  transition: all 0.2s;
}

.order-monitoring .om-dept-btn--active {
  background: #333;
  color: white;
}

.order-monitoring .om-delivery-filter {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin: 14px 0;
  padding: 4px;
  width: fit-content;
  max-width: 100%;
  border-radius: 8px;
  background: #f0f0f0;
}

.order-monitoring .om-delivery-filter-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px clamp(12px, 1.5vw, 20px);
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #555;
  font-size: clamp(12px, 1vw, 14px);
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.order-monitoring .om-delivery-filter-btn:hover {
  background: #e0e0e0;
}

.order-monitoring .om-delivery-filter-btn--active {
  background: #4A964E;
  color: #fff;
}

.order-monitoring .om-delivery-filter-btn--active:hover {
  background: #3f8243;
}

.order-monitoring .om-duplicate-warning-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #d97706;
  font-size: 11px;
  line-height: 1;
}

.order-monitoring .om-dept-btn--active .om-duplicate-warning-icon,
.order-monitoring .om-delivery-filter-btn--active .om-duplicate-warning-icon {
  color: #fef3c7;
}

.order-monitoring .om-sync-btn {
  flex: 0 1 auto;
  min-width: 0;
  padding: 8px clamp(10px, 1.3vw, 18px);
  border: 2px solid #4A964E;
  border-radius: 8px;
  background: white;
  color: #4A964E;
  font-weight: 600;
  font-size: clamp(11px, 1vw, 14px);
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s;
}

.order-monitoring .om-sync-btn:hover:not(:disabled) {
  background: #4A964E;
  color: white;
}

.order-monitoring .om-sync-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.order-monitoring .om-sync-btn.om-btn-active {
  background: #4A964E;
  color: white;
}

.order-monitoring .om-export-wrapper > .om-sync-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

/* Producer filter buttons */
.order-monitoring .om-producer-filters {
  display: flex;
  gap: 0.25rem;
  margin-left: 0.5rem;
}

.order-monitoring .om-producer-btn {
  padding: 8px 16px;
  border: 2px solid #ccc;
  border-radius: 8px;
  background: white;
  color: #555;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.order-monitoring .om-producer-btn:hover {
  border-color: #4A964E;
  color: #4A964E;
}

.order-monitoring .om-producer-btn--active {
  background: #4A964E;
  border-color: #4A964E;
  color: white;
}

/* wrapper */
.order-monitoring .om-export-wrapper {
  position: relative;
  display: inline-block;
}

/* dropdown menu */
.order-monitoring .om-export-menu {
  position: absolute;
  top: 105%;
  right: 0;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 6px 16px rgba(0,0,0,0.08);
  min-width: 150px;
  overflow: hidden;
  z-index: 20;
}

.order-monitoring .om-export-menu button {
  width: 100%;
  padding: 10px 14px;
  border: none;
  background: white;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
}

.order-monitoring .om-row-delayed {
  background: #fee2e2;
}

.order-monitoring .om-row-earlier {
  background: #dcfce7;
}

.order-monitoring .om-row-earlier td {
  border-color: #86efac;
}

.order-monitoring .om-row-earlier:hover {
  background: #bbf7d0;
}

.order-monitoring .om-row-delayed td {
  border-color: #fca5a5;
}

/* opcjonalnie mocniejsze */
.order-monitoring .om-row-delayed:hover {
  background: #fecaca;
}

/* Delivery status colors for Est. Delivery column */
.order-monitoring .om-delivery-delayed {
  background: #fee2e2;
  color: #dc2626;
  font-weight: 600;
}

.order-monitoring .om-delivery-earlier {
  background: #dcfce7;
  color: #16a34a;
  font-weight: 600;
}

.order-monitoring .om-delivery-changed {
  background: #ffedd5;
  color: #c2410c;
  font-weight: 600;
}

.order-monitoring .om-export-menu button:hover {
  background: #f3f4f6;
}

/* Banners */
.order-monitoring .om-banner {
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 12px;
  font-size: 14px;
}

.order-monitoring .om-banner--success {
  background: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #a5d6a7;
}

.order-monitoring .om-banner--error {
  background: #fbe9e7;
  color: #c62828;
  border: 1px solid #ef9a9a;
}

.order-monitoring .om-banner--info {
  background: #e3f2fd;
  color: #1565c0;
  border: 1px solid #90caf9;
}

.order-monitoring .om-banner--warning {
  background: #fff8e1;
  color: #8a4b08;
  border: 1px solid #f0c36d;
}

/* Search & Lookup */
.order-monitoring .om-order-lookup {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  max-width: 720px;
}

.order-monitoring .om-order-autocomplete {
  position: relative;
  flex: 1 1;
  min-width: 200px;
}

.order-monitoring .om-order-autocomplete .om-search {
  width: 100%;
}

.order-monitoring .om-order-suggestions {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  left: 0;
  z-index: 1000;
  max-height: 280px;
  margin: 0;
  padding: 4px;
  overflow-y: auto;
  list-style: none;
  border: 1px solid #d7ddd7;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.14);
}

.order-monitoring .om-order-suggestions li {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 9px 10px;
  border-radius: 5px;
  cursor: pointer;
}

.order-monitoring .om-order-suggestions li:hover,
.order-monitoring .om-order-suggestions li.is-active {
  background: #edf7ee;
}

.order-monitoring .om-order-suggestions li span {
  color: #667066;
  font-size: 12px;
}

.order-monitoring .om-order-suggestions-loading {
  position: absolute;
  top: 50%;
  right: 12px;
  color: #667066;
  font-size: 12px;
  transform: translateY(-50%);
  pointer-events: none;
}

.order-monitoring .om-order-lookup-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 42px;
  padding: 9px 14px;
  border: 2px solid #2f7d32;
  border-radius: 8px;
  background: #2f7d32;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}

.order-monitoring .om-order-lookup-btn:hover:not(:disabled) {
  background: #256428;
  border-color: #256428;
}

.order-monitoring .om-order-lookup-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.order-monitoring .om-search-row {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.order-monitoring .om-search {
  flex: 1 1;
  min-width: 200px;
  padding: 10px 14px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.order-monitoring .om-search:focus {
  outline: none;
  border-color: #4A964E;
}

@media (max-width: 600px) {
  .order-monitoring .om-order-lookup {
    align-items: stretch;
    flex-direction: column;
  }

  .order-monitoring .om-order-autocomplete,
  .order-monitoring .om-order-lookup .om-search {
    width: 100%;
  }
}

.order-monitoring .om-lookup-form {
  display: flex;
  gap: 4px;
}

.order-monitoring .om-lookup-input {
  width: 200px;
  padding: 10px 14px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
}

.order-monitoring .om-lookup-input:focus {
  outline: none;
  border-color: #4A964E;
}

.order-monitoring .om-lookup-btn {
  padding: 10px 14px;
  border: 2px solid #4A964E;
  border-radius: 8px;
  background: #4A964E;
  color: white;
  cursor: pointer;
  font-size: 16px;
  transition: opacity 0.2s;
}

.order-monitoring .om-lookup-btn:hover {
  opacity: 0.85;
}

/* Table */
.order-monitoring .om-table-wrap {
  overflow-x: auto;
}

.order-monitoring .om-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.order-monitoring .om-table th {
  background: #f5f5f5;
  padding: 10px 12px;
  text-align: left;
  font-weight: 600;
  color: #555;
  border-bottom: 2px solid #e0e0e0;
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
}

.order-monitoring .om-table th:hover {
  background: #ebebeb;
}

.order-monitoring .om-table td {
  padding: 10px 12px;
  border-bottom: 1px solid #f0f0f0;
  color: #333;
}

.order-monitoring .om-table tbody tr:hover {
  background: #f9fbe7;
}

.order-monitoring .om-remaining {
  font-weight: 700;
  color: #c62828;
}

.order-monitoring .om-complaint-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 9px;
  border: 1px solid #f59e0b;
  border-radius: 999px;
  background: #fffbeb;
  color: #92400e;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.order-monitoring .om-received-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 7px 11px;
  border: 1px solid #4A964E;
  border-radius: 7px;
  background: #4A964E;
  color: #fff;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
}

.order-monitoring .om-received-btn:hover:not(:disabled) {
  background: #3f8243;
}

.order-monitoring .om-received-btn:disabled {
  opacity: .6;
  cursor: not-allowed;
}

.order-monitoring .om-delivery-date-input {
  min-width: 145px;
  padding: 7px 9px;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  background: #fff;
  color: #333;
  font: inherit;
}

.order-monitoring .om-delivery-date-input:focus {
  border-color: #4A964E;
  outline: 2px solid rgba(74, 150, 78, .18);
}

/* Footer */
.order-monitoring .om-footer {
  margin-top: 12px;
  text-align: right;
  font-size: 13px;
  color: #888;
}

/* Pagination */
.order-monitoring .om-pagination {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px 24px;
  margin-top: 12px;
  font-size: 13px;
  color: #666;
}

.order-monitoring .om-pagination__size {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.order-monitoring .om-pagination__size select {
  padding: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #fff;
  font-size: 13px;
}

.order-monitoring .om-pagination__nav {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.order-monitoring .om-pagination__page {
  min-width: 110px;
  text-align: center;
}

.order-monitoring .om-pagination__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #fff;
  color: #444;
  cursor: pointer;
}

.order-monitoring .om-pagination__btn:hover:not(:disabled) {
  background: #f0f0f0;
}

.order-monitoring .om-pagination__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Loading / Empty */
.order-monitoring .om-loading,
.order-monitoring .om-empty {
  text-align: center;
  padding: 48px 20px;
  color: #888;
  font-size: 16px;
}

/* Responsive */
@media (max-width: 768px) {
  .order-monitoring .om-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .order-monitoring .om-controls {
    width: 100%;
    justify-content: flex-start;
    gap: 8px;
  }

  .order-monitoring .om-tabs {
    width: 100%;
    flex-basis: auto;
  }

  .order-monitoring .om-tab {
    padding-inline: 6px;
  }

  .order-monitoring .om-sync-btn {
    white-space: normal;
  }
}

@keyframes dropIn {
  0% {
    transform: translateY(-120px) scale(0.96);
    opacity: 0;
  }
  60% {
    transform: translateY(10px) scale(1.01);
    opacity: 1;
  }
  100% {
    transform: translateY(0) scale(1);
  }
}

.header-description {
  margin-bottom: 1.5rem; /* ~2 linie odstępu */
}

.warning-red {
  margin-top: 8px;
  padding: 10px 14px;
  background-color: #fdecea;
  border: 1px solid #f5c2c7;
  color: #b02a37;
  border-radius: 6px;
  font-size: 0.9rem;
}

.info-box {
  margin-top: 12px;
  padding: 10px 14px;
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  color: #856404;
  border-radius: 6px;
  font-size: 0.9rem;
}

.om-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.om-overlay__box {
  background: #fff;
  border-radius: 16px;
  padding: 2.5rem 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.2rem;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
}

.om-overlay__spinner {
  width: 56px;
  height: 56px;
  border: 6px solid #e0e0e0;
  border-top-color: #4f46e5;
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
}

.om-overlay__text {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

.stojaki-page .page-container {
  max-width: 1800px;
  margin: 0 auto;
  width: 100%;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: visible;
}

.stojaki-page .page-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 2rem;
  margin-bottom: 0;
  border-radius: 12px 12px 0 0;
}

.stojaki-page .page-header h2 {
  font-size: 2rem;
  margin-bottom: 0.5rem;
  color: white;
}

.stojaki-page .page-header p {
  opacity: 0.9;
  font-size: 1.1rem;
  color: white;
}

.stojaki-page .page-content {
  padding: 2rem;
  border-radius: 0;
  box-shadow: none;
}

/* Breadcrumb */
.stojaki-page .breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  font-size: 0.9rem;
}

.stojaki-page .breadcrumb-link {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: white;
  text-decoration: none;
  opacity: 0.8;
  transition: opacity 0.2s;
}

.stojaki-page .breadcrumb-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  stroke-width: 1.9;
}

.stojaki-page .stojaki-page-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.stojaki-page .stojaki-page-title > svg {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  stroke-width: 1.8;
}

.stojaki-page .breadcrumb-link:hover {
  opacity: 1;
}

.stojaki-page .breadcrumb-separator {
  opacity: 0.6;
}

.stojaki-page .breadcrumb-current {
  opacity: 1;
}

/* Tabs */
.stojaki-page .stojaki-tabs-wrapper {
  background: white;
  border-bottom: 2px solid #e5e7eb;
}

.stojaki-page .stojaki-tabs {
  display: flex;
  gap: 0.5rem;
  padding: 0 2rem;
  max-width: 1800px;
  margin: 0 auto;
}

.stojaki-page .tab-btn {
  background: none;
  border: none;
  border-radius: 0;
  padding: 1rem 1.5rem;
  font-size: 1rem;
  font-weight: 500;
  color: #718096;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: all 0.2s;
}

.stojaki-page .tab-btn:hover {
  color: #667eea;
  border-color: transparent;
  background: none;
}

.stojaki-page .tab-btn.active {
  color: #667eea;
  border-bottom-color: #667eea;
  background: none;
}

/* Tab content */
.stojaki-page .tab-content {
  min-height: 400px;
}

.stojaki-page .tab-section {
  margin-bottom: 2.5rem;
}

.stojaki-page .tab-section h3 {
  font-size: 1.5rem;
  color: #2d3748;
  margin-bottom: 0.5rem;
}

.stojaki-page .section-description {
  color: #718096;
  margin-bottom: 1.5rem;
  line-height: 1.6;
}

/* Alerts */
.stojaki-page .alert {
  padding: 1rem 1.5rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  font-weight: 500;
}

.stojaki-page .alert-error {
  background: #fee;
  color: #c53030;
  border-left: 4px solid #c53030;
}

.stojaki-page .alert-success {
  background: #d4edda;
  color: #155724;
  border-left: 4px solid #28a745;
}

/* File upload */
.stojaki-page .csv-upload-section {
  background: #f9fafb;
  border: 2px dashed #d1d5db;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
}

.stojaki-page .file-upload-wrapper {
  margin-bottom: 1.5rem;
}

.stojaki-page .file-upload-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  border: 2px dashed #667eea;
  border-radius: 12px;
  background: white;
  cursor: pointer;
  transition: all 0.2s;
}

.stojaki-page .file-upload-label:hover {
  background: #f7fafc;
  border-color: #764ba2;
}

.stojaki-page .file-upload-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.stojaki-page .file-upload-text {
  font-size: 1.1rem;
  color: #2d3748;
  margin-bottom: 0.5rem;
}

.stojaki-page .file-upload-hint {
  color: #718096;
  font-size: 0.9rem;
}

.stojaki-page .file-upload-input {
  display: none;
}

.stojaki-page .file-info-card {
  background: white;
  border: 2px solid #667eea;
  border-radius: 12px;
  padding: 1.5rem;
}

.stojaki-page .file-info-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.stojaki-page .file-info-icon {
  font-size: 2.5rem;
}

.stojaki-page .file-info-details {
  flex: 1 1;
}

.stojaki-page .file-info-details h4 {
  color: #2d3748;
  margin-bottom: 0.5rem;
}

.stojaki-page .file-info-details p {
  color: #718096;
  font-size: 0.9rem;
}

.stojaki-page .file-info-label {
  font-weight: 600;
  color: #4a5568;
}

.stojaki-page .btn-remove-file {
  background: #ef4444;
  color: white;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 1.2rem;
  transition: background 0.2s;
}

.stojaki-page .btn-remove-file:hover {
  background: #dc2626;
}

.stojaki-page .btn-remove-file:disabled {
  background: #d1d5db;
  cursor: not-allowed;
}

.stojaki-page .file-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
}

.stojaki-page .upload-placeholder {
  text-align: center;
  padding: 2rem;
  color: #718096;
}

/* Buttons */
.stojaki-page .btn-primary,
.stojaki-page .btn-success,
.stojaki-page .btn-secondary,
.stojaki-page .btn-small {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.stojaki-page .btn-primary {
  background: #667eea;
  color: white;
}

.stojaki-page .btn-primary:hover:not(:disabled) {
  background: #5a67d8;
}

.stojaki-page .btn-success {
  background: #48bb78;
  color: white;
}

.stojaki-page .btn-success:hover:not(:disabled) {
  background: #38a169;
}

.stojaki-page .btn-secondary {
  background: #718096;
  color: white;
  width: auto;
}

.stojaki-page .btn-secondary:hover:not(:disabled) {
  background: #4a5568;
}

.stojaki-page .btn-warning {
  background: #f59e0b;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.stojaki-page .btn-warning:hover:not(:disabled) {
  background: #d97706;
}

.stojaki-page .btn-small {
  padding: 0.4rem 0.8rem;
  font-size: 0.85rem;
  margin: 0 0.25rem;
}

.stojaki-page button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.stojaki-page .action-buttons {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  margin: 1.5rem 0;
}

.stojaki-page .action-buttons > button {
  flex-shrink: 0;
  width: auto;
  margin-top: 0;
}

/* Email Status Summary Cards */
.stojaki-page .email-status-summary {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1rem;
  margin: 2rem 0;
}

.stojaki-page .status-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.stojaki-page .status-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

.stojaki-page .status-card-icon {
  font-size: 2.5rem;
  line-height: 1;
  flex-shrink: 0;
}

.stojaki-page .status-card-content {
  flex: 1 1;
}

.stojaki-page .status-card-value {
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 0.25rem;
}

.stojaki-page .status-card-label {
  font-size: 0.875rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.8;
}

.stojaki-page .status-card-total { border-color: #667eea; }
.stojaki-page .status-card-total .status-card-value,
.stojaki-page .status-card-total .status-card-label { color: #667eea; }

.stojaki-page .status-card-pending { border-color: #f59e0b; }
.stojaki-page .status-card-pending .status-card-value,
.stojaki-page .status-card-pending .status-card-label { color: #f59e0b; }

.stojaki-page .status-card-sent { border-color: #3b82f6; }
.stojaki-page .status-card-sent .status-card-value,
.stojaki-page .status-card-sent .status-card-label { color: #3b82f6; }

.stojaki-page .status-card-failed { border-color: #ef4444; }
.stojaki-page .status-card-failed .status-card-value,
.stojaki-page .status-card-failed .status-card-label { color: #ef4444; }

.stojaki-page .status-card-replied { border-color: #10b981; }
.stojaki-page .status-card-replied .status-card-value,
.stojaki-page .status-card-replied .status-card-label { color: #10b981; }

.stojaki-page .status-card-check-replies {
  border-color: #8b5cf6;
  cursor: pointer;
  transition: all 0.3s ease;
}
.stojaki-page .status-card-check-replies .status-card-value,
.stojaki-page .status-card-check-replies .status-card-label { color: #8b5cf6; }
.stojaki-page .status-card-check-replies:hover:not(:disabled) {
  background: #f5f3ff;
  transform: translateY(-4px);
  box-shadow: 0 6px 16px rgba(139, 92, 246, 0.2);
}
.stojaki-page .status-card-check-replies:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Tables */
.stojaki-page .sessions-table,
.stojaki-page .customers-table {
  overflow-x: auto;
  margin-top: 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: white;
}

.stojaki-page table {
  width: 100%;
  min-width: 1100px;
  border-collapse: collapse;
  background: white;
}

.stojaki-page thead {
  background: #f9fafb;
}

.stojaki-page th {
  padding: 0.75rem 0.625rem;
  text-align: left;
  font-weight: 600;
  color: #2d3748;
  border-bottom: 2px solid #e5e7eb;
  white-space: nowrap;
  position: sticky;
  top: 0;
  background: #f9fafb;
  z-index: 10;
}

.stojaki-page td {
  padding: 0.625rem 0.625rem;
  border-bottom: 1px solid #e5e7eb;
  color: #4a5568;
  vertical-align: middle;
}

.stojaki-page tr:hover {
  background: #f9fafb;
}

.stojaki-page tr.selected {
  background: #ede9fe;
}

/* Do Not Send styles */
.stojaki-page tr.do-not-send-row {
  background: #fef3c7 !important;
  opacity: 0.7;
}

.stojaki-page tr.do-not-send-row:hover {
  background: #fde68a !important;
  opacity: 0.8;
}

.stojaki-page .do-not-send-badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  margin-left: 0.5rem;
  background: #fbbf24;
  color: #78350f;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
}

/* Status badges */
.stojaki-page .status-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
}

.stojaki-page .status-badge.imported,
.stojaki-page .status-badge.created {
  background: #dbeafe;
  color: #1e40af;
}

.stojaki-page .status-badge.generated {
  background: #fef3c7;
  color: #92400e;
}

.stojaki-page .status-badge.sent {
  background: #d1fae5;
  color: #065f46;
}

.stojaki-page .status-badge.failed {
  background: #fee2e2;
  color: #991b1b;
}

.stojaki-page .status-badge.replied {
  background: #e0e7ff;
  color: #3730a3;
}

.stojaki-page .status-badge.confirmed_ready {
  background: #d1fae5;
  color: #065f46;
}

.stojaki-page .status-badge.scheduled_pickup {
  background: #ddd6fe;
  color: #5b21b6;
}

.stojaki-page .status-badge.completed {
  background: #d1fae5;
  color: #047857;
}

/* Email preview */
.stojaki-page .email-preview-card {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1rem;
}

.stojaki-page .email-preview-card h4 {
  color: #2d3748;
  margin-bottom: 0.75rem;
}

.stojaki-page .email-preview-card p {
  margin: 0.5rem 0;
  color: #4a5568;
}

.stojaki-page .email-preview-card details {
  margin-top: 1rem;
}

.stojaki-page .email-preview-card summary {
  cursor: pointer;
  color: #667eea;
  font-weight: 600;
}

/* Preview Toggle Button */
.stojaki-page .preview-toggle-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
}

.stojaki-page .arrow-icon {
  display: inline-block;
  transition: transform 0.3s ease;
  font-size: 0.8rem;
}

.stojaki-page .arrow-icon.rotated {
  transform: rotate(180deg);
}

/* Email Preview Accordion */
.stojaki-page .email-previews-section {
  animation: stojakiFadeIn 0.3s ease;
}

@keyframes stojakiFadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

.stojaki-page .email-preview-accordion {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  margin-bottom: 1rem;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.stojaki-page .email-preview-accordion:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-color: #d1d5db;
}

.stojaki-page .accordion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem 1.5rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.2s ease;
}

.stojaki-page .accordion-header:hover {
  background-color: #f9fafb;
}

.stojaki-page .accordion-title {
  font-weight: 600;
  color: #2d3748;
  font-size: 1rem;
}

.stojaki-page .accordion-arrow {
  display: inline-block;
  transition: transform 0.3s ease;
  font-size: 0.75rem;
  color: #667eea;
  font-weight: bold;
}

.stojaki-page .accordion-arrow.rotated {
  transform: rotate(180deg);
}

.stojaki-page .accordion-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s ease, padding 0.4s ease;
}

.stojaki-page .accordion-content.open {
  max-height: 1000px;
  padding: 0 1.5rem 1.25rem 1.5rem;
}

.stojaki-page .accordion-content-inner {
  padding-top: 0.75rem;
  border-top: 1px solid #f3f4f6;
  animation: stojakiFadeInContent 0.3s ease;
}

@keyframes stojakiFadeInContent {
  from { opacity: 0; transform: translateY(-5px); }
  to { opacity: 1; transform: translateY(0); }
}

.stojaki-page .accordion-content-inner p {
  margin: 0.75rem 0;
  color: #4a5568;
  font-size: 0.95rem;
}

.stojaki-page .accordion-content-inner p strong {
  color: #2d3748;
  font-weight: 600;
}

.stojaki-page .email-body-details {
  margin-top: 1.25rem;
  padding-top: 1rem;
  border-top: 1px solid #f3f4f6;
}

.stojaki-page .email-body-details summary {
  cursor: pointer;
  color: #667eea;
  font-weight: 600;
  padding: 0.5rem 0.75rem;
  background: #f9fafb;
  border-radius: 6px;
  transition: all 0.2s ease;
  display: inline-block;
}

.stojaki-page .email-body-details summary:hover {
  background: #eef2ff;
  color: #5a67d8;
}

.stojaki-page .email-body-content {
  margin-top: 1rem;
  padding: 1rem;
  background: #f9fafb;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  max-height: 400px;
  overflow-y: auto;
}

/* Reset table styles inside email preview so they don't inherit page table styles */
.stojaki-page .email-body-content table {
  min-width: unset;
  width: auto;
  border-collapse: collapse;
}

.stojaki-page .email-body-content thead {
  background: none;
}

.stojaki-page .email-body-content th {
  padding: 10px;
  position: static;
  background: none;
  white-space: normal;
  border-bottom: none;
  font-size: inherit;
}

.stojaki-page .email-body-content td {
  padding: 8px;
  border-bottom: none;
  white-space: normal;
  font-size: inherit;
}

.stojaki-page .email-body-content tr {
  background: none;
}

.stojaki-page .email-body-content tr:hover {
  background: none;
}

/* Form inputs */
.stojaki-page .date-input-small {
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.875rem;
  width: 140px;
  box-sizing: border-box;
}

.stojaki-page .date-input-small:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15);
}

.stojaki-page .note-input {
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.875rem;
  width: 200px;
  min-width: 150px;
  box-sizing: border-box;
}

.stojaki-page .note-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15);
  background: #ffffff;
}

.stojaki-page input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

/* Placeholder */
.stojaki-page .placeholder-content {
  text-align: center;
  padding: 3rem;
  color: #718096;
  background: #f9fafb;
  border-radius: 8px;
  margin: 1rem 0;
}

.stojaki-page .placeholder-content p {
  font-size: 1.1rem;
}

/* Responsive */
@media (max-width: 768px) {
  .stojaki-page .stojaki-tabs {
    overflow-x: auto;
  }

  .stojaki-page .action-buttons {
    flex-direction: column;
  }

  .stojaki-page .email-status-summary {
    grid-template-columns: repeat(3, 1fr);
    gap: 0.75rem;
  }

  .stojaki-page .status-card {
    padding: 1rem;
  }

  .stojaki-page .status-card-icon {
    font-size: 2rem;
  }

  .stojaki-page .status-card-value {
    font-size: 1.5rem;
  }

  .stojaki-page .status-card-label {
    font-size: 0.75rem;
  }

  .stojaki-page table {
    font-size: 0.85rem;
  }

  .stojaki-page th,
  .stojaki-page td {
    padding: 0.5rem;
  }

  .stojaki-page table {
    min-width: 1000px;
    font-size: 0.8rem;
  }

  .stojaki-page .note-input {
    width: 150px;
    font-size: 0.8rem;
  }

  .stojaki-page .date-input-small {
    width: 120px;
    font-size: 0.8rem;
  }

  .stojaki-page .btn-small {
    padding: 0.3rem 0.6rem;
    font-size: 0.75rem;
  }
}

@media (max-width: 1024px) {
  .stojaki-page .page-content {
    padding: 1rem;
  }

  .stojaki-page .email-status-summary {
    grid-template-columns: repeat(3, 1fr);
  }

  .stojaki-page table {
    min-width: 1000px;
  }
}

/* Details Modal */
.stojaki-page .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.stojaki-page .modal-content {
  background: white;
  border-radius: 16px;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.2);
  max-width: 800px;
  width: 90%;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: stojakiModalSlideIn 0.3s ease;
  padding: 0;
}

.stojaki-page .modal-content-small {
  max-width: 550px;
}

@keyframes stojakiModalSlideIn {
  from { opacity: 0; transform: translateY(-50px); }
  to { opacity: 1; transform: translateY(0); }
}

.stojaki-page .modal-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 1.5rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.stojaki-page .modal-header h3 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: white;
}

.stojaki-page .modal-close {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 1.5rem;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.stojaki-page .modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

.stojaki-page .modal-body {
  padding: 2rem;
  overflow-y: auto;
  flex: 1 1;
}

.stojaki-page .modal-footer {
  padding: 1.25rem 2rem;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  background: #f9fafb;
}

.stojaki-page .detail-section {
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.stojaki-page .detail-section:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.stojaki-page .detail-section h4 {
  color: #2d3748;
  font-size: 1.1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.stojaki-page .detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.stojaki-page .detail-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.stojaki-page .detail-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stojaki-page .detail-value {
  font-size: 1rem;
  color: #2d3748;
  font-weight: 500;
}

.stojaki-page .reply-message {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 0.5rem;
  color: #2d3748;
  line-height: 1.6;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-height: 300px;
  overflow-y: auto;
}

.stojaki-page .attachment-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.stojaki-page .attachment-item {
  background: #f3f4f6;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  font-size: 0.95rem;
  color: #2d3748;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.stojaki-page .attachment-type {
  color: #6b7280;
  font-size: 0.85rem;
}

.stojaki-page .email-body-preview {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 0.5rem;
  max-height: 200px;
  overflow-y: auto;
  font-size: 0.9rem;
  color: #4a5568;
}

.stojaki-page .no-reply-message {
  text-align: center;
  padding: 2rem;
  color: #6b7280;
  font-size: 1.1rem;
}

/* Note Cell (Clickable) */
.stojaki-page .note-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  min-height: 32px;
  cursor: pointer;
  border-radius: 6px;
  border: 2px solid transparent;
  transition: all 0.2s ease;
  background: #f9fafb;
  min-width: 120px;
  max-width: 200px;
}

.stojaki-page .note-cell:hover {
  background: #eef2ff;
  border-color: #667eea;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.1);
}

.stojaki-page .note-cell:active {
  transform: translateY(0);
}

.stojaki-page .note-text {
  flex: 1 1;
  color: #2d3748;
  font-size: 0.875rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stojaki-page .note-placeholder {
  flex: 1 1;
  color: #9ca3af;
  font-size: 0.875rem;
  font-style: italic;
}

.stojaki-page .note-edit-icon {
  font-size: 14px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.stojaki-page .note-cell:hover .note-edit-icon {
  opacity: 1;
}

/* Customers table improvements */
.stojaki-page .customers-table {
  -webkit-overflow-scrolling: touch;
}

.stojaki-page .customers-table::-webkit-scrollbar {
  height: 8px;
}

.stojaki-page .customers-table::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.stojaki-page .customers-table::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.stojaki-page .customers-table::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.stojaki-page .customers-table td,
.stojaki-page .customers-table th {
  white-space: nowrap;
}

.stojaki-page .customers-table td:first-child,
.stojaki-page .customers-table td:nth-child(2) {
  white-space: normal;
  min-width: 120px;
}

.stojaki-page .customers-table td:nth-child(10),
.stojaki-page .customers-table td:nth-child(9) {
  white-space: normal;
  min-width: 160px;
}

.stojaki-page .customers-table input[type="text"],
.stojaki-page .customers-table input[type="date"],
.stojaki-page .customers-table input[type="checkbox"] {
  box-sizing: border-box;
  pointer-events: auto;
}

.stojaki-page .customers-table td:last-child {
  white-space: nowrap;
}

.stojaki-page .customers-table tbody tr:hover {
  background: #f0f4ff;
  transition: background-color 0.2s ease;
}

.stojaki-page .customers-table .status-badge {
  white-space: nowrap;
  display: inline-block;
}

.stojaki-page .customers-table td:last-child button {
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,uGAAuG;EACvG,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA,gEAAgE;;AAEhE;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,YAAY;EACZ,kCAAkC;EAClC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,yCAAyC;EACzC,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yCAAyC;EACzC,8DAA8D;AAChE;;AAEA;;;EAGE,kBAAkB;EAClB,0CAA0C;EAC1C,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,0CAA0C;EAC1C,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,4DAA4D;EAC5D,aAAa;AACf;;AAEA;;EAEE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,iCAAiC,eAAe,EAAE;AAClD,+BAA+B,cAAc,EAAE,eAAe,EAAE;;AAEhE;EACE,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,eAAe;EACf,yCAAyC;AAC3C;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA,8BAA8B,cAAc,EAAE;AAC9C,oCAAoC,mBAAmB,EAAE,cAAc,EAAE;AACzE,0BAA0B,WAAW,EAAE,eAAe,EAAE,mBAAmB,EAAE;;AAE7E;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,wCAAwC;AAC1C;;AAEA;;;EAGE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,mEAAmE;AACrE;;AAEA;;EAEE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,aAAa;AACb;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,iBAAiB;EACjB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,OAAO;EACP,SAAS;EACT,SAAS;EACT,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,0DAA0D;AAC5D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,8CAA8C;AAC9C;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;EAC7C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,uBAAuB;AACvB,sBAAsB,gBAAgB,EAAE,cAAc,EAAE;AACxD,6BAA6B,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE;AAC5G,8BAA8B,aAAa,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,eAAe,EAAE,SAAS,EAAE;AACzH;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA,mCAAmC,mBAAmB,EAAE;AACxD,sCAAsC,aAAa,EAAE,mBAAmB,EAAE;AAC1E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,cAAc;AAChB;AACA,0DAA0D,mBAAmB,EAAE;AAC/E,+DAA+D,WAAW,EAAE,YAAY,EAAE;AAC1F,2BAA2B,aAAa,EAAE,SAAS,EAAE;AACrD;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;AACA,kCAAkC,8BAA8B,EAAE,mBAAmB,EAAE;AACvF,qCAAqC,eAAe,EAAE;AACtD,2CAA2C,qBAAqB,EAAE,8CAA8C,EAAE;AAClH;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA,oDAAoD,eAAe,EAAE,eAAe,EAAE,cAAc,EAAE;AACtG,mDAAmD,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE,qBAAqB,EAAE;AAC5H,sDAAsD,cAAc,EAAE,eAAe,EAAE;AACvF;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA,iCAAiC,eAAe,EAAE;;AAElD;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,qBAAqB;EACrB,cAAc;EACd,8DAA8D;AAChE;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;GAIG;;AAEH;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yDAAmP;EACnP,sCAAsC;EACtC,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oBAAoB;;AAEpB,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,2DAA2D;EAC3D,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA,0DAA0D;AAC1D;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,oBAAoB;EACpB,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,4CAA4C;EAC5C,8DAA8D;AAChE;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA,eAAe;AACf;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;AAEF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;IACf,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;IACT,iCAAiC;EACnC;;EAEA;IACE,6BAA6B;EAC/B;;AAEF;;AAEA;EACE;IACE,gBAAgB;EAClB;;AAEF;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,qCAAqC;IACrC,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,kCAAkC;IAClC,UAAU;IACV,eAAe;IACf,yBAAyB;EAC3B;;EAEA,4DAA4D,UAAU,EAAE;;EAExE;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,0CAA0C;IAC1C,4BAA4B;IAC5B,gCAAgC;EAClC;;EAEA,0DAA0D,wBAAwB,EAAE;;EAEpF;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,4BAA4B;IAC5B,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA,mCAAmC,cAAc,EAAE,eAAe,EAAE;EACpE,qCAAqC,cAAc,EAAE,eAAe,EAAE;;EAEtE;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;EACjB;;EAEA;2CACyC,mBAAmB,EAAE,cAAc,EAAE,aAAa,EAAE;;EAE7F;IACE,SAAO;IACP,gBAAgB;IAChB,4BAA4B;IAC5B,aAAa;IACb,iCAAiC;EACnC;;EAEA,2BAA2B,kBAAkB,EAAE;EAC/C,yBAAyB,aAAa,EAAE,oBAAoB,EAAE,QAAQ,EAAE;;EAExE;IACE,YAAY;IACZ,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,gBAAgB;EAClB;;EAEA;;mCAEiC,mBAAmB,EAAE,cAAc,EAAE,aAAa,EAAE;EACrF,0BAA0B,WAAW,EAAE,kBAAkB,EAAE,eAAe,EAAE;;EAE5E;IACE,WAAW;IACX,cAAc;IACd,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,eAAe;EACjB;;EAEA;4CAC0C,mBAAmB,EAAE,cAAc,EAAE,aAAa,EAAE;EAC9F,iCAAiC,qBAAqB,EAAE,eAAe,EAAE,0BAA0B,EAAE;EACrG,uDAAuD,yBAAyB,EAAE;;EAElF;IACE,aAAa;IACb,uBAAuB;IACvB,mCAAmC;EACrC;;EAEA,kCAAkC,uBAAuB,EAAE;EAC3D,iCAAiC,gBAAgB,EAAE;;EAEnD;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,wBAAwB;IACxB,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;IACd,qBAAqB;IACrB,eAAe;EACjB;;EAEA;;sCAEoC,qBAAqB,EAAE,cAAc,EAAE,mBAAmB,EAAE,aAAa,EAAE;;EAE/G;IACE,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;EACjB;;EAEA,uBAAuB,eAAe,EAAE,SAAS,EAAE,UAAU,EAAE,qCAAqC,EAAE;EACtG,6BAA6B,uBAAuB,EAAE,sBAAsB,EAAE;;EAE9E;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;AACF;;AAEA;EACE,cAAc,cAAc,EAAE;EAC9B,aAAa,8BAA8B,EAAE,eAAe,EAAE;EAC9D,gBAAgB,aAAa,EAAE;EAC/B;IACE,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sEAAsE;;AAEtE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAO;EACP,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,0BAA0B;AAC1B,0BAA0B;AAC1B,0BAA0B;;AAE1B;EACE,8CAA8C;EAC9C,iDAAiD;EACjD,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,SAAO;EACP,aAAa;AACf;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B,0BAA0B;AAC1B,0BAA0B;;AAE1B;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;0DAE0D;;AAE1D;EACE,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,kEAAkE;AAClE;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,SAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA,kEAAkE;AAClE;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,kEAAkE;AAClE;EACE,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,+DAA+D;AACjE;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,sBAAsB;AACxB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA,kEAAkE;AAClE;EACE,cAAc,aAAa,EAAE;EAC7B,uBAAuB,WAAW,EAAE;AACtC;;AAEA;;0DAE0D;;AAE1D;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA;;0DAE0D;;AAE1D;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;;oEAEoE;;AAEpE;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAc;EACd,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,OAAO;EACP,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA,UAAU;AACV;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;EAChC,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA,eAAe;AACf;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,2BAA2B;IAC3B,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,yCAAyC;IACzC,UAAU;EACZ;EACA;IACE,uCAAuC;IACvC,UAAU;EACZ;EACA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE,qBAAqB,EAAE,qBAAqB;AAC9C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA,YAAY;AACZ;;;;EAIE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yCAAyC;EACzC,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA,mCAAmC,qBAAqB,EAAE;AAC1D;sDACsD,cAAc,EAAE;;AAEtE,qCAAqC,qBAAqB,EAAE;AAC5D;wDACwD,cAAc,EAAE;;AAExE,kCAAkC,qBAAqB,EAAE;AACzD;qDACqD,cAAc,EAAE;;AAErE,oCAAoC,qBAAqB,EAAE;AAC3D;uDACuD,cAAc,EAAE;;AAEvE,qCAAqC,qBAAqB,EAAE;AAC5D;wDACwD,cAAc,EAAE;;AAExE;EACE,qBAAqB;EACrB,eAAe;EACf,yBAAyB;AAC3B;AACA;8DAC8D,cAAc,EAAE;AAC9E;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,WAAW;AACX;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,oFAAoF;AACpF;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,qCAAqC;IACrC,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,iCAAiC;AACjC;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;EAGE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n  background-color: #f5f5f5;\n  min-height: 100vh;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.auth-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: #4A964E;\n}\n\n.auth-card {\n  background: white;\n  padding: 40px;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  width: 100%;\n  max-width: 400px;\n  animation: dropIn 0.6s ease-out;\n}\n\n.auth-card h2 {\n  text-align: center;\n  margin-bottom: 30px;\n  color: #333;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #555;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 16px;\n  transition: border-color 0.3s;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #4A964E;\n}\n\n.btn {\n  width: 100%;\n  padding: 14px;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.btn-primary {\n  background: #4A964E;\n  color: white;\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.btn-primary:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.btn-secondary {\n  background: #f0f0f0;\n  color: #333;\n  margin-top: 10px;\n}\n\n.btn-secondary:hover {\n  background: #e0e0e0;\n}\n\n.error-message {\n  background: #fee;\n  color: #c00;\n  padding: 12px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.success-message {\n  background: #efe;\n  color: #060;\n  padding: 12px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.auth-switch {\n  text-align: center;\n  margin-top: 20px;\n  color: #666;\n}\n\n.auth-switch a {\n  color: #4A964E;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.auth-switch a:hover {\n  text-decoration: underline;\n}\n\n.auth-links {\n  text-align: center;\n  margin-top: 15px;\n}\n\n.forgot-password-link {\n  color: #666;\n  text-decoration: none;\n  font-size: 14px;\n}\n\n.forgot-password-link:hover {\n  color: #4A964E;\n  text-decoration: underline;\n}\n\n.auth-description {\n  color: #666;\n  margin-bottom: 20px;\n  text-align: center;\n  font-size: 14px;\n}\n\n.countdown-timer {\n  background: #f0fdf4;\n  border: 1px solid #86efac;\n  color: #166534;\n  padding: 10px 15px;\n  border-radius: 8px;\n  text-align: center;\n  margin-bottom: 15px;\n}\n\n.countdown-expired {\n  background: #fef2f2;\n  border: 1px solid #fca5a5;\n  color: #991b1b;\n  padding: 10px 15px;\n  border-radius: 8px;\n  text-align: center;\n  margin-bottom: 15px;\n}\n\n.btn-link {\n  background: none;\n  border: none;\n  color: #4A964E;\n  cursor: pointer;\n  text-decoration: underline;\n  font-size: inherit;\n  padding: 0;\n}\n\n.btn-link:hover {\n  color: #3d7d41;\n}\n\n.btn-link:disabled {\n  color: #999;\n  cursor: not-allowed;\n}\n\n.form-hint {\n  display: block;\n  color: #666;\n  font-size: 12px;\n  margin-top: 5px;\n}\n\n.success-message {\n  background-color: #d4edda;\n  color: #155724;\n  padding: 12px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.btn-secondary {\n  background: #e5e7eb;\n  color: #374151;\n  width: 100%;\n}\n\n.btn-secondary:hover {\n  background: #d1d5db;\n}\n\n/* Dashboard styles */\n.dashboard {\n  min-height: 100vh;\n  background: #f5f5f5;\n}\n\n.navbar {\n  background: white;\n  padding: 16px 24px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.navbar h1 {\n  color: #333;\n  font-size: 24px;\n}\n\n.navbar-right {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.user-info {\n  color: #666;\n}\n\n.btn-logout {\n  padding: 8px 16px;\n  background: #ff4757;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.btn-logout:hover {\n  background: #ff3344;\n}\n\n.dashboard-content {\n  padding: 40px;\n}\n\n.welcome-card {\n  background: white;\n  padding: 40px;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.welcome-card h2 {\n  color: #333;\n  margin-bottom: 16px;\n}\n\n.welcome-card p {\n  color: #666;\n  line-height: 1.6;\n}\n\n.user-details {\n  margin-top: 30px;\n  padding: 20px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  text-align: left;\n}\n\n.user-details h3 {\n  color: #333;\n  margin-bottom: 16px;\n}\n\n.user-details p {\n  margin-bottom: 8px;\n}\n\n.user-details strong {\n  color: #333;\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  font-size: 18px;\n  color: #666;\n}\n\n/* ==================== NEW LAYOUT STYLES ==================== */\n\n.app-layout {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Top Navigation Bar */\n.top-navbar {\n  background: #4A964E;\n  color: white;\n  padding: 0 clamp(8px, 1.1vw, 20px);\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: clamp(8px, 1vw, 20px);\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n}\n\n.navbar-left {\n  display: flex;\n  align-items: center;\n  gap: clamp(8px, 0.9vw, 16px);\n  min-width: 0;\n  flex: 0 0 auto;\n}\n\n.mobile-menu-trigger,\n.mobile-navigation-layer {\n  display: none;\n}\n\n.sidebar-toggle {\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  color: white;\n  font-size: 20px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.3s;\n  flex: 0 0 auto;\n  white-space: nowrap;\n}\n\n.sidebar-toggle:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.app-title {\n  font-size: clamp(16px, 1vw, 20px);\n  font-weight: 600;\n  max-width: clamp(150px, 16vw, 300px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.main-nav {\n  display: flex;\n  gap: clamp(2px, 0.3vw, 6px);\n  flex: 1 1 auto;\n  min-width: 0;\n  justify-content: center;\n  align-items: center;\n}\n\n.header-profile {\n  position: relative;\n  flex: 0 0 auto;\n  padding: 6px 0;\n}\n\n.header-profile-trigger {\n  position: relative;\n  width: 42px;\n  height: 42px;\n  border: 2px solid rgba(255, 255, 255, 0.8);\n  border-radius: 50%;\n  background: #327a37;\n  color: #fff;\n  display: grid;\n  place-items: center;\n  overflow: visible;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);\n  transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;\n}\n\n.header-profile-trigger:hover,\n.header-profile-trigger:focus-visible,\n.header-profile.open .header-profile-trigger {\n  border-color: #fff;\n  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.25);\n  transform: translateY(-1px);\n  outline: none;\n}\n\n.header-profile-trigger img {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.header-profile-badge {\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  width: 10px;\n  height: 10px;\n  border: 2px solid #4A964E;\n  border-radius: 50%;\n  background: #ef4444;\n}\n\n.header-profile-menu {\n  position: absolute;\n  top: calc(100% - 2px);\n  right: 0;\n  width: 280px;\n  max-height: calc(100vh - 70px);\n  overflow-y: auto;\n  padding: 8px;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  background: #fff;\n  color: #1f2937;\n  box-shadow: 0 14px 35px rgba(0, 0, 0, 0.2);\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-8px);\n  transition: opacity 0.18s, visibility 0.18s, transform 0.18s;\n  z-index: 1100;\n}\n\n.header-profile.open .header-profile-menu,\n.header-profile:focus-within .header-profile-menu {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n.header-profile-summary {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  padding: 10px 12px 12px;\n  border-bottom: 1px solid #edf0ed;\n  margin-bottom: 5px;\n  overflow: hidden;\n}\n\n.header-profile-summary strong,\n.header-profile-summary span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.header-profile-summary strong { font-size: 14px; }\n.header-profile-summary span { color: #6b7280; font-size: 12px; }\n\n.header-profile-section-label {\n  margin: 0;\n  padding: 7px 11px 4px;\n  color: #8a938c;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n.header-profile-item {\n  width: 100%;\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  padding: 9px 11px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #374151;\n  text-align: left;\n  text-decoration: none;\n  font: inherit;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n}\n\n.header-profile-item:hover,\n.header-profile-item:focus-visible,\n.header-profile-item.active {\n  outline: none;\n  background: #eaf5eb;\n  color: #327a37;\n}\n\n.header-profile-item.logout { color: #b42318; }\n.header-profile-item.logout:hover { background: #fef2f2; color: #991b1b; }\n.header-profile-divider { height: 1px; margin: 5px 3px; background: #edf0ed; }\n\n.profile-menu-icon {\n  width: 18px;\n  height: 18px;\n  flex: 0 0 18px;\n  color: #6b7280;\n  transition: color 0.15s, transform 0.15s;\n}\n\n.header-profile-item:hover .profile-menu-icon,\n.header-profile-item:focus-visible .profile-menu-icon,\n.header-profile-item.active .profile-menu-icon {\n  color: #327a37;\n  transform: translateX(1px);\n}\n\n.header-profile-item.logout .profile-menu-icon,\n.header-profile-item.logout:hover .profile-menu-icon {\n  color: currentColor;\n}\n\n.nav-link {\n  color: rgba(255, 255, 255, 0.8);\n  text-decoration: none;\n  padding: 8px clamp(6px, 0.55vw, 11px);\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  gap: clamp(3px, 0.3vw, 6px);\n  transition: all 0.3s;\n  font-size: clamp(12px, 0.72vw, 14px);\n  line-height: 1.15;\n  white-space: nowrap;\n}\n\n.nav-link:hover {\n  background: rgba(255, 255, 255, 0.15);\n  color: white;\n}\n\n.nav-link.active {\n  background: rgba(255, 255, 255, 0.25);\n  color: white;\n}\n\n.nav-icon {\n  font-size: 16px;\n  flex: 0 0 auto;\n}\n\n.nav-label {\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n/* Nav Dropdown */\n.nav-dropdown-container {\n  position: relative;\n  flex: 0 0 auto;\n}\n\n.dropdown-arrow {\n  font-size: 10px;\n  margin-left: 1px;\n  transition: transform 0.2s;\n  flex: 0 0 auto;\n}\n\n.nav-dropdown-container:hover .dropdown-arrow {\n  transform: rotate(180deg);\n}\n\n.nav-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  min-width: 200px;\n  padding: 8px 0;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-10px);\n  transition: all 0.2s ease;\n  z-index: 1000;\n}\n\n.nav-dropdown-container:hover .nav-dropdown {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n.nav-dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 16px;\n  color: #333;\n  text-decoration: none;\n  font-size: 14px;\n  transition: background 0.2s;\n}\n\n.nav-dropdown-item:hover {\n  background: #f5f5f5;\n}\n\n.nav-dropdown-item .nav-icon {\n  font-size: 16px;\n}\n\n.nav-dropdown-group {\n  position: relative;\n}\n\n.nav-dropdown-nested-arrow {\n  margin-left: auto;\n  color: #6b7280;\n  font-size: 20px;\n  line-height: 1;\n}\n\n.nav-dropdown-submenu {\n  position: absolute;\n  top: -8px;\n  left: 100%;\n  min-width: 220px;\n  padding: 8px 0;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  opacity: 0;\n  visibility: hidden;\n  transform: translateX(-6px);\n  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s;\n}\n\n.nav-dropdown-group:hover > .nav-dropdown-submenu,\n.nav-dropdown-group:focus-within > .nav-dropdown-submenu {\n  opacity: 1;\n  visibility: visible;\n  transform: translateX(0);\n}\n\n/* App Body */\n.app-body {\n  display: flex;\n  margin-top: 60px;\n  min-height: calc(100vh - 60px);\n}\n\n/* Left Sidebar */\n.sidebar {\n  width: 260px;\n  background: white;\n  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.05);\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  left: 0;\n  top: 60px;\n  bottom: 0;\n  transition: transform 0.3s, width 0.3s;\n  z-index: 100;\n  overflow-y: auto;\n}\n\n.sidebar.closed {\n  transform: translateX(-260px);\n}\n\n.user-profile-section {\n  padding: 24px 20px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  border-bottom: 1px solid #eee;\n  background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);\n}\n\n.user-avatar {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background: #4A964E;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.2s;\n  overflow: hidden;\n}\n\n.user-avatar-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.user-avatar-initial {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.user-avatar:hover {\n  transform: scale(1.05);\n}\n\n.user-info-sidebar {\n  display: flex;\n  flex-direction: column;\n}\n\n.user-name {\n  font-weight: 600;\n  color: #333;\n  font-size: 15px;\n}\n\n.user-email {\n  font-size: 12px;\n  color: #888;\n  margin-top: 2px;\n}\n\n.profile-menu {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.3s;\n  background: #f8f9fa;\n}\n\n.profile-menu.open {\n  max-height: 200px;\n}\n\n.profile-menu-item {\n  padding: 12px 20px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  transition: background 0.2s;\n  color: #555;\n  font-size: 14px;\n  text-decoration: none;\n}\n\n.profile-menu-item:hover {\n  background: #eee;\n  color: #333;\n}\n\n/* Sidebar Navigation Links - Always Visible */\n.sidebar-nav-links {\n  padding: 8px 12px;\n  border-bottom: 1px solid #eee;\n}\n\n.sidebar-nav-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n  color: #555;\n  font-size: 14px;\n  text-decoration: none;\n  background: none;\n  border: none;\n  width: 100%;\n  text-align: left;\n}\n\n.sidebar-nav-item:hover {\n  background: #f0f0f0;\n  color: #4A964E;\n}\n\n.sidebar-nav-item.active {\n  background: #e8f5e9;\n  color: #4A964E;\n  font-weight: 500;\n}\n\n.sidebar-nav-item.notifications-trigger {\n  position: relative;\n}\n\n.sidebar-nav-item .notification-badge {\n  margin-left: auto;\n}\n\n/* Notifications styles */\n.notifications-trigger {\n  position: relative;\n}\n\n.notification-badge {\n  background: #ef4444;\n  color: white;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 6px;\n  border-radius: 10px;\n  min-width: 18px;\n  text-align: center;\n  margin-left: auto;\n}\n\n.notifications-dropdown {\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  margin: 8px 12px;\n  max-height: 600px;\n  min-width: 380px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.notifications-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  border-bottom: 1px solid #e5e7eb;\n  background: #f9fafb;\n}\n\n.notifications-header h4 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.mark-all-read-btn {\n  background: none;\n  border: none;\n  color: #2563eb;\n  font-size: 12px;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: background 0.2s;\n}\n\n.mark-all-read-btn:hover {\n  background: #eff6ff;\n}\n\n.notifications-list {\n  overflow-y: auto;\n  max-height: 540px;\n}\n\n.notification-item {\n  display: flex;\n  align-items: flex-start;\n  padding: 12px 16px;\n  border-bottom: 1px solid #f3f4f6;\n  cursor: pointer;\n  transition: background 0.2s;\n  position: relative;\n}\n\n.notification-item:hover {\n  background: #f9fafb;\n}\n\n.notification-item.unread {\n  background: #eff6ff;\n}\n\n.notification-item.unread:hover {\n  background: #dbeafe;\n}\n\n.notification-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.notification-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 4px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.notification-message {\n  font-size: 12px;\n  color: #6b7280;\n  margin-bottom: 4px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  white-space: pre-line;\n}\n\n.notification-time {\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n.unread-indicator {\n  width: 8px;\n  height: 8px;\n  background: #2563eb;\n  border-radius: 50%;\n  margin-left: 8px;\n  margin-top: 4px;\n  flex-shrink: 0;\n}\n\n.notification-delete-btn {\n  background: none;\n  border: none;\n  color: #f87171;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 8px;\n  transition: color 0.2s, background-color 0.2s;\n  margin-left: 8px;\n  flex-shrink: 0;\n}\n\n.notification-delete-btn:hover {\n  background: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n}\n\n.notification-delete-btn:focus-visible {\n  outline: 2px solid #ef4444;\n  outline-offset: 2px;\n}\n\n.notification-delete-icon {\n  display: block;\n  width: 16px;\n  height: 16px;\n}\n\n/* Notifications Modal */\n.notifications-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.notifications-modal {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  width: 100%;\n  max-width: 600px;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.notifications-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e5e7eb;\n  background: #f9fafb;\n}\n\n.notifications-modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.notifications-modal-close {\n  background: none;\n  border: none;\n  font-size: 20px;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.notifications-modal-close:hover {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.notifications-modal-actions {\n  padding: 12px 24px;\n  border-bottom: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.notifications-modal-actions:empty {\n  display: none;\n}\n\n.notifications-modal-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 8px 0;\n}\n\n.notifications-modal-list .notification-item {\n  margin: 0 12px 8px;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n}\n\n.notifications-modal-list .notification-item:last-child {\n  margin-bottom: 12px;\n}\n\n/* Responsive styles for notifications modal */\n@media (max-width: 768px) {\n  .notifications-modal-overlay {\n    padding: 10px;\n  }\n\n  .notifications-modal {\n    max-height: 90vh;\n  }\n\n  .notifications-modal-header {\n    padding: 16px 20px;\n  }\n\n  .notifications-modal-header h3 {\n    font-size: 16px;\n  }\n\n  .notifications-modal-actions {\n    padding: 10px 20px;\n  }\n\n  .notifications-modal-list .notification-item {\n    margin: 0 8px 8px;\n  }\n}\n\n.no-notifications {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  color: #9ca3af;\n}\n\n.no-notifications-icon {\n  font-size: 32px;\n  margin-bottom: 8px;\n}\n\n.no-notifications p {\n  margin: 0;\n  font-size: 14px;\n}\n\n/* Notifications page */\n.notifications-page { max-width: 960px; margin: 0 auto; }\n.notifications-page-header { display: flex; align-items: center; justify-content: space-between; gap: 20px; }\n.notifications-page-actions { display: flex; align-items: center; justify-content: flex-end; flex-wrap: wrap; gap: 10px; }\n.notifications-page-action {\n  padding: 10px 15px;\n  border: 1px solid #4A964E;\n  border-radius: 8px;\n  background: #fff;\n  color: #327a37;\n  font-weight: 600;\n  cursor: pointer;\n}\n.notifications-page-action:hover { background: #eaf5eb; }\n.notifications-page-action:disabled { opacity: 0.55; cursor: not-allowed; }\n.notifications-page-action--danger {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  border-color: #f87171;\n  color: #dc2626;\n}\n.notifications-page-action--danger:hover:not(:disabled) { background: #fef2f2; }\n.notifications-page-action--danger .notification-delete-icon { width: 16px; height: 16px; }\n.notifications-page-list { display: grid; gap: 10px; }\n.notifications-page-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 18px;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n.notifications-page-item.unread { border-left: 4px solid #4A964E; background: #f4fbf4; }\n.notifications-page-item.clickable { cursor: pointer; }\n.notifications-page-item.clickable:hover { border-color: #9aca9d; box-shadow: 0 4px 14px rgba(74, 150, 78, 0.12); }\n.notifications-page-icon {\n  width: 36px;\n  height: 36px;\n  flex: 0 0 36px;\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  background: #eaf5eb;\n  color: #327a37;\n  font-weight: 700;\n}\n.notifications-page-item .notification-content h3 { margin: 0 0 5px; font-size: 15px; color: #1f2937; }\n.notifications-page-item .notification-content p { margin: 0 0 8px; color: #4b5563; font-size: 14px; white-space: pre-line; }\n.notifications-page-item .notification-content time { color: #9ca3af; font-size: 12px; }\n.notifications-page-state {\n  min-height: 220px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  border: 1px dashed #d1d5db;\n  border-radius: 12px;\n  background: #fff;\n  color: #6b7280;\n}\n.notifications-page-state span { font-size: 34px; }\n\n.menu-icon {\n  font-size: 16px;\n}\n\n.sidebar-divider {\n  height: 1px;\n  background: #eee;\n  margin: 10px 0;\n}\n\n.sidebar-section {\n  padding: 16px 20px;\n}\n\n.sidebar-section-title {\n  font-size: 11px;\n  text-transform: uppercase;\n  color: #999;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  margin-bottom: 12px;\n}\n\n.sidebar-link {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  border-radius: 6px;\n  color: #555;\n  text-decoration: none;\n  font-size: 14px;\n  transition: all 0.2s;\n  margin-bottom: 4px;\n}\n\n.sidebar-link:hover {\n  background: #f0f0f0;\n  color: #4A964E;\n}\n\n.sidebar-info {\n  font-size: 13px;\n  color: #666;\n}\n\n.sidebar-info p {\n  margin-bottom: 8px;\n}\n\n.sidebar-footer {\n  margin-top: auto;\n  padding: 20px;\n  border-top: 1px solid #eee;\n}\n\n.btn-logout-sidebar {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 12px;\n  background: #ff4757;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background 0.2s;\n}\n\n.btn-logout-sidebar:hover {\n  background: #ff3344;\n}\n\n/* Main Content */\n.main-content {\n  flex: 1;\n  margin-left: 260px;\n  padding: 24px;\n  background: #f5f5f5;\n  transition: margin-left 0.3s;\n}\n\n.main-content.expanded {\n  margin-left: 0;\n}\n\n/* Page Styles */\n.page-container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.page-header {\n  margin-bottom: 24px;\n}\n\n.page-header h2 {\n  font-size: 28px;\n  color: #333;\n  margin-bottom: 8px;\n}\n\n.page-header p {\n  color: #666;\n  font-size: 15px;\n}\n\n.page-content {\n  background: white;\n  border-radius: 12px;\n  padding: 30px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n/* Blank Page Card */\n.blank-page-card {\n  text-align: center;\n  padding: 60px 20px;\n}\n\n.blank-icon {\n  font-size: 64px;\n  margin-bottom: 20px;\n  display: block;\n}\n\n.blank-page-card h3 {\n  font-size: 24px;\n  color: #333;\n  margin-bottom: 12px;\n}\n\n.blank-page-card p {\n  color: #666;\n  font-size: 16px;\n  margin-bottom: 8px;\n}\n\n.coming-soon {\n  display: inline-block;\n  margin-top: 20px;\n  padding: 8px 20px;\n  background: #4A964E;\n  color: white;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n/* Tiles Grid */\n.module-page-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.module-page-title > svg {\n  width: 30px;\n  height: 30px;\n  flex-shrink: 0;\n  color: #2563eb;\n  stroke-width: 1.8;\n}\n\n.module-tile .module-tile-icon {\n  display: grid;\n  width: 72px;\n  height: 72px;\n  margin-bottom: 20px;\n  border-radius: 20px;\n  background: #eff6ff;\n  color: #2563eb;\n  place-items: center;\n  transition: transform 0.2s ease;\n}\n\n.module-tile-icon > svg {\n  width: 36px;\n  height: 36px;\n}\n\n.module-tile:hover .module-tile-icon {\n  transform: scale(1.06);\n}\n\n.sales-module-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.sales-module-title svg {\n  width: 30px;\n  height: 30px;\n  flex-shrink: 0;\n  color: #2563eb;\n  stroke-width: 1.8;\n}\n\n.tiles-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 24px;\n}\n\n.tile-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 40px 24px;\n  background: white;\n  border-radius: 12px;\n  border: 1px solid #e9ecef;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  text-decoration: none;\n  color: inherit;\n  transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;\n}\n\n.tile-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  border-color: #4A964E;\n}\n\n.tile-icon {\n  font-size: 56px;\n  margin-bottom: 16px;\n}\n\n.tile-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #333;\n  margin: 0 0 8px 0;\n}\n\n.tile-description {\n  font-size: 14px;\n  color: #666;\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* Stats Grid */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-top: 30px;\n}\n\n.stat-card {\n  background: #f8f9fa;\n  padding: 24px;\n  border-radius: 10px;\n  text-align: center;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.stat-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.stat-icon {\n  font-size: 32px;\n  margin-bottom: 12px;\n  display: block;\n}\n\n.stat-card h4 {\n  color: #333;\n  margin-bottom: 8px;\n}\n\n.stat-card p {\n  color: #888;\n  font-size: 13px;\n}\n\n/* Profile Page */\n.profile-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 30px;\n}\n\n.profile-avatar-large {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  background: #4A964E;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 40px;\n  font-weight: 600;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.profile-avatar-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.profile-avatar-initial {\n  font-size: 40px;\n  font-weight: 600;\n}\n\n.profile-details h3 {\n  font-size: 24px;\n  color: #333;\n  margin-bottom: 4px;\n}\n\n.profile-email {\n  color: #666;\n  font-size: 15px;\n  margin-bottom: 20px;\n}\n\n/* .profile-info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 16px;\n} */\n\n.profile-info-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 16px;\n}\n\n.profile-info-item label {\n  display: block;\n  font-size: 12px;\n  color: #888;\n  text-transform: uppercase;\n  margin-bottom: 4px;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.status-badge.active {\n  background: #d4edda;\n  color: #155724;\n}\n\n.status-badge.inactive {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n/* Profile Page - Edit Form */\n.profile-input {\n  padding: 8px 12px;\n  font-size: 14px;\n  border: 2px solid #e9ecef;\n  border-radius: 6px;\n  width: 100%;\n  max-width: 200px;\n  transition: border-color 0.2s;\n}\n\n.profile-input:focus {\n  outline: none;\n  border-color: #4A964E;\n}\n\n.profile-actions {\n  margin-top: 24px;\n  display: flex;\n  gap: 12px;\n}\n\n.btn-primary {\n  padding: 10px 20px;\n  background: #4A964E;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: opacity 0.2s, transform 0.2s;\n}\n\n.btn-primary:hover:not(:disabled) {\n  opacity: 0.9;\n  transform: translateY(-1px);\n}\n\n.btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-secondary {\n  padding: 10px 20px;\n  background: #f8f9fa;\n  color: #333;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: #e9ecef;\n}\n\n.btn-secondary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.message {\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n\n.message.success {\n  background: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.message.error {\n  background: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.message.info {\n  background: #cce5ff;\n  color: #004085;\n  border: 1px solid #b8daff;\n}\n\n/* Settings Page */\n.settings-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  padding: 32px;\n  max-width: 600px;\n}\n\n.settings-form {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n.form-section {\n  border-bottom: 1px solid #eee;\n  padding-bottom: 24px;\n}\n\n.form-section:last-of-type {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.form-section-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n  margin: 0 0 4px 0;\n}\n\n.form-section-desc {\n  font-size: 13px;\n  color: #888;\n  margin: 0 0 20px 0;\n}\n\n.form-group {\n  margin-bottom: 16px;\n}\n\n.form-group:last-child {\n  margin-bottom: 0;\n}\n\n.form-group label {\n  display: block;\n  font-size: 13px;\n  font-weight: 500;\n  color: #555;\n  margin-bottom: 6px;\n}\n\n.form-input {\n  width: 100%;\n  padding: 12px 14px;\n  font-size: 15px;\n  border: 2px solid #e9ecef;\n  border-radius: 8px;\n  background: white;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  box-sizing: border-box;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #4A964E;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15);\n}\n\n.form-input.disabled {\n  background: #f5f5f5;\n  color: #888;\n  cursor: not-allowed;\n}\n\n.form-select {\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e\");\n  background-position: right 12px center;\n  background-repeat: no-repeat;\n  background-size: 16px;\n  padding-right: 40px;\n}\n\n.status-info {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.status-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.status-label {\n  font-size: 14px;\n  color: #666;\n  min-width: 120px;\n}\n\n.form-actions {\n  display: flex;\n  gap: 12px;\n  padding-top: 8px;\n}\n\n/* Avatar Section */\n.avatar-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.avatar-preview {\n  position: relative;\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  overflow: hidden;\n  border: 3px solid #e9ecef;\n  transition: border-color 0.2s;\n}\n\n.avatar-preview:hover {\n  border-color: #4A964E;\n}\n\n.avatar-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.avatar-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #4A964E 0%, #3d7a40 100%);\n  color: white;\n}\n\n.avatar-initial {\n  font-size: 48px;\n  font-weight: 600;\n}\n\n.avatar-loading {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.8);\n  font-size: 24px;\n}\n\n.avatar-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.avatar-actions button {\n  flex: 1;\n  min-width: 0;\n  transition: background 0.2s, transform 0.15s ease;\n}\n\n.avatar-actions button:hover:not(:disabled) {\n  transform: scale(1.05);\n}\n\n.avatar-message {\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 13px;\n  text-align: center;\n}\n\n.avatar-message.success {\n  background: #d4edda;\n  color: #155724;\n}\n\n.avatar-message.error {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n.btn-danger {\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n  background: #dc3545;\n  color: white;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background: #c82333;\n}\n\n.btn-danger:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Colleagues Page */\n\n/* Toolbar: search + view toggle side by side */\n.colleagues-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin-bottom: 24px;\n}\n\n.colleagues-search {\n  flex: 1;\n  margin: 0 !important;\n}\n\n/* Segmented view toggle */\n.view-toggle {\n  display: flex;\n  background: #eef2f7;\n  border: 1px solid #dbe3ed;\n  border-radius: 8px;\n  padding: 3px;\n  flex-shrink: 0;\n}\n\n.view-toggle-btn {\n  padding: 7px 16px;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #6c757d;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s, box-shadow 0.15s;\n  white-space: nowrap;\n  font-family: inherit;\n}\n\n.view-toggle-btn.active {\n  background: white;\n  color: #25643a;\n  box-shadow: 0 1px 5px rgba(15, 23, 42, 0.14);\n}\n\n.view-toggle-btn:not(.active):hover {\n  color: #343a40;\n}\n\n/* Position label in card view (below name, above email) */\n.colleague-position-compact {\n  min-height: 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #3f7d46;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Search Bar */\n.search-container {\n  position: relative;\n  margin-bottom: 24px;\n}\n\n.search-container.employee-search {\n  margin-bottom: 16px;\n}\n\n.search-input {\n  width: 100%;\n  padding: 14px 50px 14px 20px;\n  font-size: 15px;\n  border: 2px solid #e9ecef;\n  border-radius: 10px;\n  background: white;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #4A964E;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15);\n}\n\n.search-input::placeholder {\n  color: #adb5bd;\n}\n\n.search-clear {\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: #e9ecef;\n  border: none;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 12px;\n  color: #666;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n}\n\n.search-clear:hover {\n  background: #dee2e6;\n}\n\n.no-results {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n  font-size: 16px;\n}\n\n.colleagues-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n  min-width: 0;\n}\n\n.department-section {\n  background: white;\n  border-radius: 12px;\n  border: 1px solid #e3e9ef;\n  box-shadow: 0 8px 26px rgba(15, 23, 42, 0.06);\n  overflow: hidden;\n}\n\n.department-section-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n  padding: 17px 22px;\n  background: #ffffff;\n  color: #1f2937;\n  border-bottom: 1px solid #e7edf3;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.department-section-header:hover {\n  background: #f8fbf8;\n}\n\n.department-section-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.department-badge {\n  flex: 0 0 auto;\n  background: #edf7ee;\n  color: #25643a;\n  padding: 5px 12px;\n  border: 1px solid #cfe8d1;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.expand-arrow {\n  flex: 0 0 auto;\n  font-size: 12px;\n  color: #64748b;\n  transition: transform 0.3s ease;\n}\n\n.expand-arrow.open {\n  transform: rotate(180deg);\n}\n\n.colleagues-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  align-items: stretch;\n  justify-items: stretch;\n  gap: 16px;\n  width: 100%;\n  min-width: 0;\n  padding: 20px;\n}\n\n.colleague-card-compact {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  min-width: 0;\n  width: 100%;\n  min-height: 236px;\n  height: 100%;\n  padding: 20px 16px 16px;\n  background: #fbfcfd;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;\n}\n\n.colleague-card-compact:hover {\n  border-color: #b7d9bd;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.1);\n  transform: translateY(-2px);\n}\n\n.colleague-avatar-compact {\n  flex: 0 0 64px;\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: #4A964E;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 14px;\n  overflow: hidden;\n  box-shadow: 0 0 0 4px #edf7ee;\n}\n\n.colleague-avatar-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.colleague-avatar-initial {\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.colleague-details-compact {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: stretch;\n  width: 100%;\n  min-width: 0;\n}\n\n.colleague-details-compact h4 {\n  margin: 0 0 5px 0;\n  min-height: 36px;\n  color: #172033;\n  font-size: 15px;\n  font-weight: 750;\n  line-height: 1.2;\n  display: -webkit-box;\n  overflow: hidden;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow-wrap: anywhere;\n}\n\n.colleague-details-compact h4,\n.colleague-position-compact,\n.colleague-email-compact,\n.colleague-phone-compact {\n  min-width: 0;\n}\n\n.colleague-details-compact h4:only-child {\n  white-space: nowrap;\n}\n\n.colleague-card-divider {\n  border: none;\n  border-top: 1px solid #e5ebf1;\n  margin: 12px 0 10px 0;\n}\n\n.colleague-contact-icon {\n  width: 13px;\n  height: 13px;\n  flex-shrink: 0;\n  color: #888;\n  margin-right: 5px;\n  vertical-align: middle;\n  position: relative;\n  top: -1px;\n}\n\n.colleague-email-compact {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 18px;\n  margin: 0 0 6px 0;\n  color: #526070;\n  font-size: 12px;\n  line-height: 1.35;\n}\n\n.colleague-email-compact span {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.colleague-job-title-compact {\n  font-size: 11px;\n  color: #666;\n  margin: 0 0 4px 0;\n  font-weight: 500;\n}\n\n.colleague-phone-compact {\n  min-height: 18px;\n  margin: 0 0 12px 0;\n  overflow: hidden;\n  color: #64748b;\n  font-size: 12px;\n  line-height: 1.35;\n  text-align: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.status-badge-small {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  align-self: center;\n  margin-top: auto;\n  min-height: 24px;\n  padding: 3px 9px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.status-badge-small.active {\n  background: #d4edda;\n  color: #155724;\n}\n\n.status-badge-small.inactive {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n/* ── List view ── */\n.colleagues-list-view {\n  overflow-x: auto;\n  padding: 0;\n}\n\n.colleagues-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.colleagues-table thead tr {\n  background: #f8f9fa;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.colleagues-table th {\n  padding: 10px 14px;\n  text-align: left;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #6c757d;\n  white-space: nowrap;\n}\n\n.colleagues-table th:first-child {\n  width: 48px;\n  padding-left: 16px;\n}\n\n.colleagues-table tbody tr {\n  border-bottom: 1px solid #f0f0f0;\n  transition: background 0.1s;\n}\n\n.colleagues-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.colleagues-table tbody tr:hover {\n  background: #f8fdf8;\n}\n\n.colleagues-table td {\n  padding: 10px 14px;\n  vertical-align: middle;\n  color: #333;\n}\n\n.colleagues-table td:first-child {\n  padding-left: 16px;\n}\n\n/* Small avatar circle for list rows */\n.col-list-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #4A964E;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 600;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.col-list-avatar-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n.col-list-name {\n  font-weight: 600;\n  color: #1a1a1a;\n  white-space: nowrap;\n}\n\n.col-list-position {\n  color: #4A964E;\n  font-weight: 500;\n}\n\n.col-list-email {\n  color: #555;\n}\n\n.col-list-phone {\n  color: #777;\n  white-space: nowrap;\n}\n.colleagues-list {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.colleague-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 24px;\n  padding: 20px;\n  background: #f8f9fa;\n  border-radius: 10px;\n  border: 1px solid #e9ecef;\n  transition: box-shadow 0.2s, transform 0.2s;\n}\n\n.colleague-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.colleague-card .profile-avatar-large {\n  width: 80px;\n  height: 80px;\n  font-size: 32px;\n}\n\n.colleague-card .profile-details h3 {\n  font-size: 20px;\n  margin-bottom: 2px;\n}\n\n.colleague-card .profile-email {\n  margin-bottom: 16px;\n}\n\n.colleague-card .profile-info-grid {\n  gap: 16px;\n}\n\n/* Responsive */\n@media (max-width: 1440px) {\n  .app-title {\n    max-width: 190px;\n  }\n\n  .nav-link {\n    max-width: 112px;\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n\n}\n\n@media (max-width: 1220px) {\n  .nav-label {\n    display: none;\n  }\n  \n  .nav-link {\n    width: 40px;\n    max-width: 40px;\n    padding: 8px 0;\n    justify-content: center;\n  }\n\n  .dropdown-arrow {\n    display: none;\n  }\n\n  .nav-dropdown {\n    left: 50%;\n    transform: translate(-50%, -10px);\n  }\n\n  .nav-dropdown-container:hover .nav-dropdown {\n    transform: translate(-50%, 0);\n  }\n\n}\n\n@media (max-width: 900px) {\n  .app-title {\n    max-width: 160px;\n  }\n\n}\n\n@media (max-width: 768px) {\n  .main-content {\n    margin-left: 0;\n    width: 100%;\n    min-width: 0;\n    padding: 16px;\n    overflow-x: hidden;\n  }\n  \n  .main-nav {\n    display: none;\n  }\n\n  .top-navbar {\n    justify-content: space-between;\n    gap: 8px;\n  }\n\n  .navbar-left {\n    flex: 1 1 auto;\n    overflow: hidden;\n  }\n\n  .app-title {\n    max-width: calc(100vw - 120px);\n    font-size: 16px;\n  }\n\n  .mobile-menu-trigger {\n    width: 40px;\n    height: 40px;\n    flex: 0 0 40px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n    padding: 0;\n    border: 0;\n    border-radius: 8px;\n    background: rgba(255, 255, 255, 0.12);\n    color: #fff;\n    cursor: pointer;\n  }\n\n  .mobile-menu-trigger:hover,\n  .mobile-menu-trigger:focus-visible {\n    background: rgba(255, 255, 255, 0.22);\n    outline: 2px solid rgba(255, 255, 255, 0.9);\n    outline-offset: 1px;\n  }\n\n  .mobile-menu-trigger span {\n    width: 20px;\n    height: 2px;\n    border-radius: 2px;\n    background: currentColor;\n  }\n\n  .mobile-navigation-layer {\n    position: fixed;\n    inset: 0;\n    z-index: 1200;\n    display: block;\n    visibility: hidden;\n    pointer-events: none;\n    transition: visibility 0.25s;\n  }\n\n  .mobile-navigation-layer.open {\n    visibility: visible;\n    pointer-events: auto;\n  }\n\n  .mobile-navigation-backdrop {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    padding: 0;\n    border: 0;\n    background: rgba(15, 23, 42, 0.48);\n    opacity: 0;\n    cursor: default;\n    transition: opacity 0.25s;\n  }\n\n  .mobile-navigation-layer.open .mobile-navigation-backdrop { opacity: 1; }\n\n  .mobile-navigation-drawer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: min(86vw, 340px);\n    display: flex;\n    flex-direction: column;\n    background: #fff;\n    color: #1f2937;\n    box-shadow: 8px 0 30px rgba(0, 0, 0, 0.22);\n    transform: translateX(-102%);\n    transition: transform 0.25s ease;\n  }\n\n  .mobile-navigation-layer.open .mobile-navigation-drawer { transform: translateX(0); }\n\n  .mobile-navigation-header {\n    min-height: 72px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 12px 14px 12px 18px;\n    border-bottom: 1px solid #e5e7eb;\n    background: #f7faf7;\n  }\n\n  .mobile-navigation-header > div {\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n  }\n\n  .mobile-navigation-header strong { color: #285f2c; font-size: 18px; }\n  .mobile-navigation-header div span { color: #6b7280; font-size: 12px; }\n\n  .mobile-navigation-close {\n    width: 40px;\n    height: 40px;\n    flex: 0 0 40px;\n    border: 0;\n    border-radius: 8px;\n    background: transparent;\n    color: #4b5563;\n    font-size: 30px;\n    line-height: 1;\n    cursor: pointer;\n  }\n\n  .mobile-navigation-close:hover,\n  .mobile-navigation-close:focus-visible { background: #eaf5eb; color: #285f2c; outline: none; }\n\n  .mobile-navigation-list {\n    flex: 1;\n    overflow-y: auto;\n    overscroll-behavior: contain;\n    padding: 12px;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .mobile-navigation-group { margin-bottom: 3px; }\n  .mobile-navigation-row { display: flex; align-items: stretch; gap: 3px; }\n\n  .mobile-navigation-link {\n    min-width: 0;\n    flex: 1;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 11px 12px;\n    border-radius: 9px;\n    color: #374151;\n    text-decoration: none;\n    font-size: 15px;\n    font-weight: 700;\n  }\n\n  .mobile-navigation-link:hover,\n  .mobile-navigation-link:focus-visible,\n  .mobile-navigation-link.active { background: #eaf5eb; color: #327a37; outline: none; }\n  .mobile-navigation-icon { width: 22px; text-align: center; font-size: 18px; }\n\n  .mobile-navigation-expand {\n    width: 42px;\n    flex: 0 0 42px;\n    border: 0;\n    border-radius: 9px;\n    background: transparent;\n    color: #6b7280;\n    cursor: pointer;\n  }\n\n  .mobile-navigation-expand:hover,\n  .mobile-navigation-expand:focus-visible { background: #edf3ed; color: #327a37; outline: none; }\n  .mobile-navigation-expand span { display: inline-block; font-size: 20px; transition: transform 0.2s; }\n  .mobile-navigation-expand[aria-expanded=\"true\"] span { transform: rotate(180deg); }\n\n  .mobile-navigation-submenu {\n    display: grid;\n    grid-template-rows: 0fr;\n    transition: grid-template-rows 0.2s;\n  }\n\n  .mobile-navigation-submenu.open { grid-template-rows: 1fr; }\n  .mobile-navigation-submenu > * { overflow: hidden; }\n\n  .mobile-navigation-sublink {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-height: 38px;\n    margin: 2px 4px 2px 34px;\n    padding: 8px 10px;\n    border-left: 2px solid #dbe7dc;\n    color: #58605a;\n    text-decoration: none;\n    font-size: 13px;\n  }\n\n  .mobile-navigation-sublink:hover,\n  .mobile-navigation-sublink:focus-visible,\n  .mobile-navigation-sublink.active { border-color: #4A964E; color: #327a37; background: #f4f9f4; outline: none; }\n\n  .mobile-navigation-sublink--nested {\n    margin-left: 52px;\n    border-left-color: #c9d9ca;\n    font-size: 12px;\n  }\n\n  .header-profile-menu { position: fixed; top: 56px; right: 8px; width: min(280px, calc(100vw - 16px)); }\n  .notifications-page-header { align-items: flex-start; flex-direction: column; }\n\n  .colleagues-toolbar {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .view-toggle {\n    width: 100%;\n  }\n\n  .view-toggle-btn {\n    flex: 1;\n  }\n}\n\n@media (max-width: 480px) {\n  .top-navbar { padding: 0 8px; }\n  .app-title { max-width: calc(100vw - 116px); font-size: 14px; }\n  .main-content { padding: 12px; }\n  .colleagues-row {\n    grid-template-columns: 1fr;\n    padding: 14px;\n  }\n\n  .department-section-header {\n    align-items: flex-start;\n    flex-wrap: wrap;\n    padding: 15px 16px;\n  }\n\n  .department-section-header h3 {\n    flex-basis: 100%;\n  }\n\n  .department-badge {\n    font-size: 12px;\n  }\n}\n\n/* ==================== COLLEAGUES PANEL STYLES ==================== */\n\n.sidebar-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.sidebar-section-header.clickable {\n  cursor: pointer;\n  padding: 8px;\n  margin: -8px;\n  border-radius: 6px;\n  transition: background 0.2s;\n}\n\n.sidebar-section-header.clickable:hover {\n  background: #f0f0f0;\n}\n\n.sidebar-section-header .sidebar-section-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 0;\n}\n\n.expand-icon {\n  font-size: 10px;\n  color: #888;\n  transition: transform 0.3s;\n}\n\n.expand-icon.open {\n  transform: rotate(180deg);\n}\n\n.expand-icon.small {\n  font-size: 8px;\n}\n\n.colleagues-panel {\n  margin-top: 12px;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.loading-text,\n.no-colleagues {\n  font-size: 12px;\n  color: #888;\n  text-align: center;\n  padding: 10px;\n}\n\n.department-group {\n  margin-bottom: 8px;\n  border-radius: 6px;\n  background: #f8f9fa;\n  overflow: hidden;\n}\n\n.department-header {\n  display: flex;\n  align-items: center;\n  padding: 10px 12px;\n  cursor: pointer;\n  transition: background 0.2s;\n  gap: 6px;\n}\n\n.department-header:hover {\n  background: #eee;\n}\n\n.department-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #444;\n  flex: 1;\n  text-transform: capitalize;\n}\n\n.department-count {\n  font-size: 11px;\n  color: #888;\n  background: #ddd;\n  padding: 2px 6px;\n  border-radius: 10px;\n}\n\n.department-colleagues {\n  border-top: 1px solid #eee;\n  background: white;\n}\n\n.colleague-item {\n  display: flex;\n  align-items: flex-start;\n  padding: 10px 12px;\n  gap: 10px;\n  border-bottom: 1px solid #f0f0f0;\n  transition: background 0.2s;\n}\n\n.colleague-item:last-child {\n  border-bottom: none;\n}\n\n.colleague-item:hover {\n  background: #f8f9fa;\n}\n\n.colleague-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #4A964E;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.colleague-info {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.colleague-name {\n  font-size: 13px;\n  font-weight: 500;\n  color: #333;\n}\n\n.colleague-email {\n  font-size: 11px;\n  color: #888;\n  word-break: break-all;\n}\n\n.colleague-phone {\n  font-size: 11px;\n  color: #4A964E;\n  margin-top: 2px;\n}\n\n/* ===================== */\n/* Admin Panel Styles    */\n/* ===================== */\n\n.sidebar-section.admin-section {\n  border-top: 1px solid rgba(102, 126, 234, 0.3);\n  border-bottom: 1px solid rgba(102, 126, 234, 0.3);\n  background: rgba(102, 126, 234, 0.05);\n  margin: 10px -15px;\n  padding: 10px 15px;\n}\n\n.sidebar-link.admin-link {\n  color: #4A964E;\n  font-weight: 600;\n}\n\n.sidebar-link.admin-link:hover {\n  background: rgba(102, 126, 234, 0.15);\n}\n\n.admin-section {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.admin-section h3 {\n  margin-bottom: 15px;\n  color: #333;\n  font-size: 18px;\n  border-bottom: 2px solid #4A964E;\n  padding-bottom: 10px;\n}\n\n.roles-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.role-badge-info {\n  display: flex;\n  flex-direction: column;\n  padding: 10px 15px;\n  background: #4A964E;\n  color: white;\n  border-radius: 8px;\n  min-width: 150px;\n}\n\n.role-badge-info .role-name {\n  font-weight: 600;\n  font-size: 14px;\n  text-transform: capitalize;\n}\n\n.role-badge-info .role-description {\n  font-size: 12px;\n  opacity: 0.9;\n  margin-top: 4px;\n}\n\n.admin-users-table {\n  overflow-x: auto;\n}\n\n.admin-users-table table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.admin-users-table th,\n.admin-users-table td {\n  padding: 12px 15px;\n  text-align: left;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.admin-users-table th {\n  background: #f5f5f5;\n  font-weight: 600;\n  color: #333;\n}\n\n.admin-users-table tr:hover {\n  background: #f9f9f9;\n}\n\n.current-user-row {\n  background: rgba(102, 126, 234, 0.05) !important;\n}\n\n.you-badge {\n  display: inline-block;\n  background: #4A964E;\n  color: white;\n  font-size: 10px;\n  padding: 2px 6px;\n  border-radius: 4px;\n  margin-left: 8px;\n  vertical-align: middle;\n}\n\n.status-badge-small {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.status-badge-small.active {\n  background: #d4edda;\n  color: #155724;\n}\n\n.status-badge-small.inactive {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n.user-roles {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n.role-tag {\n  display: inline-block;\n  padding: 3px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  text-transform: capitalize;\n  background: #e0e0e0;\n  color: #333;\n}\n\n.role-tag.admin {\n  background: #dc3545;\n  color: white;\n}\n\n.role-tag.manager {\n  background: #fd7e14;\n  color: white;\n}\n\n.role-tag.employee {\n  background: #28a745;\n  color: white;\n}\n\n.role-tag.viewer {\n  background: #17a2b8;\n  color: white;\n}\n\n.role-tag.client {\n  background: #334155;\n  color: white;\n}\n\n.no-roles {\n  color: #999;\n  font-style: italic;\n  font-size: 12px;\n}\n\n.btn-edit-roles {\n  padding: 6px 12px;\n  background: #4A964E;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  transition: background 0.2s;\n}\n\n.btn-edit-roles:hover {\n  background: #5a6fd6;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 12px;\n  padding: 30px;\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.modal-content h3 {\n  margin-bottom: 5px;\n  color: #333;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 15px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.modal-header h3 {\n  margin: 0;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 28px;\n  cursor: pointer;\n  color: #999;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s;\n}\n\n.modal-close:hover {\n  color: #333;\n}\n\n.modal-body {\n  margin-bottom: 20px;\n}\n\n.modal-footer {\n  display: flex;\n  gap: 12px;\n  margin-top: 20px;\n  padding-top: 15px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.modal-footer button {\n  flex: 1;\n  transition: all 0.2s ease;\n}\n\n.modal-footer button:hover:not(:disabled) {\n  transform: scale(1.05);\n}\n\n.modal-subtitle {\n  color: #666;\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n\n/* No Roles Action */\n.no-roles-action {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  background: #fff3f3;\n  border: 2px dashed #dc3545;\n  border-radius: 8px;\n  margin-bottom: 16px;\n}\n\n.btn-no-roles {\n  background: #fff;\n  border: 2px solid #dc3545;\n  color: #dc3545;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.btn-no-roles:hover {\n  background: #dc3545;\n  color: white;\n}\n\n.btn-no-roles.active {\n  background: #dc3545;\n  color: white;\n}\n\n.no-roles-hint {\n  font-size: 12px;\n  color: #666;\n  font-style: italic;\n}\n\n.roles-divider {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 16px 0;\n  color: #999;\n  font-size: 13px;\n}\n\n.roles-divider::before,\n.roles-divider::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: #e0e0e0;\n}\n\n.roles-checkbox-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.role-checkbox {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.role-checkbox:hover {\n  border-color: #4A964E;\n  background: #f9f9ff;\n}\n\n.role-checkbox input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  margin-top: 2px;\n  cursor: pointer;\n}\n\n.role-checkbox-name {\n  font-weight: 600;\n  color: #333;\n  text-transform: capitalize;\n}\n\n.role-checkbox-desc {\n  font-size: 12px;\n  color: #666;\n  display: block;\n  margin-left: auto;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.modal-actions .btn-primary,\n.modal-actions .btn-secondary {\n  flex: 1;\n  padding: 12px;\n}\n\n/* User roles display in Profile */\n.profile-roles {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n/* ===================== */\n/* Admin Panel Extended  */\n/* ===================== */\n\n.admin-tabs {\n  display: flex;\n  gap: 5px;\n  margin-bottom: 20px;\n  border-bottom: 2px solid #e0e0e0;\n  padding-bottom: 10px;\n}\n\n.admin-tab {\n  padding: 10px 20px;\n  border: none;\n  background: #f5f5f5;\n  border-radius: 8px 8px 0 0;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.admin-tab:hover {\n  background: #e8e8e8;\n}\n\n.admin-tab.active {\n  background: #4A964E;\n  color: white;\n}\n\n.section-description {\n  color: #666;\n  margin-bottom: 20px;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.actions-cell {\n  display: flex;\n  gap: 5px;\n}\n\n.btn-edit-permissions {\n  padding: 6px 12px;\n  background: #28a745;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  transition: background 0.2s;\n}\n\n.btn-edit-permissions:hover {\n  background: #218838;\n}\n\n.user-permissions-count {\n  font-size: 12px;\n  color: #666;\n  background: #f0f0f0;\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\n/* Roles Grid */\n.roles-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 15px;\n}\n\n.role-card {\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 15px;\n  transition: box-shadow 0.2s;\n}\n\n.role-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.role-card-header {\n  margin-bottom: 10px;\n}\n\n.role-tag.large {\n  font-size: 14px;\n  padding: 6px 12px;\n}\n\n.role-card-description {\n  color: #666;\n  font-size: 13px;\n  margin-bottom: 10px;\n}\n\n.role-card-permissions {\n  border-top: 1px solid #e0e0e0;\n  padding-top: 10px;\n  margin-top: 10px;\n}\n\n.role-card-permissions strong {\n  font-size: 11px;\n  color: #888;\n  display: block;\n  margin-bottom: 5px;\n}\n\n.permission-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n.permission-tag-small {\n  font-size: 10px;\n  padding: 2px 6px;\n  background: #e8f4fd;\n  color: #1976d2;\n  border-radius: 3px;\n  font-family: monospace;\n}\n\n/* Permissions Grid */\n.permission-category {\n  margin-bottom: 25px;\n}\n\n.permission-category h4 {\n  color: #333;\n  margin-bottom: 15px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.permissions-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 10px;\n}\n\n.permission-card {\n  background: #f9f9f9;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  padding: 12px;\n}\n\n.permission-name {\n  display: block;\n  font-size: 13px;\n  color: #1976d2;\n  background: #e8f4fd;\n  padding: 4px 8px;\n  border-radius: 4px;\n  margin-bottom: 8px;\n}\n\n.permission-description {\n  color: #666;\n  font-size: 12px;\n  margin: 0;\n}\n\n/* Modal Large */\n.modal-large {\n  max-width: 700px;\n}\n\n.modal-info {\n  color: #666;\n  font-size: 13px;\n  margin-bottom: 15px;\n  padding: 10px;\n  background: #f5f5f5;\n  border-radius: 6px;\n}\n\n/* Permissions Checkbox Container */\n.permissions-checkbox-container {\n  max-height: 400px;\n  overflow-y: auto;\n  margin-bottom: 20px;\n}\n\n.permission-category-section {\n  margin-bottom: 20px;\n}\n\n.permission-category-section h4 {\n  font-size: 14px;\n  color: #333;\n  margin-bottom: 10px;\n  padding: 8px;\n  background: #f5f5f5;\n  border-radius: 4px;\n}\n\n.permissions-checkbox-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.permission-checkbox {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.permission-checkbox:hover {\n  border-color: #28a745;\n  background: #f0fff4;\n}\n\n.permission-checkbox input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  margin-top: 2px;\n  cursor: pointer;\n}\n\n.permission-checkbox-content {\n  flex: 1;\n}\n\n.permission-checkbox-name {\n  display: block;\n  font-size: 12px;\n  color: #1976d2;\n  margin-bottom: 4px;\n}\n\n.permission-checkbox-desc {\n  font-size: 11px;\n  color: #666;\n}\n\n/* Role checkbox name colors */\n.role-checkbox-name.admin {\n  color: #dc3545;\n}\n\n.role-checkbox-name.manager {\n  color: #fd7e14;\n}\n\n.role-checkbox-name.employee {\n  color: #28a745;\n}\n\n.role-checkbox-name.viewer {\n  color: #17a2b8;\n}\n\n.role-checkbox-name.client {\n  color: #334155;\n}\n\n/* Profile permissions */\n.profile-permissions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 5px;\n}\n\n.profile-info-item.full-width {\n  grid-column: 1 / -1;\n}\n\n/* =====================================================\n   HOME PAGE STYLES\n   ===================================================== */\n\n.home-page .page-header {\n  margin-bottom: 25px;\n}\n\n/* Home Page Header with Avatar */\n.home-header-with-avatar {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.home-avatar {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  overflow: hidden;\n  flex-shrink: 0;\n  border: 3px solid #4A964E;\n}\n\n.home-avatar-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.home-avatar-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #4A964E 0%, #3d7a40 100%);\n  color: white;\n  font-size: 32px;\n  font-weight: 600;\n}\n\n.home-header-text h2 {\n  margin: 0 0 4px 0;\n}\n\n.home-header-text p {\n  margin: 0;\n}\n\n.home-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* ── Section card shell ─────────────────────────────────────── */\n.home-section {\n  background: white;\n  border-radius: 14px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.07);\n  overflow: hidden;\n}\n\n/* ── Section header (green bar) ─────────────────────────────── */\n.section-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 13px 20px;\n  background: linear-gradient(135deg, #4A964E 0%, #3a7a3e 100%);\n  color: white;\n}\n\n.section-header__icon {\n  font-size: 17px;\n  line-height: 1;\n}\n\n.section-header h3 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  flex: 1;\n  letter-spacing: 0.01em;\n}\n\n.section-header__count {\n  font-size: 11px;\n  font-weight: 700;\n  background: rgba(255, 255, 255, 0.25);\n  padding: 2px 9px;\n  border-radius: 20px;\n  min-width: 24px;\n  text-align: center;\n}\n\n/* ── Subsection divider ─────────────────────────────────────── */\n.announcements-section,\n.news-section {\n  max-height: none;\n  overflow-y: visible;\n}\n\n.announcements-subsection {\n  padding: 16px 20px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.announcements-subsection:last-child {\n  border-bottom: none;\n}\n\n.subsection-title {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  font-weight: 700;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  margin-bottom: 12px;\n}\n\n/* ── Announcement list ──────────────────────────────────────── */\n.announcements-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n/* ── Announcement card ──────────────────────────────────────── */\n.announcement-card {\n  border-radius: 10px;\n  padding: 12px 14px;\n  border-left: 4px solid #2563eb;\n  background: #f9fafb;\n  transition: transform 0.15s, box-shadow 0.15s;\n}\n\n.announcement-card:hover {\n  transform: translateX(3px);\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.09);\n}\n\n.announcement-card.is-pinned {\n  outline: 1px solid #fbbf24;\n  outline-offset: -1px;\n}\n\n.announcement-card.priority-urgent {\n  box-shadow: 0 0 0 1px #fca5a5;\n}\n\n.announcement-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 7px;\n  margin-bottom: 7px;\n  flex-wrap: wrap;\n}\n\n.priority-icon {\n  font-size: 15px;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.announcement-title {\n  font-weight: 700;\n  font-size: 13.5px;\n  color: #111827;\n  flex: 1;\n  line-height: 1.4;\n  min-width: 0;\n  word-break: break-word;\n}\n\n/* badge row */\n.announcement-badges {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  flex-shrink: 0;\n}\n\n.pinned-badge {\n  font-size: 10px;\n  font-weight: 700;\n  color: #92400e;\n  background: #fef3c7;\n  border: 1px solid #fcd34d;\n  padding: 1px 7px;\n  border-radius: 6px;\n  white-space: nowrap;\n}\n\n.priority-badge {\n  font-size: 10px;\n  font-weight: 700;\n  color: #fff;\n  padding: 1px 7px;\n  border-radius: 6px;\n  letter-spacing: 0.03em;\n  white-space: nowrap;\n}\n\n.announcement-content {\n  font-size: 13px;\n  color: #111827;\n  line-height: 1.65;\n  margin-bottom: 10px;\n  word-break: break-word;\n}\n\n/* footer */\n.announcement-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding-top: 8px;\n  border-top: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.announcement-author {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11.5px;\n  color: #374151;\n  font-weight: 500;\n}\n\n.author-avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #dbeafe;\n  color: #1d4ed8;\n  font-size: 10px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.announcement-date {\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n/* ── News section ───────────────────────────────────────────── */\n.news-list {\n  padding: 14px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.news-card {\n  display: flex;\n  gap: 14px;\n  padding: 13px;\n  background: #f9fafb;\n  border-radius: 10px;\n  border: 1px solid #f0f0f0;\n  transition: background 0.15s, box-shadow 0.15s, transform 0.15s;\n}\n\n.news-card:hover {\n  background: #f3f4f6;\n  transform: translateY(-2px);\n  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.09);\n}\n\n.news-image {\n  width: 88px;\n  height: 70px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.news-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.news-content {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.news-title-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.pinned-icon {\n  font-size: 12px;\n  flex-shrink: 0;\n}\n\n.news-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0;\n  line-height: 1.4;\n}\n\n.news-summary {\n  font-size: 13px;\n  color: #111827;\n  line-height: 1.65;\n  margin: 0;\n  word-break: break-word;\n}\n\n/* ── Article / rich-content body ────────────────────────────── */\n.article-body {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.article-h1 {\n  font-size: 16px;\n  font-weight: 700;\n  color: #111827;\n  margin: 14px 0 4px;\n  line-height: 1.3;\n  padding-bottom: 4px;\n  border-bottom: 2px solid #e5e7eb;\n}\n\n.article-h2 {\n  font-size: 14px;\n  font-weight: 700;\n  color: #111827;\n  margin: 12px 0 3px;\n  line-height: 1.3;\n}\n\n.article-h3 {\n  font-size: 13px;\n  font-weight: 700;\n  color: #374151;\n  margin: 10px 0 2px;\n  line-height: 1.3;\n}\n\n.article-body .article-h1:first-child,\n.article-body .article-h2:first-child,\n.article-body .article-h3:first-child {\n  margin-top: 0;\n}\n\n.article-p {\n  font-size: 13px;\n  color: #111827;\n  line-height: 1.7;\n  margin: 4px 0;\n}\n\n.article-list {\n  margin: 4px 0 4px 18px;\n  padding: 0;\n  list-style: disc;\n}\n\n.article-list li {\n  font-size: 13px;\n  color: #111827;\n  line-height: 1.65;\n  margin-bottom: 2px;\n}\n\n.article-spacer {\n  height: 8px;\n}\n\n.news-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 4px;\n  padding-top: 6px;\n  border-top: 1px solid rgba(0, 0, 0, 0.05);\n  margin-top: auto;\n}\n\n.news-author {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  color: #374151;\n  font-weight: 500;\n}\n\n.news-date {\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n/* ── Empty states ───────────────────────────────────────────── */\n.no-content {\n  color: #9ca3af;\n  font-size: 12.5px;\n  font-style: italic;\n  margin: 0;\n  padding: 4px 0;\n}\n\n.no-content-box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 32px 16px;\n  color: #9ca3af;\n  font-size: 13px;\n  text-align: center;\n}\n\n.no-content-box span {\n  font-size: 28px;\n}\n\n.no-content-box p {\n  margin: 0;\n}\n\n/* ── Responsive ─────────────────────────────────────────────── */\n@media (max-width: 600px) {\n  .news-image { display: none; }\n  .announcement-badges { width: 100%; }\n}\n\n/* =====================================================\n   CONTENT MANAGEMENT STYLES\n   ===================================================== */\n\n.content-management .page-header {\n  margin-bottom: 20px;\n}\n\n.content-tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.tab-btn {\n  padding: 12px 24px;\n  border: 2px solid #e0e0e0;\n  background: white;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.tab-btn:hover {\n  border-color: #4A964E;\n  color: #4A964E;\n}\n\n.tab-btn.active {\n  background: #4A964E;\n  color: white;\n  border-color: transparent;\n}\n\n.content-panel {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  padding: 20px;\n}\n\n.panel-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 15px;\n  border-bottom: 1px solid #eee;\n}\n\n.panel-header h3 {\n  margin: 0;\n  font-size: 18px;\n  color: #333;\n}\n\n/* Content Form Overlay */\n.content-form-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.content-form {\n  background: white;\n  border-radius: 12px;\n  padding: 25px;\n  width: 100%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.content-form h4 {\n  margin: 0 0 20px 0;\n  font-size: 18px;\n  color: #333;\n}\n\n.content-form .form-group {\n  margin-bottom: 16px;\n}\n\n.content-form .form-group label {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 500;\n  font-size: 13px;\n  color: #555;\n}\n\n.content-form .form-group input,\n.content-form .form-group textarea,\n.content-form .form-group select {\n  width: 100%;\n  padding: 10px 14px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n}\n\n.content-form .form-group input:focus,\n.content-form .form-group textarea:focus,\n.content-form .form-group select:focus {\n  outline: none;\n  border-color: #4A964E;\n}\n\n.content-form .form-row {\n  display: flex;\n  gap: 15px;\n}\n\n.content-form .form-row .form-group {\n  flex: 1;\n}\n\n.content-form .checkbox-group {\n  display: flex;\n  align-items: center;\n}\n\n.content-form .checkbox-group label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  margin-bottom: 0;\n}\n\n.content-form .checkbox-group input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n}\n\n.form-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 20px;\n  padding-top: 15px;\n  border-top: 1px solid #eee;\n}\n\n.form-actions .btn {\n  width: auto;\n  padding: 10px 24px;\n}\n\n/* Content Table */\n.content-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.content-table th,\n.content-table td {\n  padding: 12px 15px;\n  text-align: left;\n  border-bottom: 1px solid #eee;\n}\n\n.content-table th {\n  background: #f8f9fa;\n  font-weight: 600;\n  font-size: 12px;\n  text-transform: uppercase;\n  color: #666;\n}\n\n.content-table tr:hover {\n  background: #f9fafb;\n}\n\n.content-table tr.unpublished {\n  opacity: 0.7;\n  background: #fffbf0;\n}\n\n.pin-icon {\n  margin-right: 5px;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.status-badge.published {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.status-badge.draft {\n  background: #fff3e0;\n  color: #e65100;\n}\n\n.priority-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  color: white;\n  text-transform: uppercase;\n}\n\n.scope-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.scope-badge.global {\n  background: #e3f2fd;\n  color: #1565c0;\n}\n\n.scope-badge.department {\n  background: #f3e5f5;\n  color: #7b1fa2;\n}\n\n.btn-small {\n  padding: 6px 12px !important;\n  font-size: 12px !important;\n  width: auto !important;\n  margin-right: 5px;\n}\n\n.btn-edit {\n  background: #17a2b8;\n  color: white;\n}\n\n.btn-edit:hover {\n  background: #138496;\n}\n\n.btn-danger {\n  background: #dc3545;\n  color: white;\n}\n\n.btn-danger:hover {\n  background: #c82333;\n}\n\n/* Content section in sidebar */\n.content-section {\n  border-top: 1px solid #eee;\n  padding-top: 15px;\n}\n\n.content-link {\n  color: #8e44ad !important;\n}\n\n.content-link:hover {\n  background: #f5eef8 !important;\n}\n\n/* Responsive adjustments */\n@media (max-width: 600px) {\n  .content-form-overlay {\n    padding: 10px;\n  }\n  \n  .content-form {\n    padding: 15px;\n  }\n  \n  .content-form .form-row {\n    flex-direction: column;\n  }\n  \n  .content-table {\n    font-size: 12px;\n  }\n  \n  .content-table th,\n  .content-table td {\n    padding: 8px 10px;\n  }\n}\n\n/* =====================================================\n   Employee Manager Styles\n   ===================================================== */\n\n.tab-navigation {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 24px;\n  border-bottom: 2px solid #e9ecef;\n  padding-bottom: 0;\n}\n\n.tab-button {\n  background: none;\n  border: none;\n  padding: 12px 24px;\n  font-size: 15px;\n  font-weight: 500;\n  color: #6c757d;\n  cursor: pointer;\n  border-bottom: 3px solid transparent;\n  transition: all 0.2s;\n  margin-bottom: -2px;\n}\n\n.tab-button:hover {\n  color: #007bff;\n  background: #f8f9fa;\n}\n\n.tab-button.active {\n  color: #007bff;\n  border-bottom-color: #007bff;\n}\n\n.tab-content {\n  animation: fadeIn 0.3s ease-in;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.tab-content .manager-section {\n  width: 100%;\n  max-width: none;\n}\n\n.employee-manager-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n}\n\n.manager-section {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  padding: 24px;\n}\n\n.manager-section h3 {\n  margin: 0 0 20px 0;\n  font-size: 18px;\n  color: #333;\n}\n\n.add-dept-form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 20px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #eee;\n}\n\n.dept-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.dept-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n.dept-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.dept-info strong {\n  color: #333;\n}\n\n.dept-desc {\n  font-size: 12px;\n  color: #666;\n}\n\n.dept-count {\n  font-size: 11px;\n  color: #888;\n  background: #e9ecef;\n  padding: 2px 8px;\n  border-radius: 10px;\n  width: fit-content;\n}\n\n.dept-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.dept-edit-form {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.dept-edit-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.position-group {\n  margin-bottom: 24px;\n}\n\n.position-group-header {\n  font-size: 14px;\n  font-weight: 600;\n  color: #555;\n  margin-bottom: 8px;\n  padding-left: 4px;\n  border-left: 3px solid #007bff;\n  padding-left: 12px;\n}\n\n.form-help {\n  display: block;\n  font-size: 12px;\n  color: #6c757d;\n  margin-top: 4px;\n}\n\n.btn-icon {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: background 0.2s;\n}\n\n.btn-icon:hover {\n  background: #e9ecef;\n}\n\n.btn-icon-danger:hover {\n  background: #f8d7da;\n}\n\n.btn-success {\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n  background: #28a745;\n  color: white;\n}\n\n.btn-success:hover:not(:disabled) {\n  background: #218838;\n}\n\n.btn-success:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-sm {\n  padding: 6px 12px;\n  font-size: 13px;\n}\n\n.no-data {\n  color: #888;\n  font-style: italic;\n  text-align: center;\n  padding: 20px;\n}\n\n/* Employees Table */\n.employees-section {\n  overflow: hidden;\n}\n\n.employees-table-container {\n  overflow-x: auto;\n}\n\n.employees-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.employees-table th,\n.employees-table td {\n  padding: 12px 16px;\n  text-align: left;\n  border-bottom: 1px solid #eee;\n}\n\n.employees-table th {\n  background: #f8f9fa;\n  font-weight: 600;\n  color: #555;\n  font-size: 13px;\n  text-transform: uppercase;\n}\n\n.employees-table tbody tr:hover {\n  background: #f8f9fa;\n}\n\n.emp-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.emp-avatar-small {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #4A964E;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.emp-avatar-small img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.emp-avatar-small span {\n  font-size: 16px;\n}\n\n.emp-info strong {\n  display: block;\n  color: #333;\n}\n\n.emp-email {\n  display: block;\n  font-size: 12px;\n  color: #888;\n}\n\n@media (max-width: 1024px) {\n  .employee-manager-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Order Monitoring  — ProductionOrderMonitoring.js\n   ═══════════════════════════════════════════════════════════════ */\n\n.order-monitoring .om-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  min-width: 0;\n  margin-bottom: 16px;\n}\n\n.order-monitoring .om-tabs {\n  display: flex;\n  flex: 1 1 380px;\n  min-width: 0;\n  gap: 4px;\n  background: #f0f0f0;\n  padding: 4px;\n  border-radius: 8px;\n}\n\n.order-monitoring .om-tab {\n  flex: 1 1 0;\n  min-width: 0;\n  padding: 8px clamp(8px, 1.2vw, 16px);\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  cursor: pointer;\n  font-size: clamp(11px, 1vw, 14px);\n  font-weight: 500;\n  line-height: 1.2;\n  white-space: normal;\n  color: #555;\n  transition: all 0.2s;\n}\n\n.order-monitoring .om-tab-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 20px;\n  margin-left: 7px;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: #dc2626;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.order-monitoring .om-tab--active .om-tab-count {\n  background: #b91c1c;\n}\n\n.order-monitoring .om-tab:hover {\n  background: #e0e0e0;\n}\n\n.order-monitoring .om-tab--active {\n  background: #4A964E;\n  color: white;\n}\n\n.order-monitoring .om-controls {\n  display: flex;\n  flex: 0 1 auto;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  min-width: 0;\n  gap: 12px;\n}\n\n.order-monitoring .om-dept-toggle {\n  display: flex;\n  flex: 0 0 auto;\n  gap: 4px;\n  background: #f0f0f0;\n  padding: 4px;\n  border-radius: 8px;\n}\n\n.order-monitoring .om-dept-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 8px clamp(10px, 1.3vw, 18px);\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  font-weight: 600;\n  font-size: clamp(11px, 1vw, 14px);\n  cursor: pointer;\n  color: #555;\n  transition: all 0.2s;\n}\n\n.order-monitoring .om-dept-btn--active {\n  background: #333;\n  color: white;\n}\n\n.order-monitoring .om-delivery-filter {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin: 14px 0;\n  padding: 4px;\n  width: fit-content;\n  max-width: 100%;\n  border-radius: 8px;\n  background: #f0f0f0;\n}\n\n.order-monitoring .om-delivery-filter-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px clamp(12px, 1.5vw, 20px);\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: #555;\n  font-size: clamp(12px, 1vw, 14px);\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n}\n\n.order-monitoring .om-delivery-filter-btn:hover {\n  background: #e0e0e0;\n}\n\n.order-monitoring .om-delivery-filter-btn--active {\n  background: #4A964E;\n  color: #fff;\n}\n\n.order-monitoring .om-delivery-filter-btn--active:hover {\n  background: #3f8243;\n}\n\n.order-monitoring .om-duplicate-warning-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #d97706;\n  font-size: 11px;\n  line-height: 1;\n}\n\n.order-monitoring .om-dept-btn--active .om-duplicate-warning-icon,\n.order-monitoring .om-delivery-filter-btn--active .om-duplicate-warning-icon {\n  color: #fef3c7;\n}\n\n.order-monitoring .om-sync-btn {\n  flex: 0 1 auto;\n  min-width: 0;\n  padding: 8px clamp(10px, 1.3vw, 18px);\n  border: 2px solid #4A964E;\n  border-radius: 8px;\n  background: white;\n  color: #4A964E;\n  font-weight: 600;\n  font-size: clamp(11px, 1vw, 14px);\n  line-height: 1.2;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.order-monitoring .om-sync-btn:hover:not(:disabled) {\n  background: #4A964E;\n  color: white;\n}\n\n.order-monitoring .om-sync-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.order-monitoring .om-sync-btn.om-btn-active {\n  background: #4A964E;\n  color: white;\n}\n\n.order-monitoring .om-export-wrapper > .om-sync-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n/* Producer filter buttons */\n.order-monitoring .om-producer-filters {\n  display: flex;\n  gap: 0.25rem;\n  margin-left: 0.5rem;\n}\n\n.order-monitoring .om-producer-btn {\n  padding: 8px 16px;\n  border: 2px solid #ccc;\n  border-radius: 8px;\n  background: white;\n  color: #555;\n  font-weight: 600;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.order-monitoring .om-producer-btn:hover {\n  border-color: #4A964E;\n  color: #4A964E;\n}\n\n.order-monitoring .om-producer-btn--active {\n  background: #4A964E;\n  border-color: #4A964E;\n  color: white;\n}\n\n/* wrapper */\n.order-monitoring .om-export-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n/* dropdown menu */\n.order-monitoring .om-export-menu {\n  position: absolute;\n  top: 105%;\n  right: 0;\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-shadow: 0 6px 16px rgba(0,0,0,0.08);\n  min-width: 150px;\n  overflow: hidden;\n  z-index: 20;\n}\n\n.order-monitoring .om-export-menu button {\n  width: 100%;\n  padding: 10px 14px;\n  border: none;\n  background: white;\n  text-align: left;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.order-monitoring .om-row-delayed {\n  background: #fee2e2;\n}\n\n.order-monitoring .om-row-earlier {\n  background: #dcfce7;\n}\n\n.order-monitoring .om-row-earlier td {\n  border-color: #86efac;\n}\n\n.order-monitoring .om-row-earlier:hover {\n  background: #bbf7d0;\n}\n\n.order-monitoring .om-row-delayed td {\n  border-color: #fca5a5;\n}\n\n/* opcjonalnie mocniejsze */\n.order-monitoring .om-row-delayed:hover {\n  background: #fecaca;\n}\n\n/* Delivery status colors for Est. Delivery column */\n.order-monitoring .om-delivery-delayed {\n  background: #fee2e2;\n  color: #dc2626;\n  font-weight: 600;\n}\n\n.order-monitoring .om-delivery-earlier {\n  background: #dcfce7;\n  color: #16a34a;\n  font-weight: 600;\n}\n\n.order-monitoring .om-delivery-changed {\n  background: #ffedd5;\n  color: #c2410c;\n  font-weight: 600;\n}\n\n.order-monitoring .om-export-menu button:hover {\n  background: #f3f4f6;\n}\n\n/* Banners */\n.order-monitoring .om-banner {\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 12px;\n  font-size: 14px;\n}\n\n.order-monitoring .om-banner--success {\n  background: #e8f5e9;\n  color: #2e7d32;\n  border: 1px solid #a5d6a7;\n}\n\n.order-monitoring .om-banner--error {\n  background: #fbe9e7;\n  color: #c62828;\n  border: 1px solid #ef9a9a;\n}\n\n.order-monitoring .om-banner--info {\n  background: #e3f2fd;\n  color: #1565c0;\n  border: 1px solid #90caf9;\n}\n\n.order-monitoring .om-banner--warning {\n  background: #fff8e1;\n  color: #8a4b08;\n  border: 1px solid #f0c36d;\n}\n\n/* Search & Lookup */\n.order-monitoring .om-order-lookup {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 12px;\n  max-width: 720px;\n}\n\n.order-monitoring .om-order-autocomplete {\n  position: relative;\n  flex: 1;\n  min-width: 200px;\n}\n\n.order-monitoring .om-order-autocomplete .om-search {\n  width: 100%;\n}\n\n.order-monitoring .om-order-suggestions {\n  position: absolute;\n  top: calc(100% + 4px);\n  right: 0;\n  left: 0;\n  z-index: 1000;\n  max-height: 280px;\n  margin: 0;\n  padding: 4px;\n  overflow-y: auto;\n  list-style: none;\n  border: 1px solid #d7ddd7;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.14);\n}\n\n.order-monitoring .om-order-suggestions li {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 9px 10px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.order-monitoring .om-order-suggestions li:hover,\n.order-monitoring .om-order-suggestions li.is-active {\n  background: #edf7ee;\n}\n\n.order-monitoring .om-order-suggestions li span {\n  color: #667066;\n  font-size: 12px;\n}\n\n.order-monitoring .om-order-suggestions-loading {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  color: #667066;\n  font-size: 12px;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n.order-monitoring .om-order-lookup-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 42px;\n  padding: 9px 14px;\n  border: 2px solid #2f7d32;\n  border-radius: 8px;\n  background: #2f7d32;\n  color: #fff;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.order-monitoring .om-order-lookup-btn:hover:not(:disabled) {\n  background: #256428;\n  border-color: #256428;\n}\n\n.order-monitoring .om-order-lookup-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.order-monitoring .om-search-row {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.order-monitoring .om-search {\n  flex: 1;\n  min-width: 200px;\n  padding: 10px 14px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n}\n\n.order-monitoring .om-search:focus {\n  outline: none;\n  border-color: #4A964E;\n}\n\n@media (max-width: 600px) {\n  .order-monitoring .om-order-lookup {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .order-monitoring .om-order-autocomplete,\n  .order-monitoring .om-order-lookup .om-search {\n    width: 100%;\n  }\n}\n\n.order-monitoring .om-lookup-form {\n  display: flex;\n  gap: 4px;\n}\n\n.order-monitoring .om-lookup-input {\n  width: 200px;\n  padding: 10px 14px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n.order-monitoring .om-lookup-input:focus {\n  outline: none;\n  border-color: #4A964E;\n}\n\n.order-monitoring .om-lookup-btn {\n  padding: 10px 14px;\n  border: 2px solid #4A964E;\n  border-radius: 8px;\n  background: #4A964E;\n  color: white;\n  cursor: pointer;\n  font-size: 16px;\n  transition: opacity 0.2s;\n}\n\n.order-monitoring .om-lookup-btn:hover {\n  opacity: 0.85;\n}\n\n/* Table */\n.order-monitoring .om-table-wrap {\n  overflow-x: auto;\n}\n\n.order-monitoring .om-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.order-monitoring .om-table th {\n  background: #f5f5f5;\n  padding: 10px 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #555;\n  border-bottom: 2px solid #e0e0e0;\n  white-space: nowrap;\n  user-select: none;\n}\n\n.order-monitoring .om-table th:hover {\n  background: #ebebeb;\n}\n\n.order-monitoring .om-table td {\n  padding: 10px 12px;\n  border-bottom: 1px solid #f0f0f0;\n  color: #333;\n}\n\n.order-monitoring .om-table tbody tr:hover {\n  background: #f9fbe7;\n}\n\n.order-monitoring .om-remaining {\n  font-weight: 700;\n  color: #c62828;\n}\n\n.order-monitoring .om-complaint-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 9px;\n  border: 1px solid #f59e0b;\n  border-radius: 999px;\n  background: #fffbeb;\n  color: #92400e;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.order-monitoring .om-received-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 7px 11px;\n  border: 1px solid #4A964E;\n  border-radius: 7px;\n  background: #4A964E;\n  color: #fff;\n  font-weight: 700;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.order-monitoring .om-received-btn:hover:not(:disabled) {\n  background: #3f8243;\n}\n\n.order-monitoring .om-received-btn:disabled {\n  opacity: .6;\n  cursor: not-allowed;\n}\n\n.order-monitoring .om-delivery-date-input {\n  min-width: 145px;\n  padding: 7px 9px;\n  border: 1px solid #cbd5e1;\n  border-radius: 7px;\n  background: #fff;\n  color: #333;\n  font: inherit;\n}\n\n.order-monitoring .om-delivery-date-input:focus {\n  border-color: #4A964E;\n  outline: 2px solid rgba(74, 150, 78, .18);\n}\n\n/* Footer */\n.order-monitoring .om-footer {\n  margin-top: 12px;\n  text-align: right;\n  font-size: 13px;\n  color: #888;\n}\n\n/* Pagination */\n.order-monitoring .om-pagination {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px 24px;\n  margin-top: 12px;\n  font-size: 13px;\n  color: #666;\n}\n\n.order-monitoring .om-pagination__size {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.order-monitoring .om-pagination__size select {\n  padding: 4px 8px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  background: #fff;\n  font-size: 13px;\n}\n\n.order-monitoring .om-pagination__nav {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.order-monitoring .om-pagination__page {\n  min-width: 110px;\n  text-align: center;\n}\n\n.order-monitoring .om-pagination__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  background: #fff;\n  color: #444;\n  cursor: pointer;\n}\n\n.order-monitoring .om-pagination__btn:hover:not(:disabled) {\n  background: #f0f0f0;\n}\n\n.order-monitoring .om-pagination__btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* Loading / Empty */\n.order-monitoring .om-loading,\n.order-monitoring .om-empty {\n  text-align: center;\n  padding: 48px 20px;\n  color: #888;\n  font-size: 16px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .order-monitoring .om-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .order-monitoring .om-controls {\n    width: 100%;\n    justify-content: flex-start;\n    gap: 8px;\n  }\n\n  .order-monitoring .om-tabs {\n    width: 100%;\n    flex-basis: auto;\n  }\n\n  .order-monitoring .om-tab {\n    padding-inline: 6px;\n  }\n\n  .order-monitoring .om-sync-btn {\n    white-space: normal;\n  }\n}\n\n@keyframes dropIn {\n  0% {\n    transform: translateY(-120px) scale(0.96);\n    opacity: 0;\n  }\n  60% {\n    transform: translateY(10px) scale(1.01);\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(0) scale(1);\n  }\n}\n\n.header-description {\n  margin-bottom: 1.5rem; /* ~2 linie odstępu */\n}\n\n.warning-red {\n  margin-top: 8px;\n  padding: 10px 14px;\n  background-color: #fdecea;\n  border: 1px solid #f5c2c7;\n  color: #b02a37;\n  border-radius: 6px;\n  font-size: 0.9rem;\n}\n\n.info-box {\n  margin-top: 12px;\n  padding: 10px 14px;\n  background-color: #fff3cd;\n  border: 1px solid #ffeeba;\n  color: #856404;\n  border-radius: 6px;\n  font-size: 0.9rem;\n}\n\n.om-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.om-overlay__box {\n  background: #fff;\n  border-radius: 16px;\n  padding: 2.5rem 3rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1.2rem;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.18);\n}\n\n.om-overlay__spinner {\n  width: 56px;\n  height: 56px;\n  border: 6px solid #e0e0e0;\n  border-top-color: #4f46e5;\n  border-radius: 50%;\n  animation: spin 0.9s linear infinite;\n}\n\n.om-overlay__text {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #333;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to   { transform: rotate(360deg); }\n}\n\n.stojaki-page .page-container {\n  max-width: 1800px;\n  margin: 0 auto;\n  width: 100%;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  overflow: visible;\n}\n\n.stojaki-page .page-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 2rem;\n  margin-bottom: 0;\n  border-radius: 12px 12px 0 0;\n}\n\n.stojaki-page .page-header h2 {\n  font-size: 2rem;\n  margin-bottom: 0.5rem;\n  color: white;\n}\n\n.stojaki-page .page-header p {\n  opacity: 0.9;\n  font-size: 1.1rem;\n  color: white;\n}\n\n.stojaki-page .page-content {\n  padding: 2rem;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n/* Breadcrumb */\n.stojaki-page .breadcrumb-nav {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n  font-size: 0.9rem;\n}\n\n.stojaki-page .breadcrumb-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  color: white;\n  text-decoration: none;\n  opacity: 0.8;\n  transition: opacity 0.2s;\n}\n\n.stojaki-page .breadcrumb-icon {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  stroke-width: 1.9;\n}\n\n.stojaki-page .stojaki-page-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.stojaki-page .stojaki-page-title > svg {\n  width: 30px;\n  height: 30px;\n  flex-shrink: 0;\n  stroke-width: 1.8;\n}\n\n.stojaki-page .breadcrumb-link:hover {\n  opacity: 1;\n}\n\n.stojaki-page .breadcrumb-separator {\n  opacity: 0.6;\n}\n\n.stojaki-page .breadcrumb-current {\n  opacity: 1;\n}\n\n/* Tabs */\n.stojaki-page .stojaki-tabs-wrapper {\n  background: white;\n  border-bottom: 2px solid #e5e7eb;\n}\n\n.stojaki-page .stojaki-tabs {\n  display: flex;\n  gap: 0.5rem;\n  padding: 0 2rem;\n  max-width: 1800px;\n  margin: 0 auto;\n}\n\n.stojaki-page .tab-btn {\n  background: none;\n  border: none;\n  border-radius: 0;\n  padding: 1rem 1.5rem;\n  font-size: 1rem;\n  font-weight: 500;\n  color: #718096;\n  cursor: pointer;\n  border-bottom: 3px solid transparent;\n  transition: all 0.2s;\n}\n\n.stojaki-page .tab-btn:hover {\n  color: #667eea;\n  border-color: transparent;\n  background: none;\n}\n\n.stojaki-page .tab-btn.active {\n  color: #667eea;\n  border-bottom-color: #667eea;\n  background: none;\n}\n\n/* Tab content */\n.stojaki-page .tab-content {\n  min-height: 400px;\n}\n\n.stojaki-page .tab-section {\n  margin-bottom: 2.5rem;\n}\n\n.stojaki-page .tab-section h3 {\n  font-size: 1.5rem;\n  color: #2d3748;\n  margin-bottom: 0.5rem;\n}\n\n.stojaki-page .section-description {\n  color: #718096;\n  margin-bottom: 1.5rem;\n  line-height: 1.6;\n}\n\n/* Alerts */\n.stojaki-page .alert {\n  padding: 1rem 1.5rem;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n}\n\n.stojaki-page .alert-error {\n  background: #fee;\n  color: #c53030;\n  border-left: 4px solid #c53030;\n}\n\n.stojaki-page .alert-success {\n  background: #d4edda;\n  color: #155724;\n  border-left: 4px solid #28a745;\n}\n\n/* File upload */\n.stojaki-page .csv-upload-section {\n  background: #f9fafb;\n  border: 2px dashed #d1d5db;\n  border-radius: 12px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n}\n\n.stojaki-page .file-upload-wrapper {\n  margin-bottom: 1.5rem;\n}\n\n.stojaki-page .file-upload-label {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem;\n  border: 2px dashed #667eea;\n  border-radius: 12px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.stojaki-page .file-upload-label:hover {\n  background: #f7fafc;\n  border-color: #764ba2;\n}\n\n.stojaki-page .file-upload-icon {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n}\n\n.stojaki-page .file-upload-text {\n  font-size: 1.1rem;\n  color: #2d3748;\n  margin-bottom: 0.5rem;\n}\n\n.stojaki-page .file-upload-hint {\n  color: #718096;\n  font-size: 0.9rem;\n}\n\n.stojaki-page .file-upload-input {\n  display: none;\n}\n\n.stojaki-page .file-info-card {\n  background: white;\n  border: 2px solid #667eea;\n  border-radius: 12px;\n  padding: 1.5rem;\n}\n\n.stojaki-page .file-info-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.stojaki-page .file-info-icon {\n  font-size: 2.5rem;\n}\n\n.stojaki-page .file-info-details {\n  flex: 1;\n}\n\n.stojaki-page .file-info-details h4 {\n  color: #2d3748;\n  margin-bottom: 0.5rem;\n}\n\n.stojaki-page .file-info-details p {\n  color: #718096;\n  font-size: 0.9rem;\n}\n\n.stojaki-page .file-info-label {\n  font-weight: 600;\n  color: #4a5568;\n}\n\n.stojaki-page .btn-remove-file {\n  background: #ef4444;\n  color: white;\n  border: none;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 1.2rem;\n  transition: background 0.2s;\n}\n\n.stojaki-page .btn-remove-file:hover {\n  background: #dc2626;\n}\n\n.stojaki-page .btn-remove-file:disabled {\n  background: #d1d5db;\n  cursor: not-allowed;\n}\n\n.stojaki-page .file-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n}\n\n.stojaki-page .upload-placeholder {\n  text-align: center;\n  padding: 2rem;\n  color: #718096;\n}\n\n/* Buttons */\n.stojaki-page .btn-primary,\n.stojaki-page .btn-success,\n.stojaki-page .btn-secondary,\n.stojaki-page .btn-small {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.stojaki-page .btn-primary {\n  background: #667eea;\n  color: white;\n}\n\n.stojaki-page .btn-primary:hover:not(:disabled) {\n  background: #5a67d8;\n}\n\n.stojaki-page .btn-success {\n  background: #48bb78;\n  color: white;\n}\n\n.stojaki-page .btn-success:hover:not(:disabled) {\n  background: #38a169;\n}\n\n.stojaki-page .btn-secondary {\n  background: #718096;\n  color: white;\n  width: auto;\n}\n\n.stojaki-page .btn-secondary:hover:not(:disabled) {\n  background: #4a5568;\n}\n\n.stojaki-page .btn-warning {\n  background: #f59e0b;\n  color: white;\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.stojaki-page .btn-warning:hover:not(:disabled) {\n  background: #d97706;\n}\n\n.stojaki-page .btn-small {\n  padding: 0.4rem 0.8rem;\n  font-size: 0.85rem;\n  margin: 0 0.25rem;\n}\n\n.stojaki-page button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.stojaki-page .action-buttons {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n  margin: 1.5rem 0;\n}\n\n.stojaki-page .action-buttons > button {\n  flex-shrink: 0;\n  width: auto;\n  margin-top: 0;\n}\n\n/* Email Status Summary Cards */\n.stojaki-page .email-status-summary {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 1rem;\n  margin: 2rem 0;\n}\n\n.stojaki-page .status-card {\n  background: #ffffff;\n  border-radius: 12px;\n  padding: 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  transition: all 0.3s ease;\n  border: 2px solid transparent;\n}\n\n.stojaki-page .status-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);\n}\n\n.stojaki-page .status-card-icon {\n  font-size: 2.5rem;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.stojaki-page .status-card-content {\n  flex: 1;\n}\n\n.stojaki-page .status-card-value {\n  font-size: 2rem;\n  font-weight: 700;\n  line-height: 1.2;\n  margin-bottom: 0.25rem;\n}\n\n.stojaki-page .status-card-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  opacity: 0.8;\n}\n\n.stojaki-page .status-card-total { border-color: #667eea; }\n.stojaki-page .status-card-total .status-card-value,\n.stojaki-page .status-card-total .status-card-label { color: #667eea; }\n\n.stojaki-page .status-card-pending { border-color: #f59e0b; }\n.stojaki-page .status-card-pending .status-card-value,\n.stojaki-page .status-card-pending .status-card-label { color: #f59e0b; }\n\n.stojaki-page .status-card-sent { border-color: #3b82f6; }\n.stojaki-page .status-card-sent .status-card-value,\n.stojaki-page .status-card-sent .status-card-label { color: #3b82f6; }\n\n.stojaki-page .status-card-failed { border-color: #ef4444; }\n.stojaki-page .status-card-failed .status-card-value,\n.stojaki-page .status-card-failed .status-card-label { color: #ef4444; }\n\n.stojaki-page .status-card-replied { border-color: #10b981; }\n.stojaki-page .status-card-replied .status-card-value,\n.stojaki-page .status-card-replied .status-card-label { color: #10b981; }\n\n.stojaki-page .status-card-check-replies {\n  border-color: #8b5cf6;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n.stojaki-page .status-card-check-replies .status-card-value,\n.stojaki-page .status-card-check-replies .status-card-label { color: #8b5cf6; }\n.stojaki-page .status-card-check-replies:hover:not(:disabled) {\n  background: #f5f3ff;\n  transform: translateY(-4px);\n  box-shadow: 0 6px 16px rgba(139, 92, 246, 0.2);\n}\n.stojaki-page .status-card-check-replies:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Tables */\n.stojaki-page .sessions-table,\n.stojaki-page .customers-table {\n  overflow-x: auto;\n  margin-top: 1rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background: white;\n}\n\n.stojaki-page table {\n  width: 100%;\n  min-width: 1100px;\n  border-collapse: collapse;\n  background: white;\n}\n\n.stojaki-page thead {\n  background: #f9fafb;\n}\n\n.stojaki-page th {\n  padding: 0.75rem 0.625rem;\n  text-align: left;\n  font-weight: 600;\n  color: #2d3748;\n  border-bottom: 2px solid #e5e7eb;\n  white-space: nowrap;\n  position: sticky;\n  top: 0;\n  background: #f9fafb;\n  z-index: 10;\n}\n\n.stojaki-page td {\n  padding: 0.625rem 0.625rem;\n  border-bottom: 1px solid #e5e7eb;\n  color: #4a5568;\n  vertical-align: middle;\n}\n\n.stojaki-page tr:hover {\n  background: #f9fafb;\n}\n\n.stojaki-page tr.selected {\n  background: #ede9fe;\n}\n\n/* Do Not Send styles */\n.stojaki-page tr.do-not-send-row {\n  background: #fef3c7 !important;\n  opacity: 0.7;\n}\n\n.stojaki-page tr.do-not-send-row:hover {\n  background: #fde68a !important;\n  opacity: 0.8;\n}\n\n.stojaki-page .do-not-send-badge {\n  display: inline-block;\n  padding: 0.25rem 0.5rem;\n  margin-left: 0.5rem;\n  background: #fbbf24;\n  color: #78350f;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n/* Status badges */\n.stojaki-page .status-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.stojaki-page .status-badge.imported,\n.stojaki-page .status-badge.created {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.stojaki-page .status-badge.generated {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.stojaki-page .status-badge.sent {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.stojaki-page .status-badge.failed {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.stojaki-page .status-badge.replied {\n  background: #e0e7ff;\n  color: #3730a3;\n}\n\n.stojaki-page .status-badge.confirmed_ready {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.stojaki-page .status-badge.scheduled_pickup {\n  background: #ddd6fe;\n  color: #5b21b6;\n}\n\n.stojaki-page .status-badge.completed {\n  background: #d1fae5;\n  color: #047857;\n}\n\n/* Email preview */\n.stojaki-page .email-preview-card {\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n.stojaki-page .email-preview-card h4 {\n  color: #2d3748;\n  margin-bottom: 0.75rem;\n}\n\n.stojaki-page .email-preview-card p {\n  margin: 0.5rem 0;\n  color: #4a5568;\n}\n\n.stojaki-page .email-preview-card details {\n  margin-top: 1rem;\n}\n\n.stojaki-page .email-preview-card summary {\n  cursor: pointer;\n  color: #667eea;\n  font-weight: 600;\n}\n\n/* Preview Toggle Button */\n.stojaki-page .preview-toggle-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  transition: all 0.3s ease;\n}\n\n.stojaki-page .arrow-icon {\n  display: inline-block;\n  transition: transform 0.3s ease;\n  font-size: 0.8rem;\n}\n\n.stojaki-page .arrow-icon.rotated {\n  transform: rotate(180deg);\n}\n\n/* Email Preview Accordion */\n.stojaki-page .email-previews-section {\n  animation: stojakiFadeIn 0.3s ease;\n}\n\n@keyframes stojakiFadeIn {\n  from { opacity: 0; transform: translateY(-10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.stojaki-page .email-preview-accordion {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  margin-bottom: 1rem;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.stojaki-page .email-preview-accordion:hover {\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  border-color: #d1d5db;\n}\n\n.stojaki-page .accordion-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.25rem 1.5rem;\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.2s ease;\n}\n\n.stojaki-page .accordion-header:hover {\n  background-color: #f9fafb;\n}\n\n.stojaki-page .accordion-title {\n  font-weight: 600;\n  color: #2d3748;\n  font-size: 1rem;\n}\n\n.stojaki-page .accordion-arrow {\n  display: inline-block;\n  transition: transform 0.3s ease;\n  font-size: 0.75rem;\n  color: #667eea;\n  font-weight: bold;\n}\n\n.stojaki-page .accordion-arrow.rotated {\n  transform: rotate(180deg);\n}\n\n.stojaki-page .accordion-content {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.4s ease, padding 0.4s ease;\n}\n\n.stojaki-page .accordion-content.open {\n  max-height: 1000px;\n  padding: 0 1.5rem 1.25rem 1.5rem;\n}\n\n.stojaki-page .accordion-content-inner {\n  padding-top: 0.75rem;\n  border-top: 1px solid #f3f4f6;\n  animation: stojakiFadeInContent 0.3s ease;\n}\n\n@keyframes stojakiFadeInContent {\n  from { opacity: 0; transform: translateY(-5px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.stojaki-page .accordion-content-inner p {\n  margin: 0.75rem 0;\n  color: #4a5568;\n  font-size: 0.95rem;\n}\n\n.stojaki-page .accordion-content-inner p strong {\n  color: #2d3748;\n  font-weight: 600;\n}\n\n.stojaki-page .email-body-details {\n  margin-top: 1.25rem;\n  padding-top: 1rem;\n  border-top: 1px solid #f3f4f6;\n}\n\n.stojaki-page .email-body-details summary {\n  cursor: pointer;\n  color: #667eea;\n  font-weight: 600;\n  padding: 0.5rem 0.75rem;\n  background: #f9fafb;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  display: inline-block;\n}\n\n.stojaki-page .email-body-details summary:hover {\n  background: #eef2ff;\n  color: #5a67d8;\n}\n\n.stojaki-page .email-body-content {\n  margin-top: 1rem;\n  padding: 1rem;\n  background: #f9fafb;\n  border-radius: 6px;\n  border: 1px solid #e5e7eb;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n/* Reset table styles inside email preview so they don't inherit page table styles */\n.stojaki-page .email-body-content table {\n  min-width: unset;\n  width: auto;\n  border-collapse: collapse;\n}\n\n.stojaki-page .email-body-content thead {\n  background: none;\n}\n\n.stojaki-page .email-body-content th {\n  padding: 10px;\n  position: static;\n  background: none;\n  white-space: normal;\n  border-bottom: none;\n  font-size: inherit;\n}\n\n.stojaki-page .email-body-content td {\n  padding: 8px;\n  border-bottom: none;\n  white-space: normal;\n  font-size: inherit;\n}\n\n.stojaki-page .email-body-content tr {\n  background: none;\n}\n\n.stojaki-page .email-body-content tr:hover {\n  background: none;\n}\n\n/* Form inputs */\n.stojaki-page .date-input-small {\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  width: 140px;\n  box-sizing: border-box;\n}\n\n.stojaki-page .date-input-small:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15);\n}\n\n.stojaki-page .note-input {\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  width: 200px;\n  min-width: 150px;\n  box-sizing: border-box;\n}\n\n.stojaki-page .note-input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15);\n  background: #ffffff;\n}\n\n.stojaki-page input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n/* Placeholder */\n.stojaki-page .placeholder-content {\n  text-align: center;\n  padding: 3rem;\n  color: #718096;\n  background: #f9fafb;\n  border-radius: 8px;\n  margin: 1rem 0;\n}\n\n.stojaki-page .placeholder-content p {\n  font-size: 1.1rem;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .stojaki-page .stojaki-tabs {\n    overflow-x: auto;\n  }\n\n  .stojaki-page .action-buttons {\n    flex-direction: column;\n  }\n\n  .stojaki-page .email-status-summary {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 0.75rem;\n  }\n\n  .stojaki-page .status-card {\n    padding: 1rem;\n  }\n\n  .stojaki-page .status-card-icon {\n    font-size: 2rem;\n  }\n\n  .stojaki-page .status-card-value {\n    font-size: 1.5rem;\n  }\n\n  .stojaki-page .status-card-label {\n    font-size: 0.75rem;\n  }\n\n  .stojaki-page table {\n    font-size: 0.85rem;\n  }\n\n  .stojaki-page th,\n  .stojaki-page td {\n    padding: 0.5rem;\n  }\n\n  .stojaki-page table {\n    min-width: 1000px;\n    font-size: 0.8rem;\n  }\n\n  .stojaki-page .note-input {\n    width: 150px;\n    font-size: 0.8rem;\n  }\n\n  .stojaki-page .date-input-small {\n    width: 120px;\n    font-size: 0.8rem;\n  }\n\n  .stojaki-page .btn-small {\n    padding: 0.3rem 0.6rem;\n    font-size: 0.75rem;\n  }\n}\n\n@media (max-width: 1024px) {\n  .stojaki-page .page-content {\n    padding: 1rem;\n  }\n\n  .stojaki-page .email-status-summary {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  .stojaki-page table {\n    min-width: 1000px;\n  }\n}\n\n/* Details Modal */\n.stojaki-page .modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.stojaki-page .modal-content {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.2);\n  max-width: 800px;\n  width: 90%;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: stojakiModalSlideIn 0.3s ease;\n  padding: 0;\n}\n\n.stojaki-page .modal-content-small {\n  max-width: 550px;\n}\n\n@keyframes stojakiModalSlideIn {\n  from { opacity: 0; transform: translateY(-50px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.stojaki-page .modal-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 1.5rem 2rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.stojaki-page .modal-header h3 {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: white;\n}\n\n.stojaki-page .modal-close {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  color: white;\n  font-size: 1.5rem;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n}\n\n.stojaki-page .modal-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.stojaki-page .modal-body {\n  padding: 2rem;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.stojaki-page .modal-footer {\n  padding: 1.25rem 2rem;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  background: #f9fafb;\n}\n\n.stojaki-page .detail-section {\n  margin-bottom: 2rem;\n  padding-bottom: 1.5rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.stojaki-page .detail-section:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n}\n\n.stojaki-page .detail-section h4 {\n  color: #2d3748;\n  font-size: 1.1rem;\n  margin-bottom: 1rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.stojaki-page .detail-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1rem;\n}\n\n.stojaki-page .detail-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.stojaki-page .detail-label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.stojaki-page .detail-value {\n  font-size: 1rem;\n  color: #2d3748;\n  font-weight: 500;\n}\n\n.stojaki-page .reply-message {\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-top: 0.5rem;\n  color: #2d3748;\n  line-height: 1.6;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.stojaki-page .attachment-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n}\n\n.stojaki-page .attachment-item {\n  background: #f3f4f6;\n  padding: 0.75rem 1rem;\n  border-radius: 6px;\n  font-size: 0.95rem;\n  color: #2d3748;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.stojaki-page .attachment-type {\n  color: #6b7280;\n  font-size: 0.85rem;\n}\n\n.stojaki-page .email-body-preview {\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-top: 0.5rem;\n  max-height: 200px;\n  overflow-y: auto;\n  font-size: 0.9rem;\n  color: #4a5568;\n}\n\n.stojaki-page .no-reply-message {\n  text-align: center;\n  padding: 2rem;\n  color: #6b7280;\n  font-size: 1.1rem;\n}\n\n/* Note Cell (Clickable) */\n.stojaki-page .note-cell {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  min-height: 32px;\n  cursor: pointer;\n  border-radius: 6px;\n  border: 2px solid transparent;\n  transition: all 0.2s ease;\n  background: #f9fafb;\n  min-width: 120px;\n  max-width: 200px;\n}\n\n.stojaki-page .note-cell:hover {\n  background: #eef2ff;\n  border-color: #667eea;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.1);\n}\n\n.stojaki-page .note-cell:active {\n  transform: translateY(0);\n}\n\n.stojaki-page .note-text {\n  flex: 1;\n  color: #2d3748;\n  font-size: 0.875rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.stojaki-page .note-placeholder {\n  flex: 1;\n  color: #9ca3af;\n  font-size: 0.875rem;\n  font-style: italic;\n}\n\n.stojaki-page .note-edit-icon {\n  font-size: 14px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.stojaki-page .note-cell:hover .note-edit-icon {\n  opacity: 1;\n}\n\n/* Customers table improvements */\n.stojaki-page .customers-table {\n  -webkit-overflow-scrolling: touch;\n}\n\n.stojaki-page .customers-table::-webkit-scrollbar {\n  height: 8px;\n}\n\n.stojaki-page .customers-table::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.stojaki-page .customers-table::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.stojaki-page .customers-table::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.stojaki-page .customers-table td,\n.stojaki-page .customers-table th {\n  white-space: nowrap;\n}\n\n.stojaki-page .customers-table td:first-child,\n.stojaki-page .customers-table td:nth-child(2) {\n  white-space: normal;\n  min-width: 120px;\n}\n\n.stojaki-page .customers-table td:nth-child(10),\n.stojaki-page .customers-table td:nth-child(9) {\n  white-space: normal;\n  min-width: 160px;\n}\n\n.stojaki-page .customers-table input[type=\"text\"],\n.stojaki-page .customers-table input[type=\"date\"],\n.stojaki-page .customers-table input[type=\"checkbox\"] {\n  box-sizing: border-box;\n  pointer-events: auto;\n}\n\n.stojaki-page .customers-table td:last-child {\n  white-space: nowrap;\n}\n\n.stojaki-page .customers-table tbody tr:hover {\n  background: #f0f4ff;\n  transition: background-color 0.2s ease;\n}\n\n.stojaki-page .customers-table .status-badge {\n  white-space: nowrap;\n  display: inline-block;\n}\n\n.stojaki-page .customers-table td:last-child button {\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
